(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("LayoutDesigner", [], factory);
	else if(typeof exports === 'object')
		exports["LayoutDesigner"] = factory();
	else
		root["LayoutDesigner"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(331);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(2);
	
	__webpack_require__(327);
	
	__webpack_require__(328);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(3);
	__webpack_require__(51);
	__webpack_require__(52);
	__webpack_require__(53);
	__webpack_require__(54);
	__webpack_require__(56);
	__webpack_require__(59);
	__webpack_require__(60);
	__webpack_require__(61);
	__webpack_require__(62);
	__webpack_require__(63);
	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(66);
	__webpack_require__(67);
	__webpack_require__(69);
	__webpack_require__(71);
	__webpack_require__(73);
	__webpack_require__(75);
	__webpack_require__(78);
	__webpack_require__(79);
	__webpack_require__(80);
	__webpack_require__(84);
	__webpack_require__(86);
	__webpack_require__(88);
	__webpack_require__(91);
	__webpack_require__(92);
	__webpack_require__(93);
	__webpack_require__(94);
	__webpack_require__(96);
	__webpack_require__(97);
	__webpack_require__(98);
	__webpack_require__(99);
	__webpack_require__(100);
	__webpack_require__(101);
	__webpack_require__(102);
	__webpack_require__(104);
	__webpack_require__(105);
	__webpack_require__(106);
	__webpack_require__(108);
	__webpack_require__(109);
	__webpack_require__(110);
	__webpack_require__(112);
	__webpack_require__(114);
	__webpack_require__(115);
	__webpack_require__(116);
	__webpack_require__(117);
	__webpack_require__(118);
	__webpack_require__(119);
	__webpack_require__(120);
	__webpack_require__(121);
	__webpack_require__(122);
	__webpack_require__(123);
	__webpack_require__(124);
	__webpack_require__(125);
	__webpack_require__(126);
	__webpack_require__(131);
	__webpack_require__(132);
	__webpack_require__(136);
	__webpack_require__(137);
	__webpack_require__(138);
	__webpack_require__(139);
	__webpack_require__(141);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(147);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(150);
	__webpack_require__(151);
	__webpack_require__(152);
	__webpack_require__(153);
	__webpack_require__(154);
	__webpack_require__(155);
	__webpack_require__(157);
	__webpack_require__(158);
	__webpack_require__(160);
	__webpack_require__(161);
	__webpack_require__(167);
	__webpack_require__(168);
	__webpack_require__(170);
	__webpack_require__(171);
	__webpack_require__(172);
	__webpack_require__(176);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(182);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(185);
	__webpack_require__(188);
	__webpack_require__(190);
	__webpack_require__(191);
	__webpack_require__(192);
	__webpack_require__(194);
	__webpack_require__(196);
	__webpack_require__(198);
	__webpack_require__(200);
	__webpack_require__(201);
	__webpack_require__(202);
	__webpack_require__(206);
	__webpack_require__(207);
	__webpack_require__(208);
	__webpack_require__(210);
	__webpack_require__(220);
	__webpack_require__(224);
	__webpack_require__(225);
	__webpack_require__(227);
	__webpack_require__(228);
	__webpack_require__(232);
	__webpack_require__(233);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(237);
	__webpack_require__(238);
	__webpack_require__(239);
	__webpack_require__(240);
	__webpack_require__(241);
	__webpack_require__(242);
	__webpack_require__(243);
	__webpack_require__(244);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(250);
	__webpack_require__(251);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(255);
	__webpack_require__(256);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(261);
	__webpack_require__(262);
	__webpack_require__(263);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(267);
	__webpack_require__(268);
	__webpack_require__(269);
	__webpack_require__(270);
	__webpack_require__(271);
	__webpack_require__(272);
	__webpack_require__(274);
	__webpack_require__(275);
	__webpack_require__(277);
	__webpack_require__(278);
	__webpack_require__(279);
	__webpack_require__(280);
	__webpack_require__(283);
	__webpack_require__(284);
	__webpack_require__(286);
	__webpack_require__(287);
	__webpack_require__(288);
	__webpack_require__(289);
	__webpack_require__(291);
	__webpack_require__(292);
	__webpack_require__(293);
	__webpack_require__(294);
	__webpack_require__(295);
	__webpack_require__(296);
	__webpack_require__(297);
	__webpack_require__(298);
	__webpack_require__(299);
	__webpack_require__(300);
	__webpack_require__(302);
	__webpack_require__(303);
	__webpack_require__(304);
	__webpack_require__(305);
	__webpack_require__(306);
	__webpack_require__(307);
	__webpack_require__(308);
	__webpack_require__(309);
	__webpack_require__(310);
	__webpack_require__(311);
	__webpack_require__(312);
	__webpack_require__(314);
	__webpack_require__(315);
	__webpack_require__(316);
	__webpack_require__(317);
	__webpack_require__(318);
	__webpack_require__(319);
	__webpack_require__(320);
	__webpack_require__(321);
	__webpack_require__(322);
	__webpack_require__(323);
	__webpack_require__(324);
	__webpack_require__(325);
	__webpack_require__(326);
	module.exports = __webpack_require__(9);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(4);
	var has = __webpack_require__(5);
	var DESCRIPTORS = __webpack_require__(6);
	var $export = __webpack_require__(8);
	var redefine = __webpack_require__(18);
	var META = __webpack_require__(22).KEY;
	var $fails = __webpack_require__(7);
	var shared = __webpack_require__(23);
	var setToStringTag = __webpack_require__(25);
	var uid = __webpack_require__(19);
	var wks = __webpack_require__(26);
	var wksExt = __webpack_require__(27);
	var wksDefine = __webpack_require__(28);
	var enumKeys = __webpack_require__(29);
	var isArray = __webpack_require__(44);
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	var toIObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(16);
	var createDesc = __webpack_require__(17);
	var _create = __webpack_require__(45);
	var gOPNExt = __webpack_require__(48);
	var $GOPD = __webpack_require__(50);
	var $DP = __webpack_require__(11);
	var $keys = __webpack_require__(30);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(49).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(43).f = $propertyIsEnumerable;
	  __webpack_require__(42).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(24)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(10)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(7)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var core = __webpack_require__(9);
	var hide = __webpack_require__(10);
	var redefine = __webpack_require__(18);
	var ctx = __webpack_require__(20);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(11);
	var createDesc = __webpack_require__(17);
	module.exports = __webpack_require__(6) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(12);
	var IE8_DOM_DEFINE = __webpack_require__(14);
	var toPrimitive = __webpack_require__(16);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(6) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(6) && !__webpack_require__(7)(function () {
	  return Object.defineProperty(__webpack_require__(15)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var document = __webpack_require__(4).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(13);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var hide = __webpack_require__(10);
	var has = __webpack_require__(5);
	var SRC = __webpack_require__(19)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(9).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(21);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(19)('meta');
	var isObject = __webpack_require__(13);
	var has = __webpack_require__(5);
	var setDesc = __webpack_require__(11).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(7)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(9);
	var global = __webpack_require__(4);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(24) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(11).f;
	var has = __webpack_require__(5);
	var TAG = __webpack_require__(26)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(23)('wks');
	var uid = __webpack_require__(19);
	var Symbol = __webpack_require__(4).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(26);


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var core = __webpack_require__(9);
	var LIBRARY = __webpack_require__(24);
	var wksExt = __webpack_require__(27);
	var defineProperty = __webpack_require__(11).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(30);
	var gOPS = __webpack_require__(42);
	var pIE = __webpack_require__(43);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(31);
	var enumBugKeys = __webpack_require__(41);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(5);
	var toIObject = __webpack_require__(32);
	var arrayIndexOf = __webpack_require__(36)(false);
	var IE_PROTO = __webpack_require__(40)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(33);
	var defined = __webpack_require__(35);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(34);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(32);
	var toLength = __webpack_require__(37);
	var toAbsoluteIndex = __webpack_require__(39);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(38);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(38);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(23)('keys');
	var uid = __webpack_require__(19);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(34);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(12);
	var dPs = __webpack_require__(46);
	var enumBugKeys = __webpack_require__(41);
	var IE_PROTO = __webpack_require__(40)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(15)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(47).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(11);
	var anObject = __webpack_require__(12);
	var getKeys = __webpack_require__(30);
	
	module.exports = __webpack_require__(6) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(4).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(32);
	var gOPN = __webpack_require__(49).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(31);
	var hiddenKeys = __webpack_require__(41).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(43);
	var createDesc = __webpack_require__(17);
	var toIObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(16);
	var has = __webpack_require__(5);
	var IE8_DOM_DEFINE = __webpack_require__(14);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(6) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(45) });


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(6), 'Object', { defineProperty: __webpack_require__(11).f });


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(6), 'Object', { defineProperties: __webpack_require__(46) });


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(32);
	var $getOwnPropertyDescriptor = __webpack_require__(50).f;
	
	__webpack_require__(55)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(8);
	var core = __webpack_require__(9);
	var fails = __webpack_require__(7);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(57);
	var $getPrototypeOf = __webpack_require__(58);
	
	__webpack_require__(55)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(35);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(5);
	var toObject = __webpack_require__(57);
	var IE_PROTO = __webpack_require__(40)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(57);
	var $keys = __webpack_require__(30);
	
	__webpack_require__(55)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(55)('getOwnPropertyNames', function () {
	  return __webpack_require__(48).f;
	});


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(13);
	var meta = __webpack_require__(22).onFreeze;
	
	__webpack_require__(55)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(13);
	var meta = __webpack_require__(22).onFreeze;
	
	__webpack_require__(55)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(13);
	var meta = __webpack_require__(22).onFreeze;
	
	__webpack_require__(55)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(55)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(55)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(55)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(8);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(68) });


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(30);
	var gOPS = __webpack_require__(42);
	var pIE = __webpack_require__(43);
	var toObject = __webpack_require__(57);
	var IObject = __webpack_require__(33);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(7)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', { is: __webpack_require__(70) });


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(72).set });


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(13);
	var anObject = __webpack_require__(12);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(20)(Function.call, __webpack_require__(50).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(74);
	var test = {};
	test[__webpack_require__(26)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(18)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(34);
	var TAG = __webpack_require__(26)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Function', { bind: __webpack_require__(76) });


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(21);
	var isObject = __webpack_require__(13);
	var invoke = __webpack_require__(77);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(11).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(6) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(13);
	var getPrototypeOf = __webpack_require__(58);
	var HAS_INSTANCE = __webpack_require__(26)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(11).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseInt = __webpack_require__(81);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(4).parseInt;
	var $trim = __webpack_require__(82).trim;
	var ws = __webpack_require__(83);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var defined = __webpack_require__(35);
	var fails = __webpack_require__(7);
	var spaces = __webpack_require__(83);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseFloat = __webpack_require__(85);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(4).parseFloat;
	var $trim = __webpack_require__(82).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(83) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var has = __webpack_require__(5);
	var cof = __webpack_require__(34);
	var inheritIfRequired = __webpack_require__(87);
	var toPrimitive = __webpack_require__(16);
	var fails = __webpack_require__(7);
	var gOPN = __webpack_require__(49).f;
	var gOPD = __webpack_require__(50).f;
	var dP = __webpack_require__(11).f;
	var $trim = __webpack_require__(82).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(45)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(6) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(18)(global, NUMBER, $Number);
	}


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var setPrototypeOf = __webpack_require__(72).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toInteger = __webpack_require__(38);
	var aNumberValue = __webpack_require__(89);
	var repeat = __webpack_require__(90);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(7)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(34);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(38);
	var defined = __webpack_require__(35);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $fails = __webpack_require__(7);
	var aNumberValue = __webpack_require__(89);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(8);
	var _isFinite = __webpack_require__(4).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(95) });


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(13);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(8);
	var isInteger = __webpack_require__(95);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseFloat = __webpack_require__(85);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseInt = __webpack_require__(81);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(8);
	var log1p = __webpack_require__(103);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(8);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(8);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(8);
	var sign = __webpack_require__(107);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(8);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(8);
	var $expm1 = __webpack_require__(111);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 111 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { fround: __webpack_require__(113) });


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(107);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(8);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(8);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(103) });


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { sign: __webpack_require__(107) });


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(8);
	var expm1 = __webpack_require__(111);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(8);
	var expm1 = __webpack_require__(111);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var toAbsoluteIndex = __webpack_require__(39);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(32);
	var toLength = __webpack_require__(37);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(82)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(127)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(128)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(38);
	var defined = __webpack_require__(35);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(24);
	var $export = __webpack_require__(8);
	var redefine = __webpack_require__(18);
	var hide = __webpack_require__(10);
	var Iterators = __webpack_require__(129);
	var $iterCreate = __webpack_require__(130);
	var setToStringTag = __webpack_require__(25);
	var getPrototypeOf = __webpack_require__(58);
	var ITERATOR = __webpack_require__(26)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 129 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(45);
	var descriptor = __webpack_require__(17);
	var setToStringTag = __webpack_require__(25);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(10)(IteratorPrototype, __webpack_require__(26)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $at = __webpack_require__(127)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(8);
	var toLength = __webpack_require__(37);
	var context = __webpack_require__(133);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(135)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(134);
	var defined = __webpack_require__(35);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(13);
	var cof = __webpack_require__(34);
	var MATCH = __webpack_require__(26)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(26)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(8);
	var context = __webpack_require__(133);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(135)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(90)
	});


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(8);
	var toLength = __webpack_require__(37);
	var context = __webpack_require__(133);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(135)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(140)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var fails = __webpack_require__(7);
	var defined = __webpack_require__(35);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(140)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(140)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(140)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(140)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(140)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(140)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(140)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(140)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(140)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(140)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(140)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(140)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(57);
	var toPrimitive = __webpack_require__(16);
	
	$export($export.P + $export.F * __webpack_require__(7)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(8);
	var toISOString = __webpack_require__(156);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(7);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(18)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(26)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(10)(proto, TO_PRIMITIVE, __webpack_require__(159));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(12);
	var toPrimitive = __webpack_require__(16);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(44) });


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(20);
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(57);
	var call = __webpack_require__(162);
	var isArrayIter = __webpack_require__(163);
	var toLength = __webpack_require__(37);
	var createProperty = __webpack_require__(164);
	var getIterFn = __webpack_require__(165);
	
	$export($export.S + $export.F * !__webpack_require__(166)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(12);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(129);
	var ITERATOR = __webpack_require__(26)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(11);
	var createDesc = __webpack_require__(17);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(74);
	var ITERATOR = __webpack_require__(26)('iterator');
	var Iterators = __webpack_require__(129);
	module.exports = __webpack_require__(9).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(26)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var createProperty = __webpack_require__(164);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(32);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(33) != Object || !__webpack_require__(169)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var html = __webpack_require__(47);
	var cof = __webpack_require__(34);
	var toAbsoluteIndex = __webpack_require__(39);
	var toLength = __webpack_require__(37);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(7)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(21);
	var toObject = __webpack_require__(57);
	var fails = __webpack_require__(7);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(169)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $forEach = __webpack_require__(173)(0);
	var STRICT = __webpack_require__(169)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(20);
	var IObject = __webpack_require__(33);
	var toObject = __webpack_require__(57);
	var toLength = __webpack_require__(37);
	var asc = __webpack_require__(174);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(175);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var isArray = __webpack_require__(44);
	var SPECIES = __webpack_require__(26)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $map = __webpack_require__(173)(1);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $filter = __webpack_require__(173)(2);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $some = __webpack_require__(173)(3);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $every = __webpack_require__(173)(4);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $reduce = __webpack_require__(181);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(21);
	var toObject = __webpack_require__(57);
	var IObject = __webpack_require__(33);
	var toLength = __webpack_require__(37);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $reduce = __webpack_require__(181);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $indexOf = __webpack_require__(36)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(169)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(32);
	var toInteger = __webpack_require__(38);
	var toLength = __webpack_require__(37);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(169)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(186) });
	
	__webpack_require__(187)('copyWithin');


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(57);
	var toAbsoluteIndex = __webpack_require__(39);
	var toLength = __webpack_require__(37);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(26)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(10)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', { fill: __webpack_require__(189) });
	
	__webpack_require__(187)('fill');


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(57);
	var toAbsoluteIndex = __webpack_require__(39);
	var toLength = __webpack_require__(37);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(8);
	var $find = __webpack_require__(173)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(187)(KEY);


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(8);
	var $find = __webpack_require__(173)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(187)(KEY);


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(193)('Array');


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var dP = __webpack_require__(11);
	var DESCRIPTORS = __webpack_require__(6);
	var SPECIES = __webpack_require__(26)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(187);
	var step = __webpack_require__(195);
	var Iterators = __webpack_require__(129);
	var toIObject = __webpack_require__(32);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(128)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 195 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var inheritIfRequired = __webpack_require__(87);
	var dP = __webpack_require__(11).f;
	var gOPN = __webpack_require__(49).f;
	var isRegExp = __webpack_require__(134);
	var $flags = __webpack_require__(197);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(6) && (!CORRECT_NEW || __webpack_require__(7)(function () {
	  re2[__webpack_require__(26)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(18)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(193)('RegExp');


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(12);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(199);
	__webpack_require__(8)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(197);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(201);
	var anObject = __webpack_require__(12);
	var $flags = __webpack_require__(197);
	var DESCRIPTORS = __webpack_require__(6);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(18)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(7)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(6) && /./g.flags != 'g') __webpack_require__(11).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(197)
	});


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(12);
	var toLength = __webpack_require__(37);
	var advanceStringIndex = __webpack_require__(203);
	var regExpExec = __webpack_require__(204);
	
	// @@match logic
	__webpack_require__(205)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(127)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(74);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(198);
	var redefine = __webpack_require__(18);
	var hide = __webpack_require__(10);
	var fails = __webpack_require__(7);
	var defined = __webpack_require__(35);
	var wks = __webpack_require__(26);
	var regexpExec = __webpack_require__(199);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(12);
	var toObject = __webpack_require__(57);
	var toLength = __webpack_require__(37);
	var toInteger = __webpack_require__(38);
	var advanceStringIndex = __webpack_require__(203);
	var regExpExec = __webpack_require__(204);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(205)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(12);
	var sameValue = __webpack_require__(70);
	var regExpExec = __webpack_require__(204);
	
	// @@search logic
	__webpack_require__(205)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(134);
	var anObject = __webpack_require__(12);
	var speciesConstructor = __webpack_require__(209);
	var advanceStringIndex = __webpack_require__(203);
	var toLength = __webpack_require__(37);
	var callRegExpExec = __webpack_require__(204);
	var regexpExec = __webpack_require__(199);
	var fails = __webpack_require__(7);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(205)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(12);
	var aFunction = __webpack_require__(21);
	var SPECIES = __webpack_require__(26)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(24);
	var global = __webpack_require__(4);
	var ctx = __webpack_require__(20);
	var classof = __webpack_require__(74);
	var $export = __webpack_require__(8);
	var isObject = __webpack_require__(13);
	var aFunction = __webpack_require__(21);
	var anInstance = __webpack_require__(211);
	var forOf = __webpack_require__(212);
	var speciesConstructor = __webpack_require__(209);
	var task = __webpack_require__(213).set;
	var microtask = __webpack_require__(214)();
	var newPromiseCapabilityModule = __webpack_require__(215);
	var perform = __webpack_require__(216);
	var userAgent = __webpack_require__(217);
	var promiseResolve = __webpack_require__(218);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(26)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(219)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(25)($Promise, PROMISE);
	__webpack_require__(193)(PROMISE);
	Wrapper = __webpack_require__(9)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(166)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 211 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(20);
	var call = __webpack_require__(162);
	var isArrayIter = __webpack_require__(163);
	var anObject = __webpack_require__(12);
	var toLength = __webpack_require__(37);
	var getIterFn = __webpack_require__(165);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(20);
	var invoke = __webpack_require__(77);
	var html = __webpack_require__(47);
	var cel = __webpack_require__(15);
	var global = __webpack_require__(4);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(34)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var macrotask = __webpack_require__(213).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(34)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(21);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 216 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	var newPromiseCapability = __webpack_require__(215);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(18);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(221);
	var validate = __webpack_require__(222);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(223)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(11).f;
	var create = __webpack_require__(45);
	var redefineAll = __webpack_require__(219);
	var ctx = __webpack_require__(20);
	var anInstance = __webpack_require__(211);
	var forOf = __webpack_require__(212);
	var $iterDefine = __webpack_require__(128);
	var step = __webpack_require__(195);
	var setSpecies = __webpack_require__(193);
	var DESCRIPTORS = __webpack_require__(6);
	var fastKey = __webpack_require__(22).fastKey;
	var validate = __webpack_require__(222);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var $export = __webpack_require__(8);
	var redefine = __webpack_require__(18);
	var redefineAll = __webpack_require__(219);
	var meta = __webpack_require__(22);
	var forOf = __webpack_require__(212);
	var anInstance = __webpack_require__(211);
	var isObject = __webpack_require__(13);
	var fails = __webpack_require__(7);
	var $iterDetect = __webpack_require__(166);
	var setToStringTag = __webpack_require__(25);
	var inheritIfRequired = __webpack_require__(87);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(221);
	var validate = __webpack_require__(222);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(223)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(173)(0);
	var redefine = __webpack_require__(18);
	var meta = __webpack_require__(22);
	var assign = __webpack_require__(68);
	var weak = __webpack_require__(226);
	var isObject = __webpack_require__(13);
	var fails = __webpack_require__(7);
	var validate = __webpack_require__(222);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(223)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(219);
	var getWeak = __webpack_require__(22).getWeak;
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	var anInstance = __webpack_require__(211);
	var forOf = __webpack_require__(212);
	var createArrayMethod = __webpack_require__(173);
	var $has = __webpack_require__(5);
	var validate = __webpack_require__(222);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(226);
	var validate = __webpack_require__(222);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(223)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $typed = __webpack_require__(229);
	var buffer = __webpack_require__(230);
	var anObject = __webpack_require__(12);
	var toAbsoluteIndex = __webpack_require__(39);
	var toLength = __webpack_require__(37);
	var isObject = __webpack_require__(13);
	var ArrayBuffer = __webpack_require__(4).ArrayBuffer;
	var speciesConstructor = __webpack_require__(209);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(7)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(193)(ARRAY_BUFFER);


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var hide = __webpack_require__(10);
	var uid = __webpack_require__(19);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(6);
	var LIBRARY = __webpack_require__(24);
	var $typed = __webpack_require__(229);
	var hide = __webpack_require__(10);
	var redefineAll = __webpack_require__(219);
	var fails = __webpack_require__(7);
	var anInstance = __webpack_require__(211);
	var toInteger = __webpack_require__(38);
	var toLength = __webpack_require__(37);
	var toIndex = __webpack_require__(231);
	var gOPN = __webpack_require__(49).f;
	var dP = __webpack_require__(11).f;
	var arrayFill = __webpack_require__(189);
	var setToStringTag = __webpack_require__(25);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(38);
	var toLength = __webpack_require__(37);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	$export($export.G + $export.W + $export.F * !__webpack_require__(229).ABV, {
	  DataView: __webpack_require__(230).DataView
	});


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(234)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(6)) {
	  var LIBRARY = __webpack_require__(24);
	  var global = __webpack_require__(4);
	  var fails = __webpack_require__(7);
	  var $export = __webpack_require__(8);
	  var $typed = __webpack_require__(229);
	  var $buffer = __webpack_require__(230);
	  var ctx = __webpack_require__(20);
	  var anInstance = __webpack_require__(211);
	  var propertyDesc = __webpack_require__(17);
	  var hide = __webpack_require__(10);
	  var redefineAll = __webpack_require__(219);
	  var toInteger = __webpack_require__(38);
	  var toLength = __webpack_require__(37);
	  var toIndex = __webpack_require__(231);
	  var toAbsoluteIndex = __webpack_require__(39);
	  var toPrimitive = __webpack_require__(16);
	  var has = __webpack_require__(5);
	  var classof = __webpack_require__(74);
	  var isObject = __webpack_require__(13);
	  var toObject = __webpack_require__(57);
	  var isArrayIter = __webpack_require__(163);
	  var create = __webpack_require__(45);
	  var getPrototypeOf = __webpack_require__(58);
	  var gOPN = __webpack_require__(49).f;
	  var getIterFn = __webpack_require__(165);
	  var uid = __webpack_require__(19);
	  var wks = __webpack_require__(26);
	  var createArrayMethod = __webpack_require__(173);
	  var createArrayIncludes = __webpack_require__(36);
	  var speciesConstructor = __webpack_require__(209);
	  var ArrayIterators = __webpack_require__(194);
	  var Iterators = __webpack_require__(129);
	  var $iterDetect = __webpack_require__(166);
	  var setSpecies = __webpack_require__(193);
	  var arrayFill = __webpack_require__(189);
	  var arrayCopyWithin = __webpack_require__(186);
	  var $DP = __webpack_require__(11);
	  var $GOPD = __webpack_require__(50);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(234)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(234)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(234)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(234)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(234)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(234)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(234)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(234)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(21);
	var anObject = __webpack_require__(12);
	var rApply = (__webpack_require__(4).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(7)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(8);
	var create = __webpack_require__(45);
	var aFunction = __webpack_require__(21);
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	var fails = __webpack_require__(7);
	var bind = __webpack_require__(76);
	var rConstruct = (__webpack_require__(4).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(11);
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var toPrimitive = __webpack_require__(16);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(8);
	var gOPD = __webpack_require__(50).f;
	var anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(130)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(50);
	var getPrototypeOf = __webpack_require__(58);
	var has = __webpack_require__(5);
	var $export = __webpack_require__(8);
	var isObject = __webpack_require__(13);
	var anObject = __webpack_require__(12);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(50);
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(8);
	var getProto = __webpack_require__(58);
	var anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(254) });


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(49);
	var gOPS = __webpack_require__(42);
	var anObject = __webpack_require__(12);
	var Reflect = __webpack_require__(4).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(11);
	var gOPD = __webpack_require__(50);
	var getPrototypeOf = __webpack_require__(58);
	var has = __webpack_require__(5);
	var $export = __webpack_require__(8);
	var createDesc = __webpack_require__(17);
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(8);
	var setProto = __webpack_require__(72);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(8);
	var $includes = __webpack_require__(36)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(187)('includes');


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(8);
	var flattenIntoArray = __webpack_require__(260);
	var toObject = __webpack_require__(57);
	var toLength = __webpack_require__(37);
	var aFunction = __webpack_require__(21);
	var arraySpeciesCreate = __webpack_require__(174);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(187)('flatMap');


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(44);
	var isObject = __webpack_require__(13);
	var toLength = __webpack_require__(37);
	var ctx = __webpack_require__(20);
	var IS_CONCAT_SPREADABLE = __webpack_require__(26)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(8);
	var flattenIntoArray = __webpack_require__(260);
	var toObject = __webpack_require__(57);
	var toLength = __webpack_require__(37);
	var toInteger = __webpack_require__(38);
	var arraySpeciesCreate = __webpack_require__(174);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(187)('flatten');


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(8);
	var $at = __webpack_require__(127)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8);
	var $pad = __webpack_require__(264);
	var userAgent = __webpack_require__(217);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(37);
	var repeat = __webpack_require__(90);
	var defined = __webpack_require__(35);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8);
	var $pad = __webpack_require__(264);
	var userAgent = __webpack_require__(217);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(82)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(82)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(8);
	var defined = __webpack_require__(35);
	var toLength = __webpack_require__(37);
	var isRegExp = __webpack_require__(134);
	var getFlags = __webpack_require__(197);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(130)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28)('asyncIterator');


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28)('observable');


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(8);
	var ownKeys = __webpack_require__(254);
	var toIObject = __webpack_require__(32);
	var gOPD = __webpack_require__(50);
	var createProperty = __webpack_require__(164);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(8);
	var $values = __webpack_require__(273)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(30);
	var toIObject = __webpack_require__(32);
	var isEnum = __webpack_require__(43).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(8);
	var $entries = __webpack_require__(273)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(57);
	var aFunction = __webpack_require__(21);
	var $defineProperty = __webpack_require__(11);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(6) && $export($export.P + __webpack_require__(276), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(24) || !__webpack_require__(7)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(4)[K];
	});


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(57);
	var aFunction = __webpack_require__(21);
	var $defineProperty = __webpack_require__(11);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(6) && $export($export.P + __webpack_require__(276), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(57);
	var toPrimitive = __webpack_require__(16);
	var getPrototypeOf = __webpack_require__(58);
	var getOwnPropertyDescriptor = __webpack_require__(50).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(6) && $export($export.P + __webpack_require__(276), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(57);
	var toPrimitive = __webpack_require__(16);
	var getPrototypeOf = __webpack_require__(58);
	var getOwnPropertyDescriptor = __webpack_require__(50).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(6) && $export($export.P + __webpack_require__(276), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(8);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(281)('Map') });


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(74);
	var from = __webpack_require__(282);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(212);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(8);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(281)('Set') });


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(285)('Map');


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(8);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(285)('Set');


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(285)('WeakMap');


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(285)('WeakSet');


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(290)('Map');


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(21);
	var ctx = __webpack_require__(20);
	var forOf = __webpack_require__(212);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(290)('Set');


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(290)('WeakMap');


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(290)('WeakSet');


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(8);
	
	$export($export.G, { global: __webpack_require__(4) });


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(8);
	
	$export($export.S, 'System', { global: __webpack_require__(4) });


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(8);
	var cof = __webpack_require__(34);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var scale = __webpack_require__(301);
	var fround = __webpack_require__(113);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 301 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { scale: __webpack_require__(301) });


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(8);
	var core = __webpack_require__(9);
	var global = __webpack_require__(4);
	var speciesConstructor = __webpack_require__(209);
	var promiseResolve = __webpack_require__(218);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(8);
	var newPromiseCapability = __webpack_require__(215);
	var perform = __webpack_require__(216);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(313);
	var anObject = __webpack_require__(12);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(220);
	var $export = __webpack_require__(8);
	var shared = __webpack_require__(23)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(225))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(313);
	var anObject = __webpack_require__(12);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(313);
	var anObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(58);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(224);
	var from = __webpack_require__(282);
	var metadata = __webpack_require__(313);
	var anObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(58);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(313);
	var anObject = __webpack_require__(12);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(313);
	var anObject = __webpack_require__(12);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(313);
	var anObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(58);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(313);
	var anObject = __webpack_require__(12);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(313);
	var anObject = __webpack_require__(12);
	var aFunction = __webpack_require__(21);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(8);
	var microtask = __webpack_require__(214)();
	var process = __webpack_require__(4).process;
	var isNode = __webpack_require__(34)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(8);
	var global = __webpack_require__(4);
	var core = __webpack_require__(9);
	var microtask = __webpack_require__(214)();
	var OBSERVABLE = __webpack_require__(26)('observable');
	var aFunction = __webpack_require__(21);
	var anObject = __webpack_require__(12);
	var anInstance = __webpack_require__(211);
	var redefineAll = __webpack_require__(219);
	var hide = __webpack_require__(10);
	var forOf = __webpack_require__(212);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(193)('Observable');


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(4);
	var $export = __webpack_require__(8);
	var userAgent = __webpack_require__(217);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $task = __webpack_require__(213);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(194);
	var getKeys = __webpack_require__(30);
	var redefine = __webpack_require__(18);
	var global = __webpack_require__(4);
	var hide = __webpack_require__(10);
	var Iterators = __webpack_require__(129);
	var wks = __webpack_require__(26);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 327 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(329);
	module.exports = __webpack_require__(9).RegExp.escape;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(8);
	var $re = __webpack_require__(330)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 330 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _designPlacerTpl = __webpack_require__(332);
	
	var _designPlacerTpl2 = _interopRequireDefault(_designPlacerTpl);
	
	var _placingEditor = __webpack_require__(333);
	
	var _placingEditor2 = _interopRequireDefault(_placingEditor);
	
	var _eventEmitter = __webpack_require__(520);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _customLodash = __webpack_require__(352);
	
	var _customLodash2 = _interopRequireDefault(_customLodash);
	
	__webpack_require__(530);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var designPlacer = function designPlacer() {
	    return {
	        templateUrl: _designPlacerTpl2.default,
	        restrict: 'EA',
	        replace: true,
	        scope: {
	            config: '=',
	            init: '&'
	        },
	        bindToController: true,
	        controller: 'DesignPlacerController',
	        controllerAs: 'vm'
	    };
	};
	
	var DesignPlacerController = function () {
	    function DesignPlacerController() {
	        'ngInject';
	
	        _classCallCheck(this, DesignPlacerController);
	
	        this.events = new _eventEmitter2.default();
	        this.editorSize = this.config.editorSize;
	        this.colour = this.config.colour;
	        this.editable = this.config.editable !== false;
	        this.viewpoints = [];
	        this.currentViewpoint = null;
	        this.navDisabled = false;
	        this.editorContainer = angular.element(document.getElementById('editors'));
	        this.viewpointSelectors = angular.element(document.getElementById('viewpoint-selectors'));
	        this.init({ controller: this });
	    }
	
	    DesignPlacerController.prototype.addViewpoint = function addViewpoint(options) {
	        var _this = this;
	
	        var viewpoint = _customLodash2.default.extend({}, options);
	        var container = this.createViewpointContainer(viewpoint.name);
	        this.editorContainer.append(container);
	        var selector = this.createViewpointSelector(viewpoint.name);
	        this.viewpointSelectors.append(selector);
	        viewpoint.editor = this.createEditor(viewpoint, container);
	        viewpoint.editor.events.on('change', function (evt) {
	            return _this.onChange(evt);
	        });
	        viewpoint.editor.events.on('instruction', function (evt) {
	            return _this.onInstruction(evt);
	        });
	        viewpoint.selector = selector;
	        this.viewpoints.push(viewpoint);
	    };
	
	    DesignPlacerController.prototype.createViewpointContainer = function createViewpointContainer(name) {
	        var viewpointContainer = angular.element('<div id="' + name + '" class="viewpoint-editor"></div>');
	        viewpointContainer.css('display', 'none');
	        return viewpointContainer;
	    };
	
	    DesignPlacerController.prototype.createViewpointSelector = function createViewpointSelector(name) {
	        var _this2 = this;
	
	        var selectorName = '<span class="name">' + name + '</span>';
	        var selector = '<div class="viewpoint" id="viewpoint-' + name + '"><div class="background"><img class="background-img"></div>' + selectorName + '</div>';
	        var viewpointSelector = angular.element(selector);
	        viewpointSelector.on('click', function () {
	            return _this2.selectViewpoint(name);
	        });
	        return viewpointSelector;
	    };
	
	    DesignPlacerController.prototype.createEditor = function createEditor(viewpoint, viewpointContainer) {
	        var containerId = viewpointContainer.attr('id');
	        return new _placingEditor2.default(containerId, this.editorSize, viewpoint, this.colour, this.editable);
	    };
	
	    DesignPlacerController.prototype.selectViewpoint = function selectViewpoint(viewpointName) {
	        if (this.currentViewpoint === viewpointName || this.navDisabled) {
	            return;
	        }
	
	        this.currentViewpoint = viewpointName;
	        var viewpointContainers = this.editorContainer.children();
	        _customLodash2.default.forEach(viewpointContainers, function (viewpointContainer) {
	            var element = angular.element(viewpointContainer);
	            element.css('display', element.attr('id') === viewpointName ? 'block' : 'none');
	        });
	        var viewpointSelectors = angular.element(document.getElementById('viewpoint-selectors'));
	        _customLodash2.default.forEach(viewpointSelectors.children(), function (viewpointSelector) {
	            var element = angular.element(viewpointSelector);
	            element.attr('class', element.attr('id') === 'viewpoint-' + viewpointName ? 'viewpoint active' : 'viewpoint');
	        });
	
	        this.events.emit('selectviewpoint', { viewpointName: viewpointName });
	    };
	
	    DesignPlacerController.prototype.getEditor = function getEditor(viewpointName) {
	        var viewpoint = _customLodash2.default.find(this.viewpoints, function (v) {
	            return v.name === viewpointName;
	        });
	
	        return viewpoint.editor;
	    };
	
	    DesignPlacerController.prototype.getSelector = function getSelector(viewpointName) {
	        var viewpoint = _customLodash2.default.find(this.viewpoints, function (v) {
	            return v.name === viewpointName;
	        });
	
	        return viewpoint.selector;
	    };
	
	    DesignPlacerController.prototype.addDesign = function addDesign(viewpointName, design) {
	        var editor = this.getEditor(viewpointName);
	        return editor.addDesign(design);
	    };
	
	    DesignPlacerController.prototype.getDesigns = function getDesigns(viewpointName) {
	        var editor = this.getEditor(viewpointName);
	        return editor.getDesigns();
	    };
	
	    DesignPlacerController.prototype.setDesigns = function setDesigns(viewpointName, designs) {
	        var _this3 = this;
	
	        var editor = this.getEditor(viewpointName);
	        return editor.setDesigns(designs).then(function () {
	            _this3.drawViewpointSelector(viewpointName);
	        });
	    };
	
	    DesignPlacerController.prototype.setBackground = function setBackground(viewpointName, imageUrl) {
	        var _this4 = this;
	
	        var editor = this.getEditor(viewpointName);
	        editor.viewpoint.image = imageUrl;
	        return editor.setBackground(imageUrl).then(function () {
	            _this4.drawViewpointSelector(viewpointName);
	            _this4.events.emit('change');
	        });
	    };
	
	    DesignPlacerController.prototype.disableNav = function disableNav(disabled) {
	        this.navDisabled = disabled;
	        var viewpointSelectors = this.viewpointSelectors.children();
	        _customLodash2.default.forEach(viewpointSelectors, function (viewpointSelector) {
	            var element = angular.element(viewpointSelector);
	            element.toggleClass('disabled', disabled);
	        });
	    };
	
	    DesignPlacerController.prototype.drawViewpointSelector = function drawViewpointSelector(viewpointName) {
	        var editor = this.getEditor(viewpointName);
	        var imageData = editor.getImageData({ width: 160, height: 160 });
	        var element = angular.element(this.getSelector(viewpointName));
	        var background = element[0].getElementsByClassName('background-img')[0];
	        background.src = imageData;
	    };
	
	    DesignPlacerController.prototype.onChange = function onChange(evt) {
	        // Use update to trigger external state changes.
	        // Use change for internal state changes.
	        this.events.emit('update', evt);
	        this.drawViewpointSelector(evt.viewpointName);
	    };
	
	    DesignPlacerController.prototype.onInstruction = function onInstruction(evt) {
	        this.events.emit('instruction', evt);
	    };
	
	    return DesignPlacerController;
	}();
	
	exports.default = angular.module('designPlacer', []).controller('DesignPlacerController', DesignPlacerController).directive('designPlacer', designPlacer).name;

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	var path = '/Users/philipborg/Code/DesignPlacer/src/designPlacer.tpl.html';
	var html = "<div> <div id=editors></div> <div id=viewpoint-selectors></div> </div>";
	window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
	module.exports = path;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Core = __webpack_require__(334);
	
	var _Core2 = _interopRequireDefault(_Core);
	
	var _PlacingLayer = __webpack_require__(348);
	
	var _PlacingLayer2 = _interopRequireDefault(_PlacingLayer);
	
	var _design = __webpack_require__(521);
	
	var _design2 = _interopRequireDefault(_design);
	
	var _helper = __webpack_require__(517);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _eventEmitter = __webpack_require__(520);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PlacingEditor = function () {
	    function PlacingEditor(containerId, editorSize, viewpoint, colour, editable) {
	        var _this = this;
	
	        _classCallCheck(this, PlacingEditor);
	
	        this.events = new _eventEmitter2.default();
	        this.viewpoint = viewpoint;
	        this.colour = colour;
	        this.stage = new _Core2.default.Stage({
	            container: containerId,
	            width: editorSize.width,
	            height: editorSize.height
	        });
	        var viewpointSize = { width: this.viewpoint.width, height: this.viewpoint.height };
	        this.placingLayer = new _PlacingLayer2.default(viewpointSize, editorSize, colour, editable);
	        this.placingLayer.events.on('change', function () {
	            return _this.emitChange();
	        });
	        this.placingLayer.events.on('instruction', function (design) {
	            return _this.emitInstruction(design);
	        });
	        this.stage.add(this.placingLayer.konvaLayer);
	        this.editable = editable;
	    }
	
	    PlacingEditor.prototype.createDesign = function createDesign(data) {
	        var _this2 = this;
	
	        return new Promise(function (resolve, reject) {
	            _helper2.default.getImage(data.image).then(function (imgObj) {
	                resolve(new _design2.default(data, imgObj, _this2.editable));
	            }, function (err) {
	                return reject(err);
	            });
	        });
	    };
	
	    PlacingEditor.prototype.addDesignToLayer = function addDesignToLayer(design) {
	        var _this3 = this;
	
	        return this.createDesign(design).then(function (designObj) {
	            _this3.placingLayer.addDesign(designObj);
	        });
	    };
	
	    PlacingEditor.prototype.addDesign = function addDesign(design) {
	        var _this4 = this;
	
	        return this.addDesignToLayer(design).then(function () {
	            _this4.emitChange();
	        });
	    };
	
	    PlacingEditor.prototype.setDesigns = function setDesigns(designs) {
	        var _this5 = this;
	
	        var promises = [];
	        this.placingLayer.clear();
	        designs.forEach(function (d) {
	            promises.push(_this5.addDesignToLayer(d));
	        });
	        return Promise.all(promises);
	    };
	
	    PlacingEditor.prototype.getDesigns = function getDesigns() {
	        return this.placingLayer.getDesigns();
	    };
	
	    PlacingEditor.prototype.setBackground = function setBackground(imgUrl) {
	        var _this6 = this;
	
	        return _helper2.default.getImage(imgUrl).then(function (imgObj) {
	            _this6.placingLayer.setBackground(imgObj);
	        });
	    };
	
	    PlacingEditor.prototype.emitChange = function emitChange() {
	        this.events.emit('change', { viewpointName: this.viewpoint.name });
	    };
	
	    PlacingEditor.prototype.emitInstruction = function emitInstruction(design) {
	        this.events.emit('instruction', design);
	    };
	
	    PlacingEditor.prototype.getImageData = function getImageData(maxSize) {
	        return this.placingLayer.getImageData(maxSize);
	    };
	
	    return PlacingEditor;
	}();
	
	exports.default = PlacingEditor;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(335);
	
	__webpack_require__(336);
	__webpack_require__(337);
	__webpack_require__(338);
	__webpack_require__(339);
	__webpack_require__(340);
	__webpack_require__(341);
	__webpack_require__(342);
	__webpack_require__(343);
	__webpack_require__(344);
	__webpack_require__(345);
	__webpack_require__(346);
	__webpack_require__(347);


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	 * Konva JavaScript Framework v@@version
	 * http://konvajs.github.io/
	 * Licensed under the MIT or GPL Version 2 licenses.
	 * Date: @@date
	 *
	 * Original work Copyright (C) 2011 - 2013 by Eric Rowell (KineticJS)
	 * Modified work Copyright (C) 2014 - 2017 by Anton Lavrenov (Konva)
	 *
	 * @license
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 */
	
	// runtime check for already included Konva
	(function() {
	  'use strict';
	  /**
	     * @namespace Konva
	     */
	
	  var PI_OVER_180 = Math.PI / 180;
	
	  var Konva = {
	    // public
	    version: '@@version',
	
	    // private
	    stages: [],
	    idCounter: 0,
	    ids: {},
	    names: {},
	    shapes: {},
	    listenClickTap: false,
	    inDblClickWindow: false,
	
	    isBrowser:
	      typeof window !== 'undefined' &&
	      // browser case
	      ({}.toString.call(window) === '[object Window]' ||
	        // electron case
	        {}.toString.call(window) === '[object global]'),
	
	    // configurations
	    enableTrace: false,
	    traceArrMax: 100,
	    dblClickWindow: 400,
	    /**
	         * Global pixel ratio configuration. KonvaJS automatically detect pixel ratio of current device.
	         * But you may override such property, if you want to use your value.
	         * @property pixelRatio
	         * @default undefined
	         * @memberof Konva
	         * @example
	         * Konva.pixelRatio = 1;
	         */
	    pixelRatio: undefined,
	    /**
	         * Drag distance property. If you start to drag a node you may want to wait until pointer is moved to some distance from start point,
	         * only then start dragging. Default is 3px.
	         * @property dragDistance
	         * @default 0
	         * @memberof Konva
	         * @example
	         * Konva.dragDistance = 10;
	         */
	    dragDistance: 3,
	    /**
	         * Use degree values for angle properties. You may set this property to false if you want to use radiant values.
	         * @property angleDeg
	         * @default true
	         * @memberof Konva
	         * @example
	         * node.rotation(45); // 45 degrees
	         * Konva.angleDeg = false;
	         * node.rotation(Math.PI / 2); // PI/2 radian
	         */
	    angleDeg: true,
	    /**
	         * Show different warnings about errors or wrong API usage
	         * @property showWarnings
	         * @default true
	         * @memberof Konva
	         * @example
	         * Konva.showWarnings = false;
	         */
	    showWarnings: true,
	
	    /**
	         * @namespace Filters
	         * @memberof Konva
	         */
	    Filters: {},
	
	    /**
	         * returns whether or not drag and drop is currently active
	         * @method
	         * @memberof Konva
	         */
	    isDragging: function() {
	      var dd = Konva.DD;
	
	      // if DD is not included with the build, then
	      // drag and drop is not even possible
	      if (dd) {
	        return dd.isDragging;
	      }
	      return false;
	    },
	    /**
	        * returns whether or not a drag and drop operation is ready, but may
	        *  not necessarily have started
	        * @method
	        * @memberof Konva
	        */
	    isDragReady: function() {
	      var dd = Konva.DD;
	
	      // if DD is not included with the build, then
	      // drag and drop is not even possible
	      if (dd) {
	        return !!dd.node;
	      }
	      return false;
	    },
	    _addId: function(node, id) {
	      if (id !== undefined) {
	        this.ids[id] = node;
	      }
	    },
	    _removeId: function(id) {
	      if (id !== undefined) {
	        delete this.ids[id];
	      }
	    },
	    _addName: function(node, name) {
	      if (name) {
	        if (!this.names[name]) {
	          this.names[name] = [];
	        }
	        this.names[name].push(node);
	      }
	    },
	    _removeName: function(name, _id) {
	      if (!name) {
	        return;
	      }
	      var nodes = this.names[name];
	      if (!nodes) {
	        return;
	      }
	      for (var n = 0; n < nodes.length; n++) {
	        var no = nodes[n];
	        if (no._id === _id) {
	          nodes.splice(n, 1);
	        }
	      }
	      if (nodes.length === 0) {
	        delete this.names[name];
	      }
	    },
	    getAngle: function(angle) {
	      return this.angleDeg ? angle * PI_OVER_180 : angle;
	    },
	    _detectIE: function(ua) {
	      var msie = ua.indexOf('msie ');
	      if (msie > 0) {
	        // IE 10 or older => return version number
	        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	      }
	
	      var trident = ua.indexOf('trident/');
	      if (trident > 0) {
	        // IE 11 => return version number
	        var rv = ua.indexOf('rv:');
	        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	      }
	
	      var edge = ua.indexOf('edge/');
	      if (edge > 0) {
	        // Edge (IE 12+) => return version number
	        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	      }
	
	      // other browser
	      return false;
	    },
	    _parseUA: function(userAgent) {
	      var ua = userAgent.toLowerCase(),
	        // jQuery UA regex
	        match =
	          /(chrome)[ /]([\w.]+)/.exec(ua) ||
	          /(webkit)[ /]([\w.]+)/.exec(ua) ||
	          /(opera)(?:.*version|)[ /]([\w.]+)/.exec(ua) ||
	          /(msie) ([\w.]+)/.exec(ua) ||
	          (ua.indexOf('compatible') < 0 &&
	            /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua)) ||
	          [],
	        // adding mobile flag as well
	        mobile = !!userAgent.match(
	          /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i
	        ),
	        ieMobile = !!userAgent.match(/IEMobile/i);
	
	      return {
	        browser: match[1] || '',
	        version: match[2] || '0',
	        isIE: Konva._detectIE(ua),
	        // adding mobile flab
	        mobile: mobile,
	        ieMobile: ieMobile // If this is true (i.e., WP8), then Konva touch events are executed instead of equivalent Konva mouse events
	      };
	    },
	    // user agent
	    UA: undefined
	  };
	
	  var glob =
	    typeof global !== 'undefined'
	      ? global
	      : typeof window !== 'undefined'
	        ? window
	        : typeof WorkerGlobalScope !== 'undefined' ? self : {};
	
	  Konva.UA = Konva._parseUA((glob.navigator && glob.navigator.userAgent) || '');
	
	  if (glob.Konva) {
	    console.error(
	      'Konva instance is already exist in current eviroment. ' +
	        'Please use only one instance.'
	    );
	  }
	  glob.Konva = Konva;
	  Konva.global = glob;
	  Konva.window = glob;
	  Konva.document = glob.document;
	
	  if (true) {
	    module.exports = Konva;
	  } else if (typeof define === 'function' && define.amd) {
	    // AMD. Register as an anonymous module.
	    define(function() {
	      return Konva;
	    });
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	/*eslint-disable  eqeqeq, no-cond-assign, no-empty*/
	(function() {
	  'use strict';
	  /**
	     * Collection constructor.  Collection extends
	     *  Array.  This class is used in conjunction with {@link Konva.Container#get}
	     * @constructor
	     * @memberof Konva
	     */
	  Konva.Collection = function() {
	    var args = [].slice.call(arguments),
	      length = args.length,
	      i = 0;
	
	    this.length = length;
	    for (; i < length; i++) {
	      this[i] = args[i];
	    }
	    return this;
	  };
	  Konva.Collection.prototype = [];
	  /**
	     * iterate through node array and run a function for each node.
	     *  The node and index is passed into the function
	     * @method
	     * @memberof Konva.Collection.prototype
	     * @param {Function} func
	     * @example
	     * // get all nodes with name foo inside layer, and set x to 10 for each
	     * layer.get('.foo').each(function(shape, n) {
	     *   shape.setX(10);
	     * });
	     */
	  Konva.Collection.prototype.each = function(func) {
	    for (var n = 0; n < this.length; n++) {
	      func(this[n], n);
	    }
	  };
	  /**
	     * convert collection into an array
	     * @method
	     * @memberof Konva.Collection.prototype
	     */
	  Konva.Collection.prototype.toArray = function() {
	    var arr = [],
	      len = this.length,
	      n;
	
	    for (n = 0; n < len; n++) {
	      arr.push(this[n]);
	    }
	    return arr;
	  };
	  /**
	     * convert array into a collection
	     * @method
	     * @memberof Konva.Collection
	     * @param {Array} arr
	     */
	  Konva.Collection.toCollection = function(arr) {
	    var collection = new Konva.Collection(),
	      len = arr.length,
	      n;
	
	    for (n = 0; n < len; n++) {
	      collection.push(arr[n]);
	    }
	    return collection;
	  };
	
	  // map one method by it's name
	  Konva.Collection._mapMethod = function(methodName) {
	    Konva.Collection.prototype[methodName] = function() {
	      var len = this.length,
	        i;
	
	      var args = [].slice.call(arguments);
	      for (i = 0; i < len; i++) {
	        this[i][methodName].apply(this[i], args);
	      }
	
	      return this;
	    };
	  };
	
	  Konva.Collection.mapMethods = function(constructor) {
	    var prot = constructor.prototype;
	    for (var methodName in prot) {
	      Konva.Collection._mapMethod(methodName);
	    }
	  };
	
	  /*
	    * Last updated November 2011
	    * By Simon Sarris
	    * www.simonsarris.com
	    * sarris@acm.org
	    *
	    * Free to use and distribute at will
	    * So long as you are nice to people, etc
	    */
	
	  /*
	    * The usage of this class was inspired by some of the work done by a forked
	    * project, KineticJS-Ext by Wappworks, which is based on Simon's Transform
	    * class.  Modified by Eric Rowell
	    */
	
	  /**
	     * Transform constructor
	     * @constructor
	     * @param {Array} [m] Optional six-element matrix
	     * @memberof Konva
	     */
	  Konva.Transform = function(m) {
	    this.m = (m && m.slice()) || [1, 0, 0, 1, 0, 0];
	  };
	
	  Konva.Transform.prototype = {
	    /**
	         * Copy Konva.Transform object
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @returns {Konva.Transform}
	         */
	    copy: function() {
	      return new Konva.Transform(this.m);
	    },
	    /**
	         * Transform point
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @param {Object} point 2D point(x, y)
	         * @returns {Object} 2D point(x, y)
	         */
	    point: function(point) {
	      var m = this.m;
	      return {
	        x: m[0] * point.x + m[2] * point.y + m[4],
	        y: m[1] * point.x + m[3] * point.y + m[5]
	      };
	    },
	    /**
	         * Apply translation
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @param {Number} x
	         * @param {Number} y
	         * @returns {Konva.Transform}
	         */
	    translate: function(x, y) {
	      this.m[4] += this.m[0] * x + this.m[2] * y;
	      this.m[5] += this.m[1] * x + this.m[3] * y;
	      return this;
	    },
	    /**
	         * Apply scale
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @param {Number} sx
	         * @param {Number} sy
	         * @returns {Konva.Transform}
	         */
	    scale: function(sx, sy) {
	      this.m[0] *= sx;
	      this.m[1] *= sx;
	      this.m[2] *= sy;
	      this.m[3] *= sy;
	      return this;
	    },
	    /**
	         * Apply rotation
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @param {Number} rad  Angle in radians
	         * @returns {Konva.Transform}
	         */
	    rotate: function(rad) {
	      var c = Math.cos(rad);
	      var s = Math.sin(rad);
	      var m11 = this.m[0] * c + this.m[2] * s;
	      var m12 = this.m[1] * c + this.m[3] * s;
	      var m21 = this.m[0] * -s + this.m[2] * c;
	      var m22 = this.m[1] * -s + this.m[3] * c;
	      this.m[0] = m11;
	      this.m[1] = m12;
	      this.m[2] = m21;
	      this.m[3] = m22;
	      return this;
	    },
	    /**
	         * Returns the translation
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @returns {Object} 2D point(x, y)
	         */
	    getTranslation: function() {
	      return {
	        x: this.m[4],
	        y: this.m[5]
	      };
	    },
	    /**
	         * Apply skew
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @param {Number} sx
	         * @param {Number} sy
	         * @returns {Konva.Transform}
	         */
	    skew: function(sx, sy) {
	      var m11 = this.m[0] + this.m[2] * sy;
	      var m12 = this.m[1] + this.m[3] * sy;
	      var m21 = this.m[2] + this.m[0] * sx;
	      var m22 = this.m[3] + this.m[1] * sx;
	      this.m[0] = m11;
	      this.m[1] = m12;
	      this.m[2] = m21;
	      this.m[3] = m22;
	      return this;
	    },
	    /**
	         * Transform multiplication
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @param {Konva.Transform} matrix
	         * @returns {Konva.Transform}
	         */
	    multiply: function(matrix) {
	      var m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
	      var m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
	
	      var m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
	      var m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
	
	      var dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
	      var dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
	
	      this.m[0] = m11;
	      this.m[1] = m12;
	      this.m[2] = m21;
	      this.m[3] = m22;
	      this.m[4] = dx;
	      this.m[5] = dy;
	      return this;
	    },
	    /**
	         * Invert the matrix
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @returns {Konva.Transform}
	         */
	    invert: function() {
	      var d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
	      var m0 = this.m[3] * d;
	      var m1 = -this.m[1] * d;
	      var m2 = -this.m[2] * d;
	      var m3 = this.m[0] * d;
	      var m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
	      var m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
	      this.m[0] = m0;
	      this.m[1] = m1;
	      this.m[2] = m2;
	      this.m[3] = m3;
	      this.m[4] = m4;
	      this.m[5] = m5;
	      return this;
	    },
	    /**
	         * return matrix
	         * @method
	         * @memberof Konva.Transform.prototype
	         */
	    getMatrix: function() {
	      return this.m;
	    },
	    /**
	         * set to absolute position via translation
	         * @method
	         * @memberof Konva.Transform.prototype
	         * @returns {Konva.Transform}
	         * @author ericdrowell
	         */
	    setAbsolutePosition: function(x, y) {
	      var m0 = this.m[0],
	        m1 = this.m[1],
	        m2 = this.m[2],
	        m3 = this.m[3],
	        m4 = this.m[4],
	        m5 = this.m[5],
	        yt = (m0 * (y - m5) - m1 * (x - m4)) / (m0 * m3 - m1 * m2),
	        xt = (x - m4 - m2 * yt) / m0;
	
	      return this.translate(xt, yt);
	    }
	  };
	
	  // CONSTANTS
	  var CONTEXT_2D = '2d',
	    OBJECT_ARRAY = '[object Array]',
	    OBJECT_NUMBER = '[object Number]',
	    OBJECT_STRING = '[object String]',
	    PI_OVER_DEG180 = Math.PI / 180,
	    DEG180_OVER_PI = 180 / Math.PI,
	    HASH = '#',
	    EMPTY_STRING = '',
	    ZERO = '0',
	    KONVA_WARNING = 'Konva warning: ',
	    KONVA_ERROR = 'Konva error: ',
	    RGB_PAREN = 'rgb(',
	    COLORS = {
	      aliceblue: [240, 248, 255],
	      antiquewhite: [250, 235, 215],
	      aqua: [0, 255, 255],
	      aquamarine: [127, 255, 212],
	      azure: [240, 255, 255],
	      beige: [245, 245, 220],
	      bisque: [255, 228, 196],
	      black: [0, 0, 0],
	      blanchedalmond: [255, 235, 205],
	      blue: [0, 0, 255],
	      blueviolet: [138, 43, 226],
	      brown: [165, 42, 42],
	      burlywood: [222, 184, 135],
	      cadetblue: [95, 158, 160],
	      chartreuse: [127, 255, 0],
	      chocolate: [210, 105, 30],
	      coral: [255, 127, 80],
	      cornflowerblue: [100, 149, 237],
	      cornsilk: [255, 248, 220],
	      crimson: [220, 20, 60],
	      cyan: [0, 255, 255],
	      darkblue: [0, 0, 139],
	      darkcyan: [0, 139, 139],
	      darkgoldenrod: [184, 132, 11],
	      darkgray: [169, 169, 169],
	      darkgreen: [0, 100, 0],
	      darkgrey: [169, 169, 169],
	      darkkhaki: [189, 183, 107],
	      darkmagenta: [139, 0, 139],
	      darkolivegreen: [85, 107, 47],
	      darkorange: [255, 140, 0],
	      darkorchid: [153, 50, 204],
	      darkred: [139, 0, 0],
	      darksalmon: [233, 150, 122],
	      darkseagreen: [143, 188, 143],
	      darkslateblue: [72, 61, 139],
	      darkslategray: [47, 79, 79],
	      darkslategrey: [47, 79, 79],
	      darkturquoise: [0, 206, 209],
	      darkviolet: [148, 0, 211],
	      deeppink: [255, 20, 147],
	      deepskyblue: [0, 191, 255],
	      dimgray: [105, 105, 105],
	      dimgrey: [105, 105, 105],
	      dodgerblue: [30, 144, 255],
	      firebrick: [178, 34, 34],
	      floralwhite: [255, 255, 240],
	      forestgreen: [34, 139, 34],
	      fuchsia: [255, 0, 255],
	      gainsboro: [220, 220, 220],
	      ghostwhite: [248, 248, 255],
	      gold: [255, 215, 0],
	      goldenrod: [218, 165, 32],
	      gray: [128, 128, 128],
	      green: [0, 128, 0],
	      greenyellow: [173, 255, 47],
	      grey: [128, 128, 128],
	      honeydew: [240, 255, 240],
	      hotpink: [255, 105, 180],
	      indianred: [205, 92, 92],
	      indigo: [75, 0, 130],
	      ivory: [255, 255, 240],
	      khaki: [240, 230, 140],
	      lavender: [230, 230, 250],
	      lavenderblush: [255, 240, 245],
	      lawngreen: [124, 252, 0],
	      lemonchiffon: [255, 250, 205],
	      lightblue: [173, 216, 230],
	      lightcoral: [240, 128, 128],
	      lightcyan: [224, 255, 255],
	      lightgoldenrodyellow: [250, 250, 210],
	      lightgray: [211, 211, 211],
	      lightgreen: [144, 238, 144],
	      lightgrey: [211, 211, 211],
	      lightpink: [255, 182, 193],
	      lightsalmon: [255, 160, 122],
	      lightseagreen: [32, 178, 170],
	      lightskyblue: [135, 206, 250],
	      lightslategray: [119, 136, 153],
	      lightslategrey: [119, 136, 153],
	      lightsteelblue: [176, 196, 222],
	      lightyellow: [255, 255, 224],
	      lime: [0, 255, 0],
	      limegreen: [50, 205, 50],
	      linen: [250, 240, 230],
	      magenta: [255, 0, 255],
	      maroon: [128, 0, 0],
	      mediumaquamarine: [102, 205, 170],
	      mediumblue: [0, 0, 205],
	      mediumorchid: [186, 85, 211],
	      mediumpurple: [147, 112, 219],
	      mediumseagreen: [60, 179, 113],
	      mediumslateblue: [123, 104, 238],
	      mediumspringgreen: [0, 250, 154],
	      mediumturquoise: [72, 209, 204],
	      mediumvioletred: [199, 21, 133],
	      midnightblue: [25, 25, 112],
	      mintcream: [245, 255, 250],
	      mistyrose: [255, 228, 225],
	      moccasin: [255, 228, 181],
	      navajowhite: [255, 222, 173],
	      navy: [0, 0, 128],
	      oldlace: [253, 245, 230],
	      olive: [128, 128, 0],
	      olivedrab: [107, 142, 35],
	      orange: [255, 165, 0],
	      orangered: [255, 69, 0],
	      orchid: [218, 112, 214],
	      palegoldenrod: [238, 232, 170],
	      palegreen: [152, 251, 152],
	      paleturquoise: [175, 238, 238],
	      palevioletred: [219, 112, 147],
	      papayawhip: [255, 239, 213],
	      peachpuff: [255, 218, 185],
	      peru: [205, 133, 63],
	      pink: [255, 192, 203],
	      plum: [221, 160, 203],
	      powderblue: [176, 224, 230],
	      purple: [128, 0, 128],
	      rebeccapurple: [102, 51, 153],
	      red: [255, 0, 0],
	      rosybrown: [188, 143, 143],
	      royalblue: [65, 105, 225],
	      saddlebrown: [139, 69, 19],
	      salmon: [250, 128, 114],
	      sandybrown: [244, 164, 96],
	      seagreen: [46, 139, 87],
	      seashell: [255, 245, 238],
	      sienna: [160, 82, 45],
	      silver: [192, 192, 192],
	      skyblue: [135, 206, 235],
	      slateblue: [106, 90, 205],
	      slategray: [119, 128, 144],
	      slategrey: [119, 128, 144],
	      snow: [255, 255, 250],
	      springgreen: [0, 255, 127],
	      steelblue: [70, 130, 180],
	      tan: [210, 180, 140],
	      teal: [0, 128, 128],
	      thistle: [216, 191, 216],
	      transparent: [255, 255, 255, 0],
	      tomato: [255, 99, 71],
	      turquoise: [64, 224, 208],
	      violet: [238, 130, 238],
	      wheat: [245, 222, 179],
	      white: [255, 255, 255],
	      whitesmoke: [245, 245, 245],
	      yellow: [255, 255, 0],
	      yellowgreen: [154, 205, 5]
	    },
	    RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/;
	
	  /**
	     * @namespace Util
	     * @memberof Konva
	     */
	  Konva.Util = {
	    /*
	         * cherry-picked utilities from underscore.js
	         */
	    _isElement: function(obj) {
	      return !!(obj && obj.nodeType == 1);
	    },
	    _isFunction: function(obj) {
	      return !!(obj && obj.constructor && obj.call && obj.apply);
	    },
	    _isObject: function(obj) {
	      return !!obj && obj.constructor === Object;
	    },
	    _isArray: function(obj) {
	      return Object.prototype.toString.call(obj) === OBJECT_ARRAY;
	    },
	    _isNumber: function(obj) {
	      return Object.prototype.toString.call(obj) === OBJECT_NUMBER;
	    },
	    _isString: function(obj) {
	      return Object.prototype.toString.call(obj) === OBJECT_STRING;
	    },
	    // Returns a function, that, when invoked, will only be triggered at most once
	    // during a given window of time. Normally, the throttled function will run
	    // as much as it can, without ever going more than once per `wait` duration;
	    // but if you'd like to disable the execution on the leading edge, pass
	    // `{leading: false}`. To disable execution on the trailing edge, ditto.
	    _throttle: function(func, wait, opts) {
	      var context, args, result;
	      var timeout = null;
	      var previous = 0;
	      var options = opts || {};
	      var later = function() {
	        previous = options.leading === false ? 0 : new Date().getTime();
	        timeout = null;
	        result = func.apply(context, args);
	        context = args = null;
	      };
	      return function() {
	        var now = new Date().getTime();
	        if (!previous && options.leading === false) {
	          previous = now;
	        }
	        var remaining = wait - (now - previous);
	        context = this;
	        args = arguments;
	        if (remaining <= 0) {
	          clearTimeout(timeout);
	          timeout = null;
	          previous = now;
	          result = func.apply(context, args);
	          context = args = null;
	        } else if (!timeout && options.trailing !== false) {
	          timeout = setTimeout(later, remaining);
	        }
	        return result;
	      };
	    },
	    /*
	         * other utils
	         */
	    _hasMethods: function(obj) {
	      var names = [],
	        key;
	
	      for (key in obj) {
	        if (!obj.hasOwnProperty(key)) {
	          continue;
	        }
	        if (this._isFunction(obj[key])) {
	          names.push(key);
	        }
	      }
	      return names.length > 0;
	    },
	    isValidSelector: function(selector) {
	      if (typeof selector !== 'string') {
	        return false;
	      }
	      var firstChar = selector[0];
	      return (
	        firstChar === '#' ||
	        firstChar === '.' ||
	        firstChar === firstChar.toUpperCase()
	      );
	    },
	    createCanvasElement: function() {
	      var canvas = Konva.isBrowser
	        ? Konva.document.createElement('canvas')
	        : new Konva._nodeCanvas();
	      // on some environments canvas.style is readonly
	      try {
	        canvas.style = canvas.style || {};
	      } catch (e) {}
	      return canvas;
	    },
	    _isInDocument: function(el) {
	      while ((el = el.parentNode)) {
	        if (el == Konva.document) {
	          return true;
	        }
	      }
	      return false;
	    },
	    _simplifyArray: function(arr) {
	      var retArr = [],
	        len = arr.length,
	        util = Konva.Util,
	        n,
	        val;
	
	      for (n = 0; n < len; n++) {
	        val = arr[n];
	        if (util._isNumber(val)) {
	          val = Math.round(val * 1000) / 1000;
	        } else if (!util._isString(val)) {
	          val = val.toString();
	        }
	
	        retArr.push(val);
	      }
	
	      return retArr;
	    },
	    /*
	         * arg can be an image object or image data
	         */
	    _getImage: function(arg, callback) {
	      var imageObj, canvas;
	
	      // if arg is null or undefined
	      if (!arg) {
	        callback(null);
	      } else if (this._isElement(arg)) {
	        // if arg is already an image object
	        callback(arg);
	      } else if (this._isString(arg)) {
	        // if arg is a string, then it's a data url
	        imageObj = new Konva.window.Image();
	        imageObj.onload = function() {
	          callback(imageObj);
	        };
	        imageObj.src = arg;
	      } else if (arg.data) {
	        //if arg is an object that contains the data property, it's an image object
	        canvas = Konva.Util.createCanvasElement();
	        canvas.width = arg.width;
	        canvas.height = arg.height;
	        var _context = canvas.getContext(CONTEXT_2D);
	        _context.putImageData(arg, 0, 0);
	        this._getImage(canvas.toDataURL(), callback);
	      } else {
	        callback(null);
	      }
	    },
	    _getRGBAString: function(obj) {
	      var red = obj.red || 0,
	        green = obj.green || 0,
	        blue = obj.blue || 0,
	        alpha = obj.alpha || 1;
	
	      return ['rgba(', red, ',', green, ',', blue, ',', alpha, ')'].join(
	        EMPTY_STRING
	      );
	    },
	    _rgbToHex: function(r, g, b) {
	      return ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
	    },
	    _hexToRgb: function(hex) {
	      hex = hex.replace(HASH, EMPTY_STRING);
	      var bigint = parseInt(hex, 16);
	      return {
	        r: (bigint >> 16) & 255,
	        g: (bigint >> 8) & 255,
	        b: bigint & 255
	      };
	    },
	    /**
	         * return random hex color
	         * @method
	         * @memberof Konva.Util.prototype
	         */
	    getRandomColor: function() {
	      var randColor = ((Math.random() * 0xffffff) << 0).toString(16);
	      while (randColor.length < 6) {
	        randColor = ZERO + randColor;
	      }
	      return HASH + randColor;
	    },
	    /**
	         * return value with default fallback
	         * @method
	         * @memberof Konva.Util.prototype
	         */
	    get: function(val, def) {
	      if (val === undefined) {
	        return def;
	      } else {
	        return val;
	      }
	    },
	    /**
	         * get RGB components of a color
	         * @method
	         * @memberof Konva.Util.prototype
	         * @param {String} color
	         * @example
	         * // each of the following examples return {r:0, g:0, b:255}
	         * var rgb = Konva.Util.getRGB('blue');
	         * var rgb = Konva.Util.getRGB('#0000ff');
	         * var rgb = Konva.Util.getRGB('rgb(0,0,255)');
	         */
	    getRGB: function(color) {
	      var rgb;
	      // color string
	      if (color in COLORS) {
	        rgb = COLORS[color];
	        return {
	          r: rgb[0],
	          g: rgb[1],
	          b: rgb[2]
	        };
	      } else if (color[0] === HASH) {
	        // hex
	        return this._hexToRgb(color.substring(1));
	      } else if (color.substr(0, 4) === RGB_PAREN) {
	        // rgb string
	        rgb = RGB_REGEX.exec(color.replace(/ /g, ''));
	        return {
	          r: parseInt(rgb[1], 10),
	          g: parseInt(rgb[2], 10),
	          b: parseInt(rgb[3], 10)
	        };
	      } else {
	        // default
	        return {
	          r: 0,
	          g: 0,
	          b: 0
	        };
	      }
	    },
	    // convert any color string to RGBA object
	    // from https://github.com/component/color-parser
	    colorToRGBA: function(str) {
	      str = str || 'black';
	      return (
	        Konva.Util._namedColorToRBA(str) ||
	        Konva.Util._hex3ColorToRGBA(str) ||
	        Konva.Util._hex6ColorToRGBA(str) ||
	        Konva.Util._rgbColorToRGBA(str) ||
	        Konva.Util._rgbaColorToRGBA(str)
	      );
	    },
	    // Parse named css color. Like "green"
	    _namedColorToRBA: function(str) {
	      var c = COLORS[str.toLowerCase()];
	      if (!c) {
	        return null;
	      }
	      return {
	        r: c[0],
	        g: c[1],
	        b: c[2],
	        a: 1
	      };
	    },
	    // Parse rgb(n, n, n)
	    _rgbColorToRGBA: function(str) {
	      if (str.indexOf('rgb(') === 0) {
	        str = str.match(/rgb\(([^)]+)\)/)[1];
	        var parts = str.split(/ *, */).map(Number);
	        return {
	          r: parts[0],
	          g: parts[1],
	          b: parts[2],
	          a: 1
	        };
	      }
	    },
	    // Parse rgba(n, n, n, n)
	    _rgbaColorToRGBA: function(str) {
	      if (str.indexOf('rgba(') === 0) {
	        str = str.match(/rgba\(([^)]+)\)/)[1];
	        var parts = str.split(/ *, */).map(Number);
	        return {
	          r: parts[0],
	          g: parts[1],
	          b: parts[2],
	          a: parts[3]
	        };
	      }
	    },
	    // Parse #nnnnnn
	    _hex6ColorToRGBA: function(str) {
	      if (str[0] === '#' && str.length === 7) {
	        return {
	          r: parseInt(str.slice(1, 3), 16),
	          g: parseInt(str.slice(3, 5), 16),
	          b: parseInt(str.slice(5, 7), 16),
	          a: 1
	        };
	      }
	    },
	    // Parse #nnn
	    _hex3ColorToRGBA: function(str) {
	      if (str[0] === '#' && str.length === 4) {
	        return {
	          r: parseInt(str[1] + str[1], 16),
	          g: parseInt(str[2] + str[2], 16),
	          b: parseInt(str[3] + str[3], 16),
	          a: 1
	        };
	      }
	    },
	    // o1 takes precedence over o2
	    _merge: function(o1, o2) {
	      var retObj = this._clone(o2);
	      for (var key in o1) {
	        if (this._isObject(o1[key])) {
	          retObj[key] = this._merge(o1[key], retObj[key]);
	        } else {
	          retObj[key] = o1[key];
	        }
	      }
	      return retObj;
	    },
	    cloneObject: function(obj) {
	      var retObj = {};
	      for (var key in obj) {
	        if (this._isObject(obj[key])) {
	          retObj[key] = this.cloneObject(obj[key]);
	        } else if (this._isArray(obj[key])) {
	          retObj[key] = this.cloneArray(obj[key]);
	        } else {
	          retObj[key] = obj[key];
	        }
	      }
	      return retObj;
	    },
	    cloneArray: function(arr) {
	      return arr.slice(0);
	    },
	    _degToRad: function(deg) {
	      return deg * PI_OVER_DEG180;
	    },
	    _radToDeg: function(rad) {
	      return rad * DEG180_OVER_PI;
	    },
	    _capitalize: function(str) {
	      return str.charAt(0).toUpperCase() + str.slice(1);
	    },
	    throw: function(str) {
	      throw new Error(KONVA_ERROR + str);
	    },
	    error: function(str) {
	      console.error(KONVA_ERROR + str);
	    },
	    warn: function(str) {
	      /*
	             * IE9 on Windows7 64bit will throw a JS error
	             * if we don't use window.console in the conditional
	             */
	      if (Konva.global.console && console.warn && Konva.showWarnings) {
	        console.warn(KONVA_WARNING + str);
	      }
	    },
	    extend: function(child, parent) {
	      function Ctor() {
	        this.constructor = child;
	      }
	      Ctor.prototype = parent.prototype;
	      var oldProto = child.prototype;
	      child.prototype = new Ctor();
	      for (var key in oldProto) {
	        if (oldProto.hasOwnProperty(key)) {
	          child.prototype[key] = oldProto[key];
	        }
	      }
	      child.__super__ = parent.prototype;
	      // create reference to parent
	      child.super = parent;
	    },
	    /**
	         * adds methods to a constructor prototype
	         * @method
	         * @memberof Konva.Util.prototype
	         * @param {Function} constructor
	         * @param {Object} methods
	         */
	    addMethods: function(constructor, methods) {
	      var key;
	
	      for (key in methods) {
	        constructor.prototype[key] = methods[key];
	      }
	    },
	    _getControlPoints: function(x0, y0, x1, y1, x2, y2, t) {
	      var d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)),
	        d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)),
	        fa = t * d01 / (d01 + d12),
	        fb = t * d12 / (d01 + d12),
	        p1x = x1 - fa * (x2 - x0),
	        p1y = y1 - fa * (y2 - y0),
	        p2x = x1 + fb * (x2 - x0),
	        p2y = y1 + fb * (y2 - y0);
	
	      return [p1x, p1y, p2x, p2y];
	    },
	    _expandPoints: function(p, tension) {
	      var len = p.length,
	        allPoints = [],
	        n,
	        cp;
	
	      for (n = 2; n < len - 2; n += 2) {
	        cp = Konva.Util._getControlPoints(
	          p[n - 2],
	          p[n - 1],
	          p[n],
	          p[n + 1],
	          p[n + 2],
	          p[n + 3],
	          tension
	        );
	        allPoints.push(cp[0]);
	        allPoints.push(cp[1]);
	        allPoints.push(p[n]);
	        allPoints.push(p[n + 1]);
	        allPoints.push(cp[2]);
	        allPoints.push(cp[3]);
	      }
	
	      return allPoints;
	    },
	    _removeLastLetter: function(str) {
	      return str.substring(0, str.length - 1);
	    },
	    each: function(obj, func) {
	      for (var key in obj) {
	        func(key, obj[key]);
	      }
	    },
	    _getProjectionToSegment: function(x1, y1, x2, y2, x3, y3) {
	      var x, y, dist;
	
	      var pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
	      if (pd2 == 0) {
	        x = x1;
	        y = y1;
	        dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
	      } else {
	        var u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
	        if (u < 0) {
	          x = x1;
	          y = y1;
	          dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
	        } else if (u > 1.0) {
	          x = x2;
	          y = y2;
	          dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
	        } else {
	          x = x1 + u * (x2 - x1);
	          y = y1 + u * (y2 - y1);
	          dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
	        }
	      }
	      return [x, y, dist];
	    },
	    // line as array of points.
	    // line might be closed
	    _getProjectionToLine: function(pt, line, isClosed) {
	      var pc = Konva.Util.cloneObject(pt);
	      var dist = Number.MAX_VALUE;
	      line.forEach(function(p1, i) {
	        if (!isClosed && i === line.length - 1) {
	          return;
	        }
	        var p2 = line[(i + 1) % line.length];
	        var proj = Konva.Util._getProjectionToSegment(
	          p1.x,
	          p1.y,
	          p2.x,
	          p2.y,
	          pt.x,
	          pt.y
	        );
	        var px = proj[0],
	          py = proj[1],
	          pdist = proj[2];
	        if (pdist < dist) {
	          pc.x = px;
	          pc.y = py;
	          dist = pdist;
	        }
	      });
	      return pc;
	    },
	    _prepareArrayForTween: function(startArray, endArray, isClosed) {
	      var n,
	        start = [],
	        end = [];
	      if (startArray.length > endArray.length) {
	        var temp = endArray;
	        endArray = startArray;
	        startArray = temp;
	      }
	      for (n = 0; n < startArray.length; n += 2) {
	        start.push({
	          x: startArray[n],
	          y: startArray[n + 1]
	        });
	      }
	      for (n = 0; n < endArray.length; n += 2) {
	        end.push({
	          x: endArray[n],
	          y: endArray[n + 1]
	        });
	      }
	
	      var newStart = [];
	      end.forEach(function(point) {
	        var pr = Konva.Util._getProjectionToLine(point, start, isClosed);
	        newStart.push(pr.x);
	        newStart.push(pr.y);
	      });
	      return newStart;
	    },
	    _prepareToStringify: function(obj) {
	      var desc;
	
	      obj.visitedByCircularReferenceRemoval = true;
	
	      for (var key in obj) {
	        if (
	          !(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == 'object')
	        ) {
	          continue;
	        }
	        desc = Object.getOwnPropertyDescriptor(obj, key);
	        if (
	          obj[key].visitedByCircularReferenceRemoval ||
	          Konva.Util._isElement(obj[key])
	        ) {
	          if (desc.configurable) {
	            delete obj[key];
	          } else {
	            return null;
	          }
	        } else if (Konva.Util._prepareToStringify(obj[key]) === null) {
	          if (desc.configurable) {
	            delete obj[key];
	          } else {
	            return null;
	          }
	        }
	      }
	
	      delete obj.visitedByCircularReferenceRemoval;
	
	      return obj;
	    }
	  };
	})();


/***/ }),
/* 337 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';
	  // calculate pixel ratio
	
	  var _pixelRatio;
	  function getDevicePixelRatio() {
	    if (_pixelRatio) {
	      return _pixelRatio;
	    }
	    var canvas = Konva.Util.createCanvasElement();
	    var context = canvas.getContext('2d');
	    _pixelRatio = (function() {
	      var devicePixelRatio = Konva.window.devicePixelRatio || 1,
	        backingStoreRatio =
	          context.webkitBackingStorePixelRatio ||
	          context.mozBackingStorePixelRatio ||
	          context.msBackingStorePixelRatio ||
	          context.oBackingStorePixelRatio ||
	          context.backingStorePixelRatio ||
	          1;
	      return devicePixelRatio / backingStoreRatio;
	    })();
	    return _pixelRatio;
	  }
	
	  /**
	     * Canvas Renderer constructor
	     * @constructor
	     * @abstract
	     * @memberof Konva
	     * @param {Object} config
	     * @param {Number} config.width
	     * @param {Number} config.height
	     * @param {Number} config.pixelRatio KonvaJS automatically handles pixel ratio adjustments in order to render crisp drawings
	     *  on all devices. Most desktops, low end tablets, and low end phones, have device pixel ratios
	     *  of 1.  Some high end tablets and phones, like iPhones and iPads (not the mini) have a device pixel ratio
	     *  of 2.  Some Macbook Pros, and iMacs also have a device pixel ratio of 2.  Some high end Android devices have pixel
	     *  ratios of 2 or 3.  Some browsers like Firefox allow you to configure the pixel ratio of the viewport.  Unless otherwise
	     *  specified, the pixel ratio will be defaulted to the actual device pixel ratio.  You can override the device pixel
	     *  ratio for special situations, or, if you don't want the pixel ratio to be taken into account, you can set it to 1.
	     */
	  Konva.Canvas = function(config) {
	    this.init(config);
	  };
	
	  Konva.Canvas.prototype = {
	    init: function(config) {
	      var conf = config || {};
	
	      var pixelRatio =
	        conf.pixelRatio || Konva.pixelRatio || getDevicePixelRatio();
	
	      this.pixelRatio = pixelRatio;
	      this._canvas = Konva.Util.createCanvasElement();
	
	      // set inline styles
	      this._canvas.style.padding = 0;
	      this._canvas.style.margin = 0;
	      this._canvas.style.border = 0;
	      this._canvas.style.background = 'transparent';
	      this._canvas.style.position = 'absolute';
	      this._canvas.style.top = 0;
	      this._canvas.style.left = 0;
	    },
	    /**
	         * get canvas context
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @returns {CanvasContext} context
	         */
	    getContext: function() {
	      return this.context;
	    },
	    /**
	         * get pixel ratio
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @returns {Number} pixel ratio
	         */
	    getPixelRatio: function() {
	      return this.pixelRatio;
	    },
	    /**
	         * get pixel ratio
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @param {Number} pixelRatio KonvaJS automatically handles pixel ratio adustments in order to render crisp drawings
	         *  on all devices. Most desktops, low end tablets, and low end phones, have device pixel ratios
	         *  of 1.  Some high end tablets and phones, like iPhones and iPads have a device pixel ratio
	         *  of 2.  Some Macbook Pros, and iMacs also have a device pixel ratio of 2.  Some high end Android devices have pixel
	         *  ratios of 2 or 3.  Some browsers like Firefox allow you to configure the pixel ratio of the viewport.  Unless otherwise
	         *  specificed, the pixel ratio will be defaulted to the actual device pixel ratio.  You can override the device pixel
	         *  ratio for special situations, or, if you don't want the pixel ratio to be taken into account, you can set it to 1.
	         */
	    setPixelRatio: function(pixelRatio) {
	      var previousRatio = this.pixelRatio;
	      this.pixelRatio = pixelRatio;
	      this.setSize(
	        this.getWidth() / previousRatio,
	        this.getHeight() / previousRatio
	      );
	    },
	    /**
	         * set width
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @param {Number} width
	         */
	    setWidth: function(width) {
	      // take into account pixel ratio
	      this.width = this._canvas.width = width * this.pixelRatio;
	      this._canvas.style.width = width + 'px';
	
	      var pixelRatio = this.pixelRatio,
	        _context = this.getContext()._context;
	      _context.scale(pixelRatio, pixelRatio);
	    },
	    /**
	         * set height
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @param {Number} height
	         */
	    setHeight: function(height) {
	      // take into account pixel ratio
	      this.height = this._canvas.height = height * this.pixelRatio;
	      this._canvas.style.height = height + 'px';
	      var pixelRatio = this.pixelRatio,
	        _context = this.getContext()._context;
	      _context.scale(pixelRatio, pixelRatio);
	    },
	    /**
	         * get width
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @returns {Number} width
	         */
	    getWidth: function() {
	      return this.width;
	    },
	    /**
	         * get height
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @returns {Number} height
	         */
	    getHeight: function() {
	      return this.height;
	    },
	    /**
	         * set size
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @param {Number} width
	         * @param {Number} height
	         */
	    setSize: function(width, height) {
	      this.setWidth(width);
	      this.setHeight(height);
	    },
	    /**
	         * to data url
	         * @method
	         * @memberof Konva.Canvas.prototype
	         * @param {String} mimeType
	         * @param {Number} quality between 0 and 1 for jpg mime types
	         * @returns {String} data url string
	         */
	    toDataURL: function(mimeType, quality) {
	      try {
	        // If this call fails (due to browser bug, like in Firefox 3.6),
	        // then revert to previous no-parameter image/png behavior
	        return this._canvas.toDataURL(mimeType, quality);
	      } catch (e) {
	        try {
	          return this._canvas.toDataURL();
	        } catch (err) {
	          Konva.Util.warn('Unable to get data URL. ' + err.message);
	          return '';
	        }
	      }
	    }
	  };
	
	  Konva.SceneCanvas = function(config) {
	    var conf = config || {};
	    var width = conf.width || 0,
	      height = conf.height || 0;
	
	    Konva.Canvas.call(this, conf);
	    this.context = new Konva.SceneContext(this);
	    this.setSize(width, height);
	  };
	
	  Konva.Util.extend(Konva.SceneCanvas, Konva.Canvas);
	
	  Konva.HitCanvas = function(config) {
	    var conf = config || {};
	    var width = conf.width || 0,
	      height = conf.height || 0;
	
	    Konva.Canvas.call(this, conf);
	    this.context = new Konva.HitContext(this);
	    this.setSize(width, height);
	    this.hitCanvas = true;
	  };
	  Konva.Util.extend(Konva.HitCanvas, Konva.Canvas);
	})();


/***/ }),
/* 338 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';
	  var COMMA = ',',
	    OPEN_PAREN = '(',
	    CLOSE_PAREN = ')',
	    OPEN_PAREN_BRACKET = '([',
	    CLOSE_BRACKET_PAREN = '])',
	    SEMICOLON = ';',
	    DOUBLE_PAREN = '()',
	    // EMPTY_STRING = '',
	    EQUALS = '=',
	    // SET = 'set',
	    CONTEXT_METHODS = [
	      'arc',
	      'arcTo',
	      'beginPath',
	      'bezierCurveTo',
	      'clearRect',
	      'clip',
	      'closePath',
	      'createLinearGradient',
	      'createPattern',
	      'createRadialGradient',
	      'drawImage',
	      'fill',
	      'fillText',
	      'getImageData',
	      'createImageData',
	      'lineTo',
	      'moveTo',
	      'putImageData',
	      'quadraticCurveTo',
	      'rect',
	      'restore',
	      'rotate',
	      'save',
	      'scale',
	      'setLineDash',
	      'setTransform',
	      'stroke',
	      'strokeText',
	      'transform',
	      'translate'
	    ];
	
	  var CONTEXT_PROPERTIES = [
	    'fillStyle',
	    'strokeStyle',
	    'shadowColor',
	    'shadowBlur',
	    'shadowOffsetX',
	    'shadowOffsetY',
	    'lineCap',
	    'lineDashOffset',
	    'lineJoin',
	    'lineWidth',
	    'miterLimit',
	    'font',
	    'textAlign',
	    'textBaseline',
	    'globalAlpha',
	    'globalCompositeOperation'
	  ];
	
	  /**
	     * Canvas Context constructor
	     * @constructor
	     * @abstract
	     * @memberof Konva
	     */
	  Konva.Context = function(canvas) {
	    this.init(canvas);
	  };
	
	  Konva.Context.prototype = {
	    init: function(canvas) {
	      this.canvas = canvas;
	      this._context = canvas._canvas.getContext('2d');
	
	      if (Konva.enableTrace) {
	        this.traceArr = [];
	        this._enableTrace();
	      }
	    },
	    /**
	         * fill shape
	         * @method
	         * @memberof Konva.Context.prototype
	         * @param {Konva.Shape} shape
	         */
	    fillShape: function(shape) {
	      if (shape.getFillEnabled()) {
	        this._fill(shape);
	      }
	    },
	    /**
	         * stroke shape
	         * @method
	         * @memberof Konva.Context.prototype
	         * @param {Konva.Shape} shape
	         */
	    strokeShape: function(shape) {
	      if (shape.getStrokeEnabled()) {
	        this._stroke(shape);
	      }
	    },
	    /**
	         * fill then stroke
	         * @method
	         * @memberof Konva.Context.prototype
	         * @param {Konva.Shape} shape
	         */
	    fillStrokeShape: function(shape) {
	      var fillEnabled = shape.getFillEnabled();
	      if (fillEnabled) {
	        this._fill(shape);
	      }
	      if (shape.getStrokeEnabled()) {
	        this._stroke(shape);
	      }
	    },
	    /**
	         * get context trace if trace is enabled
	         * @method
	         * @memberof Konva.Context.prototype
	         * @param {Boolean} relaxed if false, return strict context trace, which includes method names, method parameters
	         *  properties, and property values.  If true, return relaxed context trace, which only returns method names and
	         *  properites.
	         * @returns {String}
	         */
	    getTrace: function(relaxed) {
	      var traceArr = this.traceArr,
	        len = traceArr.length,
	        str = '',
	        n,
	        trace,
	        method,
	        args;
	
	      for (n = 0; n < len; n++) {
	        trace = traceArr[n];
	        method = trace.method;
	
	        // methods
	        if (method) {
	          args = trace.args;
	          str += method;
	          if (relaxed) {
	            str += DOUBLE_PAREN;
	          } else {
	            if (Konva.Util._isArray(args[0])) {
	              str +=
	                OPEN_PAREN_BRACKET + args.join(COMMA) + CLOSE_BRACKET_PAREN;
	            } else {
	              str += OPEN_PAREN + args.join(COMMA) + CLOSE_PAREN;
	            }
	          }
	        } else {
	          // properties
	          str += trace.property;
	          if (!relaxed) {
	            str += EQUALS + trace.val;
	          }
	        }
	
	        str += SEMICOLON;
	      }
	
	      return str;
	    },
	    /**
	         * clear trace if trace is enabled
	         * @method
	         * @memberof Konva.Context.prototype
	         */
	    clearTrace: function() {
	      this.traceArr = [];
	    },
	    _trace: function(str) {
	      var traceArr = this.traceArr, len;
	
	      traceArr.push(str);
	      len = traceArr.length;
	
	      if (len >= Konva.traceArrMax) {
	        traceArr.shift();
	      }
	    },
	    /**
	         * reset canvas context transform
	         * @method
	         * @memberof Konva.Context.prototype
	         */
	    reset: function() {
	      var pixelRatio = this.getCanvas().getPixelRatio();
	      this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
	    },
	    /**
	         * get canvas
	         * @method
	         * @memberof Konva.Context.prototype
	         * @returns {Konva.Canvas}
	         */
	    getCanvas: function() {
	      return this.canvas;
	    },
	    /**
	         * clear canvas
	         * @method
	         * @memberof Konva.Context.prototype
	         * @param {Object} [bounds]
	         * @param {Number} [bounds.x]
	         * @param {Number} [bounds.y]
	         * @param {Number} [bounds.width]
	         * @param {Number} [bounds.height]
	         */
	    clear: function(bounds) {
	      var canvas = this.getCanvas();
	
	      if (bounds) {
	        this.clearRect(
	          bounds.x || 0,
	          bounds.y || 0,
	          bounds.width || 0,
	          bounds.height || 0
	        );
	      } else {
	        this.clearRect(
	          0,
	          0,
	          canvas.getWidth() / canvas.pixelRatio,
	          canvas.getHeight() / canvas.pixelRatio
	        );
	      }
	    },
	    _applyLineCap: function(shape) {
	      var lineCap = shape.getLineCap();
	      if (lineCap) {
	        this.setAttr('lineCap', lineCap);
	      }
	    },
	    _applyOpacity: function(shape) {
	      var absOpacity = shape.getAbsoluteOpacity();
	      if (absOpacity !== 1) {
	        this.setAttr('globalAlpha', absOpacity);
	      }
	    },
	    _applyLineJoin: function(shape) {
	      var lineJoin = shape.getLineJoin();
	      if (lineJoin) {
	        this.setAttr('lineJoin', lineJoin);
	      }
	    },
	    setAttr: function(attr, val) {
	      this._context[attr] = val;
	    },
	
	    // context pass through methods
	    arc: function() {
	      var a = arguments;
	      this._context.arc(a[0], a[1], a[2], a[3], a[4], a[5]);
	    },
	    beginPath: function() {
	      this._context.beginPath();
	    },
	    bezierCurveTo: function() {
	      var a = arguments;
	      this._context.bezierCurveTo(a[0], a[1], a[2], a[3], a[4], a[5]);
	    },
	    clearRect: function() {
	      var a = arguments;
	      this._context.clearRect(a[0], a[1], a[2], a[3]);
	    },
	    clip: function() {
	      this._context.clip();
	    },
	    closePath: function() {
	      this._context.closePath();
	    },
	    createImageData: function() {
	      var a = arguments;
	      if (a.length === 2) {
	        return this._context.createImageData(a[0], a[1]);
	      } else if (a.length === 1) {
	        return this._context.createImageData(a[0]);
	      }
	    },
	    createLinearGradient: function() {
	      var a = arguments;
	      return this._context.createLinearGradient(a[0], a[1], a[2], a[3]);
	    },
	    createPattern: function() {
	      var a = arguments;
	      return this._context.createPattern(a[0], a[1]);
	    },
	    createRadialGradient: function() {
	      var a = arguments;
	      return this._context.createRadialGradient(
	        a[0],
	        a[1],
	        a[2],
	        a[3],
	        a[4],
	        a[5]
	      );
	    },
	    drawImage: function() {
	      var a = arguments, _context = this._context;
	
	      if (a.length === 3) {
	        _context.drawImage(a[0], a[1], a[2]);
	      } else if (a.length === 5) {
	        _context.drawImage(a[0], a[1], a[2], a[3], a[4]);
	      } else if (a.length === 9) {
	        _context.drawImage(
	          a[0],
	          a[1],
	          a[2],
	          a[3],
	          a[4],
	          a[5],
	          a[6],
	          a[7],
	          a[8]
	        );
	      }
	    },
	    isPointInPath: function(x, y) {
	      return this._context.isPointInPath(x, y);
	    },
	    fill: function() {
	      this._context.fill();
	    },
	    fillRect: function(x, y, width, height) {
	      this._context.fillRect(x, y, width, height);
	    },
	    strokeRect: function(x, y, width, height) {
	      this._context.strokeRect(x, y, width, height);
	    },
	    fillText: function() {
	      var a = arguments;
	      this._context.fillText(a[0], a[1], a[2]);
	    },
	    measureText: function(text) {
	      return this._context.measureText(text);
	    },
	    getImageData: function() {
	      var a = arguments;
	      return this._context.getImageData(a[0], a[1], a[2], a[3]);
	    },
	    lineTo: function() {
	      var a = arguments;
	      this._context.lineTo(a[0], a[1]);
	    },
	    moveTo: function() {
	      var a = arguments;
	      this._context.moveTo(a[0], a[1]);
	    },
	    rect: function() {
	      var a = arguments;
	      this._context.rect(a[0], a[1], a[2], a[3]);
	    },
	    putImageData: function() {
	      var a = arguments;
	      this._context.putImageData(a[0], a[1], a[2]);
	    },
	    quadraticCurveTo: function() {
	      var a = arguments;
	      this._context.quadraticCurveTo(a[0], a[1], a[2], a[3]);
	    },
	    restore: function() {
	      this._context.restore();
	    },
	    rotate: function() {
	      var a = arguments;
	      this._context.rotate(a[0]);
	    },
	    save: function() {
	      this._context.save();
	    },
	    scale: function() {
	      var a = arguments;
	      this._context.scale(a[0], a[1]);
	    },
	    setLineDash: function() {
	      var a = arguments, _context = this._context;
	
	      // works for Chrome and IE11
	      if (this._context.setLineDash) {
	        _context.setLineDash(a[0]);
	      } else if ('mozDash' in _context) {
	        // verified that this works in firefox
	        _context.mozDash = a[0];
	      } else if ('webkitLineDash' in _context) {
	        // does not currently work for Safari
	        _context.webkitLineDash = a[0];
	      }
	
	      // no support for IE9 and IE10
	    },
	    getLineDash: function() {
	      return this._context.getLineDash();
	    },
	    setTransform: function() {
	      var a = arguments;
	      this._context.setTransform(a[0], a[1], a[2], a[3], a[4], a[5]);
	    },
	    stroke: function() {
	      this._context.stroke();
	    },
	    strokeText: function() {
	      var a = arguments;
	      this._context.strokeText(a[0], a[1], a[2]);
	    },
	    transform: function() {
	      var a = arguments;
	      this._context.transform(a[0], a[1], a[2], a[3], a[4], a[5]);
	    },
	    translate: function() {
	      var a = arguments;
	      this._context.translate(a[0], a[1]);
	    },
	    _enableTrace: function() {
	      var that = this,
	        len = CONTEXT_METHODS.length,
	        _simplifyArray = Konva.Util._simplifyArray,
	        origSetter = this.setAttr,
	        n,
	        args;
	
	      // to prevent creating scope function at each loop
	      var func = function(methodName) {
	        var origMethod = that[methodName], ret;
	
	        that[methodName] = function() {
	          args = _simplifyArray(Array.prototype.slice.call(arguments, 0));
	          ret = origMethod.apply(that, arguments);
	
	          that._trace({
	            method: methodName,
	            args: args
	          });
	
	          return ret;
	        };
	      };
	      // methods
	      for (n = 0; n < len; n++) {
	        func(CONTEXT_METHODS[n]);
	      }
	
	      // attrs
	      that.setAttr = function() {
	        origSetter.apply(that, arguments);
	        var prop = arguments[0];
	        var val = arguments[1];
	        if (
	          prop === 'shadowOffsetX' ||
	          prop === 'shadowOffsetY' ||
	          prop === 'shadowBlur'
	        ) {
	          val = val / this.canvas.getPixelRatio();
	        }
	        that._trace({
	          property: prop,
	          val: val
	        });
	      };
	    }
	  };
	
	  CONTEXT_PROPERTIES.forEach(function(prop) {
	    Object.defineProperty(Konva.Context.prototype, prop, {
	      get: function() {
	        return this._context[prop];
	      },
	      set: function(val) {
	        this._context[prop] = val;
	      }
	    });
	  });
	
	  Konva.SceneContext = function(canvas) {
	    Konva.Context.call(this, canvas);
	  };
	
	  Konva.SceneContext.prototype = {
	    _fillColor: function(shape) {
	      var fill = shape.fill();
	
	      this.setAttr('fillStyle', fill);
	      shape._fillFunc(this);
	    },
	    _fillPattern: function(shape) {
	      var fillPatternX = shape.getFillPatternX(),
	        fillPatternY = shape.getFillPatternY(),
	        fillPatternScale = shape.getFillPatternScale(),
	        fillPatternRotation = Konva.getAngle(shape.getFillPatternRotation()),
	        fillPatternOffset = shape.getFillPatternOffset();
	
	      if (fillPatternX || fillPatternY) {
	        this.translate(fillPatternX || 0, fillPatternY || 0);
	      }
	      if (fillPatternRotation) {
	        this.rotate(fillPatternRotation);
	      }
	      if (fillPatternScale) {
	        this.scale(fillPatternScale.x, fillPatternScale.y);
	      }
	      if (fillPatternOffset) {
	        this.translate(-1 * fillPatternOffset.x, -1 * fillPatternOffset.y);
	      }
	
	      this.setAttr(
	        'fillStyle',
	        this.createPattern(
	          shape.getFillPatternImage(),
	          shape.getFillPatternRepeat() || 'repeat'
	        )
	      );
	      this.fill();
	    },
	    _fillLinearGradient: function(shape) {
	      var start = shape.getFillLinearGradientStartPoint(),
	        end = shape.getFillLinearGradientEndPoint(),
	        colorStops = shape.getFillLinearGradientColorStops(),
	        grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
	
	      if (colorStops) {
	        // build color stops
	        for (var n = 0; n < colorStops.length; n += 2) {
	          grd.addColorStop(colorStops[n], colorStops[n + 1]);
	        }
	        this.setAttr('fillStyle', grd);
	        shape._fillFunc(this);
	      }
	    },
	    _fillRadialGradient: function(shape) {
	      var start = shape.getFillRadialGradientStartPoint(),
	        end = shape.getFillRadialGradientEndPoint(),
	        startRadius = shape.getFillRadialGradientStartRadius(),
	        endRadius = shape.getFillRadialGradientEndRadius(),
	        colorStops = shape.getFillRadialGradientColorStops(),
	        grd = this.createRadialGradient(
	          start.x,
	          start.y,
	          startRadius,
	          end.x,
	          end.y,
	          endRadius
	        );
	
	      // build color stops
	      for (var n = 0; n < colorStops.length; n += 2) {
	        grd.addColorStop(colorStops[n], colorStops[n + 1]);
	      }
	      this.setAttr('fillStyle', grd);
	      this.fill();
	    },
	    _fill: function(shape) {
	      var hasColor = shape.fill(),
	        hasPattern = shape.getFillPatternImage(),
	        hasLinearGradient = shape.getFillLinearGradientColorStops(),
	        hasRadialGradient = shape.getFillRadialGradientColorStops(),
	        fillPriority = shape.getFillPriority();
	
	      // priority fills
	      if (hasColor && fillPriority === 'color') {
	        this._fillColor(shape);
	      } else if (hasPattern && fillPriority === 'pattern') {
	        this._fillPattern(shape);
	      } else if (hasLinearGradient && fillPriority === 'linear-gradient') {
	        this._fillLinearGradient(shape);
	      } else if (hasRadialGradient && fillPriority === 'radial-gradient') {
	        this._fillRadialGradient(shape);
	      } else if (hasColor) {
	        // now just try and fill with whatever is available
	        this._fillColor(shape);
	      } else if (hasPattern) {
	        this._fillPattern(shape);
	      } else if (hasLinearGradient) {
	        this._fillLinearGradient(shape);
	      } else if (hasRadialGradient) {
	        this._fillRadialGradient(shape);
	      }
	    },
	    _stroke: function(shape) {
	      var dash = shape.dash(),
	        // ignore strokeScaleEnabled for Text
	        strokeScaleEnabled =
	          shape.getStrokeScaleEnabled() || shape instanceof Konva.Text;
	
	      if (shape.hasStroke()) {
	        if (!strokeScaleEnabled) {
	          this.save();
	          this.setTransform(1, 0, 0, 1, 0, 0);
	        }
	
	        this._applyLineCap(shape);
	        if (dash && shape.dashEnabled()) {
	          this.setLineDash(dash);
	          this.setAttr('lineDashOffset', shape.dashOffset());
	        }
	
	        this.setAttr('lineWidth', shape.strokeWidth());
	        this.setAttr('strokeStyle', shape.stroke());
	
	        if (!shape.getShadowForStrokeEnabled()) {
	          this.setAttr('shadowColor', 'rgba(0,0,0,0)');
	        }
	        shape._strokeFunc(this);
	
	        if (!strokeScaleEnabled) {
	          this.restore();
	        }
	      }
	    },
	    _applyShadow: function(shape) {
	      var util = Konva.Util,
	        color = util.get(shape.getShadowRGBA(), 'black'),
	        blur = util.get(shape.getShadowBlur(), 5),
	        offset = util.get(shape.getShadowOffset(), {
	          x: 0,
	          y: 0
	        }),
	        // TODO: get this info from transform??
	        scale = shape.getAbsoluteScale(),
	        ratio = this.canvas.getPixelRatio(),
	        scaleX = scale.x * ratio,
	        scaleY = scale.y * ratio;
	
	      this.setAttr('shadowColor', color);
	      this.setAttr(
	        'shadowBlur',
	        blur * ratio * Math.min(Math.abs(scaleX), Math.abs(scaleY))
	      );
	      this.setAttr('shadowOffsetX', offset.x * scaleX);
	      this.setAttr('shadowOffsetY', offset.y * scaleY);
	    },
	    _applyGlobalCompositeOperation: function(shape) {
	      var globalCompositeOperation = shape.getGlobalCompositeOperation();
	      if (globalCompositeOperation !== 'source-over') {
	        this.setAttr('globalCompositeOperation', globalCompositeOperation);
	      }
	    }
	  };
	  Konva.Util.extend(Konva.SceneContext, Konva.Context);
	
	  Konva.HitContext = function(canvas) {
	    Konva.Context.call(this, canvas);
	  };
	
	  Konva.HitContext.prototype = {
	    _fill: function(shape) {
	      this.save();
	      this.setAttr('fillStyle', shape.colorKey);
	      shape._fillFuncHit(this);
	      this.restore();
	    },
	    _stroke: function(shape) {
	      if (shape.hasStroke() && shape.strokeHitEnabled()) {
	        // ignore strokeScaleEnabled for Text
	        var strokeScaleEnabled =
	          shape.getStrokeScaleEnabled() || shape instanceof Konva.Text;
	        if (!strokeScaleEnabled) {
	          this.save();
	          this.setTransform(1, 0, 0, 1, 0, 0);
	        }
	        this._applyLineCap(shape);
	        this.setAttr('lineWidth', shape.strokeWidth());
	        this.setAttr('strokeStyle', shape.colorKey);
	        shape._strokeFuncHit(this);
	        if (!strokeScaleEnabled) {
	          this.restore();
	        }
	      }
	    }
	  };
	  Konva.Util.extend(Konva.HitContext, Konva.Context);
	})();


/***/ }),
/* 339 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';
	  // CONSTANTS
	  var GET = 'get', SET = 'set';
	
	  Konva.Factory = {
	    addGetterSetter: function(constructor, attr, def, validator, after) {
	      this.addGetter(constructor, attr, def);
	      this.addSetter(constructor, attr, validator, after);
	      this.addOverloadedGetterSetter(constructor, attr);
	    },
	    addGetter: function(constructor, attr, def) {
	      var method = GET + Konva.Util._capitalize(attr);
	
	      constructor.prototype[method] = function() {
	        var val = this.attrs[attr];
	        return val === undefined ? def : val;
	      };
	    },
	    addSetter: function(constructor, attr, validator, after) {
	      var method = SET + Konva.Util._capitalize(attr);
	
	      constructor.prototype[method] = function(val) {
	        if (validator) {
	          val = validator.call(this, val);
	        }
	
	        this._setAttr(attr, val);
	
	        if (after) {
	          after.call(this);
	        }
	
	        return this;
	      };
	    },
	    addComponentsGetterSetter: function(
	      constructor,
	      attr,
	      components,
	      validator,
	      after
	    ) {
	      var len = components.length,
	        capitalize = Konva.Util._capitalize,
	        getter = GET + capitalize(attr),
	        setter = SET + capitalize(attr),
	        n,
	        component;
	
	      // getter
	      constructor.prototype[getter] = function() {
	        var ret = {};
	
	        for (n = 0; n < len; n++) {
	          component = components[n];
	          ret[component] = this.getAttr(attr + capitalize(component));
	        }
	
	        return ret;
	      };
	
	      // setter
	      constructor.prototype[setter] = function(val) {
	        var oldVal = this.attrs[attr], key;
	
	        if (validator) {
	          val = validator.call(this, val);
	        }
	
	        for (key in val) {
	          if (!val.hasOwnProperty(key)) {
	            continue;
	          }
	          this._setAttr(attr + capitalize(key), val[key]);
	        }
	
	        this._fireChangeEvent(attr, oldVal, val);
	
	        if (after) {
	          after.call(this);
	        }
	
	        return this;
	      };
	
	      this.addOverloadedGetterSetter(constructor, attr);
	    },
	    addOverloadedGetterSetter: function(constructor, attr) {
	      var capitalizedAttr = Konva.Util._capitalize(attr),
	        setter = SET + capitalizedAttr,
	        getter = GET + capitalizedAttr;
	
	      constructor.prototype[attr] = function() {
	        // setting
	        if (arguments.length) {
	          this[setter](arguments[0]);
	          return this;
	        }
	        // getting
	        return this[getter]();
	      };
	    },
	    addDeprecatedGetterSetter: function(constructor, attr, def, validator) {
	      var method = GET + Konva.Util._capitalize(attr);
	      var message =
	        attr +
	        ' property is deprecated and will be removed soon. Look at Konva change log for more information.';
	      constructor.prototype[method] = function() {
	        Konva.Util.error(message);
	        var val = this.attrs[attr];
	        return val === undefined ? def : val;
	      };
	      this.addSetter(constructor, attr, validator, function() {
	        Konva.Util.error(message);
	      });
	      this.addOverloadedGetterSetter(constructor, attr);
	    },
	    backCompat: function(constructor, methods) {
	      Konva.Util.each(methods, function(oldMethodName, newMethodName) {
	        var method = constructor.prototype[newMethodName];
	        constructor.prototype[oldMethodName] = function() {
	          method.apply(this, arguments);
	          Konva.Util.error(
	            oldMethodName +
	              ' method is deprecated and will be removed soon. Use ' +
	              newMethodName +
	              ' instead'
	          );
	        };
	      });
	    },
	    afterSetFilter: function() {
	      this._filterUpToDate = false;
	    }
	  };
	
	  Konva.Validators = {
	    /**
	         * @return {number}
	         */
	    RGBComponent: function(val) {
	      if (val > 255) {
	        return 255;
	      } else if (val < 0) {
	        return 0;
	      }
	      return Math.round(val);
	    },
	    alphaComponent: function(val) {
	      if (val > 1) {
	        return 1;
	      } else if (val < 0.0001) {
	        // chrome does not honor alpha values of 0
	        return 0.0001;
	      }
	
	      return val;
	    }
	  };
	})();


/***/ }),
/* 340 */
/***/ (function(module, exports) {

	(function(Konva) {
	  'use strict';
	  // CONSTANTS
	  var ABSOLUTE_OPACITY = 'absoluteOpacity',
	    ABSOLUTE_TRANSFORM = 'absoluteTransform',
	    ABSOLUTE_SCALE = 'absoluteScale',
	    CHANGE = 'Change',
	    CHILDREN = 'children',
	    DOT = '.',
	    EMPTY_STRING = '',
	    GET = 'get',
	    ID = 'id',
	    KONVA = 'konva',
	    LISTENING = 'listening',
	    MOUSEENTER = 'mouseenter',
	    MOUSELEAVE = 'mouseleave',
	    NAME = 'name',
	    SET = 'set',
	    SHAPE = 'Shape',
	    SPACE = ' ',
	    STAGE = 'stage',
	    TRANSFORM = 'transform',
	    UPPER_STAGE = 'Stage',
	    VISIBLE = 'visible',
	    CLONE_BLACK_LIST = ['id'],
	    TRANSFORM_CHANGE_STR = [
	      'xChange.konva',
	      'yChange.konva',
	      'scaleXChange.konva',
	      'scaleYChange.konva',
	      'skewXChange.konva',
	      'skewYChange.konva',
	      'rotationChange.konva',
	      'offsetXChange.konva',
	      'offsetYChange.konva',
	      'transformsEnabledChange.konva'
	    ].join(SPACE),
	    SCALE_CHANGE_STR = ['scaleXChange.konva', 'scaleYChange.konva'].join(SPACE);
	
	  /**
	     * Node constructor. Nodes are entities that can be transformed, layered,
	     * and have bound events. The stage, layers, groups, and shapes all extend Node.
	     * @constructor
	     * @memberof Konva
	     * @abstract
	     * @param {Object} config
	     * @@nodeParams
	     */
	  Konva.Node = function(config) {
	    this._init(config);
	  };
	
	  Konva.Util.addMethods(Konva.Node, {
	    _init: function(config) {
	      var that = this;
	      this._id = Konva.idCounter++;
	      this.eventListeners = {};
	      this.attrs = {};
	      this._cache = {};
	      this._filterUpToDate = false;
	      this._isUnderCache = false;
	      this.setAttrs(config);
	
	      // event bindings for cache handling
	      this.on(TRANSFORM_CHANGE_STR, function() {
	        this._clearCache(TRANSFORM);
	        that._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
	      });
	
	      this.on(SCALE_CHANGE_STR, function() {
	        that._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
	      });
	
	      this.on('visibleChange.konva', function() {
	        that._clearSelfAndDescendantCache(VISIBLE);
	      });
	      this.on('listeningChange.konva', function() {
	        that._clearSelfAndDescendantCache(LISTENING);
	      });
	      this.on('opacityChange.konva', function() {
	        that._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
	      });
	    },
	    _clearCache: function(attr) {
	      if (attr) {
	        delete this._cache[attr];
	      } else {
	        this._cache = {};
	      }
	    },
	    _getCache: function(attr, privateGetter) {
	      var cache = this._cache[attr];
	
	      // if not cached, we need to set it using the private getter method.
	      if (cache === undefined) {
	        this._cache[attr] = privateGetter.call(this);
	      }
	
	      return this._cache[attr];
	    },
	    /*
	         * when the logic for a cached result depends on ancestor propagation, use this
	         * method to clear self and children cache
	         */
	    _clearSelfAndDescendantCache: function(attr) {
	      this._clearCache(attr);
	
	      if (this.children) {
	        this.getChildren().each(function(node) {
	          node._clearSelfAndDescendantCache(attr);
	        });
	      }
	    },
	    /**
	        * clear cached canvas
	        * @method
	        * @memberof Konva.Node.prototype
	        * @returns {Konva.Node}
	        * @example
	        * node.clearCache();
	        */
	    clearCache: function() {
	      delete this._cache.canvas;
	      this._filterUpToDate = false;
	      return this;
	    },
	    /**
	        *  cache node to improve drawing performance, apply filters, or create more accurate
	        *  hit regions. For all basic shapes size of cache canvas will be automatically detected.
	        *  If you need to cache your custom `Konva.Shape` instance you have to pass shape's bounding box
	        *  properties. Look at [link to demo page](link to demo page) for more information.
	        * @method
	        * @memberof Konva.Node.prototype
	        * @param {Object} [config]
	        * @param {Number} [config.x]
	        * @param {Number} [config.y]
	        * @param {Number} [config.width]
	        * @param {Number} [config.height]
	        * @param {Number} [config.offset]  increase canvas size by `offset` pixel in all directions.
	        * @param {Boolean} [config.drawBorder] when set to true, a red border will be drawn around the cached
	        *  region for debugging purposes
	        * @param {Number} [config.pixelRatio] change quality (or pixel ratio) of cached image. pixelRatio = 2 will produce 2x sized cache.
	        * @returns {Konva.Node}
	        * @example
	        * // cache a shape with the x,y position of the bounding box at the center and
	        * // the width and height of the bounding box equal to the width and height of
	        * // the shape obtained from shape.width() and shape.height()
	        * image.cache();
	        *
	        * // cache a node and define the bounding box position and size
	        * node.cache({
	        *   x: -30,
	        *   y: -30,
	        *   width: 100,
	        *   height: 200
	        * });
	        *
	        * // cache a node and draw a red border around the bounding box
	        * // for debugging purposes
	        * node.cache({
	        *   x: -30,
	        *   y: -30,
	        *   width: 100,
	        *   height: 200,
	        *   offset : 10,
	        *   drawBorder: true
	        * });
	        */
	    cache: function(config) {
	      var conf = config || {},
	        rect = this.getClientRect({
	          skipTransform: true,
	          relativeTo: this.getParent()
	        }),
	        width = conf.width || rect.width,
	        height = conf.height || rect.height,
	        pixelRatio = conf.pixelRatio,
	        x = conf.x || rect.x,
	        y = conf.y || rect.y,
	        offset = conf.offset || 0,
	        drawBorder = conf.drawBorder || false;
	
	      if (!width || !height) {
	        // make throw async, because we don't need to stop funcion
	        setTimeout(function() {
	          Konva.Util.throw(
	            'Width or height of caching configuration equals 0. Caching is ignored.'
	          );
	        });
	        return;
	      }
	
	      width += offset * 2;
	      height += offset * 2;
	
	      x -= offset;
	      y -= offset;
	
	      var cachedSceneCanvas = new Konva.SceneCanvas({
	          pixelRatio: pixelRatio,
	          width: width,
	          height: height
	        }),
	        cachedFilterCanvas = new Konva.SceneCanvas({
	          pixelRatio: pixelRatio,
	          width: width,
	          height: height
	        }),
	        cachedHitCanvas = new Konva.HitCanvas({
	          pixelRatio: 1,
	          width: width,
	          height: height
	        }),
	        sceneContext = cachedSceneCanvas.getContext(),
	        hitContext = cachedHitCanvas.getContext();
	
	      cachedHitCanvas.isCache = true;
	
	      this.clearCache();
	
	      sceneContext.save();
	      hitContext.save();
	
	      sceneContext.translate(-x, -y);
	      hitContext.translate(-x, -y);
	
	      // extra flag to skip on getAbsolute opacity calc
	      this._isUnderCache = true;
	      this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
	      this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
	
	      this.drawScene(cachedSceneCanvas, this, true);
	      this.drawHit(cachedHitCanvas, this, true);
	      this._isUnderCache = false;
	
	      sceneContext.restore();
	      hitContext.restore();
	
	      // this will draw a red border around the cached box for
	      // debugging purposes
	      if (drawBorder) {
	        sceneContext.save();
	        sceneContext.beginPath();
	        sceneContext.rect(0, 0, width, height);
	        sceneContext.closePath();
	        sceneContext.setAttr('strokeStyle', 'red');
	        sceneContext.setAttr('lineWidth', 5);
	        sceneContext.stroke();
	        sceneContext.restore();
	      }
	
	      this._cache.canvas = {
	        scene: cachedSceneCanvas,
	        filter: cachedFilterCanvas,
	        hit: cachedHitCanvas,
	        x: x,
	        y: y
	      };
	
	      return this;
	    },
	    /**
	         * Return client rectangle {x, y, width, height} of node. This rectangle also include all styling (strokes, shadows, etc).
	         * The rectangle position is relative to parent container.
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Object} config
	         * @param {Boolean} [config.skipTransform] should we apply transform to node for calculating rect?
	         * @param {Object} [config.relativeTo] calculate client rect relative to one of the parents
	         * @returns {Object} rect with {x, y, width, height} properties
	         * @example
	         * var rect = new Konva.Rect({
	         *      width : 100,
	         *      height : 100,
	         *      x : 50,
	         *      y : 50,
	         *      strokeWidth : 4,
	         *      stroke : 'black',
	         *      offsetX : 50,
	         *      scaleY : 2
	         * });
	         *
	         * // get client rect without think off transformations (position, rotation, scale, offset, etc)
	         * rect.getClientRect({ skipTransform: true});
	         * // returns {
	         * //     x : -2,   // two pixels for stroke / 2
	         * //     y : -2,
	         * //     width : 104, // increased by 4 for stroke
	         * //     height : 104
	         * //}
	         *
	         * // get client rect with transformation applied
	         * rect.getClientRect();
	         * // returns Object {x: -2, y: 46, width: 104, height: 208}
	         */
	    getClientRect: function() {
	      // abstract method
	      // redefine in Container and Shape
	      throw new Error('abstract "getClientRect" method call');
	    },
	    _transformedRect: function(rect, top) {
	      var points = [
	        { x: rect.x, y: rect.y },
	        { x: rect.x + rect.width, y: rect.y },
	        { x: rect.x + rect.width, y: rect.y + rect.height },
	        { x: rect.x, y: rect.y + rect.height }
	      ];
	      var minX, minY, maxX, maxY;
	      var trans = this.getAbsoluteTransform(top);
	      points.forEach(function(point) {
	        var transformed = trans.point(point);
	        if (minX === undefined) {
	          minX = maxX = transformed.x;
	          minY = maxY = transformed.y;
	        }
	        minX = Math.min(minX, transformed.x);
	        minY = Math.min(minY, transformed.y);
	        maxX = Math.max(maxX, transformed.x);
	        maxY = Math.max(maxY, transformed.y);
	      });
	      return {
	        x: minX,
	        y: minY,
	        width: maxX - minX,
	        height: maxY - minY
	      };
	    },
	    _drawCachedSceneCanvas: function(context) {
	      context.save();
	      context._applyOpacity(this);
	      context._applyGlobalCompositeOperation(this);
	      context.translate(this._cache.canvas.x, this._cache.canvas.y);
	
	      var cacheCanvas = this._getCachedSceneCanvas();
	      var ratio = cacheCanvas.pixelRatio;
	
	      context.drawImage(
	        cacheCanvas._canvas,
	        0,
	        0,
	        cacheCanvas.width / ratio,
	        cacheCanvas.height / ratio
	      );
	      context.restore();
	    },
	    _drawCachedHitCanvas: function(context) {
	      var cachedCanvas = this._cache.canvas,
	        hitCanvas = cachedCanvas.hit;
	      context.save();
	      context.translate(this._cache.canvas.x, this._cache.canvas.y);
	      context.drawImage(hitCanvas._canvas, 0, 0);
	      context.restore();
	    },
	    _getCachedSceneCanvas: function() {
	      var filters = this.filters(),
	        cachedCanvas = this._cache.canvas,
	        sceneCanvas = cachedCanvas.scene,
	        filterCanvas = cachedCanvas.filter,
	        filterContext = filterCanvas.getContext(),
	        len,
	        imageData,
	        n,
	        filter;
	
	      if (filters) {
	        if (!this._filterUpToDate) {
	          var ratio = sceneCanvas.pixelRatio;
	
	          try {
	            len = filters.length;
	            filterContext.clear();
	
	            // copy cached canvas onto filter context
	            filterContext.drawImage(
	              sceneCanvas._canvas,
	              0,
	              0,
	              sceneCanvas.getWidth() / ratio,
	              sceneCanvas.getHeight() / ratio
	            );
	            imageData = filterContext.getImageData(
	              0,
	              0,
	              filterCanvas.getWidth(),
	              filterCanvas.getHeight()
	            );
	
	            // apply filters to filter context
	            for (n = 0; n < len; n++) {
	              filter = filters[n];
	              if (typeof filter !== 'function') {
	                Konva.Util.error(
	                  'Filter should be type of function, but got ' +
	                    typeof filter +
	                    ' insted. Please check correct filters'
	                );
	                continue;
	              }
	              filter.call(this, imageData);
	              filterContext.putImageData(imageData, 0, 0);
	            }
	          } catch (e) {
	            Konva.Util.error('Unable to apply filter. ' + e.message);
	          }
	
	          this._filterUpToDate = true;
	        }
	
	        return filterCanvas;
	      }
	      return sceneCanvas;
	    },
	    /**
	         * bind events to the node. KonvaJS supports mouseover, mousemove,
	         *  mouseout, mouseenter, mouseleave, mousedown, mouseup, wheel, click, dblclick, touchstart, touchmove,
	         *  touchend, tap, dbltap, dragstart, dragmove, and dragend events. The Konva Stage supports
	         *  contentMouseover, contentMousemove, contentMouseout, contentMousedown, contentMouseup, contentWheel, contentContextmenu
	         *  contentClick, contentDblclick, contentTouchstart, contentTouchmove, contentTouchend, contentTap,
	         *  and contentDblTap.  Pass in a string of events delimmited by a space to bind multiple events at once
	         *  such as 'mousedown mouseup mousemove'. Include a namespace to bind an
	         *  event by name such as 'click.foobar'.
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} evtStr e.g. 'click', 'mousedown touchstart', 'mousedown.foo touchstart.foo'
	         * @param {Function} handler The handler function is passed an event object
	         * @returns {Konva.Node}
	         * @example
	         * // add click listener
	         * node.on('click', function() {
	         *   console.log('you clicked me!');
	         * });
	         *
	         * // get the target node
	         * node.on('click', function(evt) {
	         *   console.log(evt.target);
	         * });
	         *
	         * // stop event propagation
	         * node.on('click', function(evt) {
	         *   evt.cancelBubble = true;
	         * });
	         *
	         * // bind multiple listeners
	         * node.on('click touchstart', function() {
	         *   console.log('you clicked/touched me!');
	         * });
	         *
	         * // namespace listener
	         * node.on('click.foo', function() {
	         *   console.log('you clicked/touched me!');
	         * });
	         *
	         * // get the event type
	         * node.on('click tap', function(evt) {
	         *   var eventType = evt.type;
	         * });
	         *
	         * // get native event object
	         * node.on('click tap', function(evt) {
	         *   var nativeEvent = evt.evt;
	         * });
	         *
	         * // for change events, get the old and new val
	         * node.on('xChange', function(evt) {
	         *   var oldVal = evt.oldVal;
	         *   var newVal = evt.newVal;
	         * });
	         *
	         * // get event targets
	         * // with event delegations
	         * layer.on('click', 'Group', function(evt) {
	         *   var shape = evt.target;
	         *   var group = evtn.currentTarger;
	         * });
	         */
	    on: function(evtStr, handler) {
	      if (arguments.length === 3) {
	        return this._delegate.apply(this, arguments);
	      }
	      var events = evtStr.split(SPACE),
	        len = events.length,
	        n,
	        event,
	        parts,
	        baseEvent,
	        name;
	
	      /*
	             * loop through types and attach event listeners to
	             * each one.  eg. 'click mouseover.namespace mouseout'
	             * will create three event bindings
	             */
	      for (n = 0; n < len; n++) {
	        event = events[n];
	        parts = event.split(DOT);
	        baseEvent = parts[0];
	        name = parts[1] || EMPTY_STRING;
	
	        // create events array if it doesn't exist
	        if (!this.eventListeners[baseEvent]) {
	          this.eventListeners[baseEvent] = [];
	        }
	
	        this.eventListeners[baseEvent].push({
	          name: name,
	          handler: handler
	        });
	      }
	
	      return this;
	    },
	    /**
	         * remove event bindings from the node. Pass in a string of
	         *  event types delimmited by a space to remove multiple event
	         *  bindings at once such as 'mousedown mouseup mousemove'.
	         *  include a namespace to remove an event binding by name
	         *  such as 'click.foobar'. If you only give a name like '.foobar',
	         *  all events in that namespace will be removed.
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} evtStr e.g. 'click', 'mousedown touchstart', '.foobar'
	         * @returns {Konva.Node}
	         * @example
	         * // remove listener
	         * node.off('click');
	         *
	         * // remove multiple listeners
	         * node.off('click touchstart');
	         *
	         * // remove listener by name
	         * node.off('click.foo');
	         */
	    off: function(evtStr) {
	      var events = (evtStr || '').split(SPACE),
	        len = events.length,
	        n,
	        t,
	        event,
	        parts,
	        baseEvent,
	        name;
	
	      if (!evtStr) {
	        // remove all events
	        for (t in this.eventListeners) {
	          this._off(t);
	        }
	      }
	      for (n = 0; n < len; n++) {
	        event = events[n];
	        parts = event.split(DOT);
	        baseEvent = parts[0];
	        name = parts[1];
	
	        if (baseEvent) {
	          if (this.eventListeners[baseEvent]) {
	            this._off(baseEvent, name);
	          }
	        } else {
	          for (t in this.eventListeners) {
	            this._off(t, name);
	          }
	        }
	      }
	      return this;
	    },
	    // some event aliases for third party integration like HammerJS
	    dispatchEvent: function(evt) {
	      var e = {
	        target: this,
	        type: evt.type,
	        evt: evt
	      };
	      this.fire(evt.type, e);
	      return this;
	    },
	    addEventListener: function(type, handler) {
	      // we have to pass native event to handler
	      this.on(type, function(evt) {
	        handler.call(this, evt.evt);
	      });
	      return this;
	    },
	    removeEventListener: function(type) {
	      this.off(type);
	      return this;
	    },
	    // like node.on
	    _delegate: function(event, selector, handler) {
	      var stopNode = this;
	      this.on(event, function(evt) {
	        var targets = evt.target.findAncestors(selector, true, stopNode);
	        for (var i = 0; i < targets.length; i++) {
	          evt = Konva.Util.cloneObject(evt);
	          evt.currentTarget = targets[i];
	          handler.call(targets[i], evt);
	        }
	      });
	    },
	    /**
	         * remove self from parent, but don't destroy
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Node}
	         * @example
	         * node.remove();
	         */
	    remove: function() {
	      var parent = this.getParent();
	
	      if (parent && parent.children) {
	        parent.children.splice(this.index, 1);
	        parent._setChildrenIndices();
	        delete this.parent;
	      }
	
	      // every cached attr that is calculated via node tree
	      // traversal must be cleared when removing a node
	      this._clearSelfAndDescendantCache(STAGE);
	      this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
	      this._clearSelfAndDescendantCache(VISIBLE);
	      this._clearSelfAndDescendantCache(LISTENING);
	      this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
	
	      return this;
	    },
	    /**
	         * remove and destroy self
	         * @method
	         * @memberof Konva.Node.prototype
	         * @example
	         * node.destroy();
	         */
	    destroy: function() {
	      // remove from ids and names hashes
	      Konva._removeId(this.getId());
	
	      // remove all names
	      var names = (this.getName() || '').split(/\s/g);
	      for (var i = 0; i < names.length; i++) {
	        var subname = names[i];
	        Konva._removeName(subname, this._id);
	      }
	
	      this.remove();
	      return this;
	    },
	    /**
	         * get attr
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} attr
	         * @returns {Integer|String|Object|Array}
	         * @example
	         * var x = node.getAttr('x');
	         */
	    getAttr: function(attr) {
	      var method = GET + Konva.Util._capitalize(attr);
	      if (Konva.Util._isFunction(this[method])) {
	        return this[method]();
	      }
	      // otherwise get directly
	      return this.attrs[attr];
	    },
	    /**
	        * get ancestors
	        * @method
	        * @memberof Konva.Node.prototype
	        * @returns {Konva.Collection}
	        * @example
	        * shape.getAncestors().each(function(node) {
	        *   console.log(node.getId());
	        * })
	        */
	    getAncestors: function() {
	      var parent = this.getParent(),
	        ancestors = new Konva.Collection();
	
	      while (parent) {
	        ancestors.push(parent);
	        parent = parent.getParent();
	      }
	
	      return ancestors;
	    },
	    /**
	         * get attrs object literal
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Object}
	         */
	    getAttrs: function() {
	      return this.attrs || {};
	    },
	    /**
	         * set multiple attrs at once using an object literal
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Object} config object containing key value pairs
	         * @returns {Konva.Node}
	         * @example
	         * node.setAttrs({
	         *   x: 5,
	         *   fill: 'red'
	         * });
	         */
	    setAttrs: function(config) {
	      var key, method;
	
	      if (!config) {
	        return this;
	      }
	      for (key in config) {
	        if (key === CHILDREN) {
	          continue;
	        }
	        method = SET + Konva.Util._capitalize(key);
	        // use setter if available
	        if (Konva.Util._isFunction(this[method])) {
	          this[method](config[key]);
	        } else {
	          // otherwise set directly
	          this._setAttr(key, config[key]);
	        }
	      }
	      return this;
	    },
	    /**
	         * determine if node is listening for events by taking into account ancestors.
	         *
	         * Parent    | Self      | isListening
	         * listening | listening |
	         * ----------+-----------+------------
	         * T         | T         | T
	         * T         | F         | F
	         * F         | T         | T
	         * F         | F         | F
	         * ----------+-----------+------------
	         * T         | I         | T
	         * F         | I         | F
	         * I         | I         | T
	         *
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Boolean}
	         */
	    isListening: function() {
	      return this._getCache(LISTENING, this._isListening);
	    },
	    _isListening: function() {
	      var listening = this.getListening(),
	        parent = this.getParent();
	
	      // the following conditions are a simplification of the truth table above.
	      // please modify carefully
	      if (listening === 'inherit') {
	        if (parent) {
	          return parent.isListening();
	        } else {
	          return true;
	        }
	      } else {
	        return listening;
	      }
	    },
	    /**
	         * determine if node is visible by taking into account ancestors.
	         *
	         * Parent    | Self      | isVisible
	         * visible   | visible   |
	         * ----------+-----------+------------
	         * T         | T         | T
	         * T         | F         | F
	         * F         | T         | T
	         * F         | F         | F
	         * ----------+-----------+------------
	         * T         | I         | T
	         * F         | I         | F
	         * I         | I         | T
	
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Boolean}
	         */
	    isVisible: function() {
	      return this._getCache(VISIBLE, this._isVisible);
	    },
	    _isVisible: function() {
	      var visible = this.getVisible(),
	        parent = this.getParent();
	
	      // the following conditions are a simplification of the truth table above.
	      // please modify carefully
	      if (visible === 'inherit') {
	        if (parent) {
	          return parent.isVisible();
	        } else {
	          return true;
	        }
	      } else {
	        return visible;
	      }
	    },
	    /**
	         * determine if listening is enabled by taking into account descendants.  If self or any children
	         * have _isListeningEnabled set to true, then self also has listening enabled.
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Boolean}
	         */
	    shouldDrawHit: function(canvas) {
	      var layer = this.getLayer();
	      return (
	        (canvas && canvas.isCache) ||
	        (layer &&
	          layer.hitGraphEnabled() &&
	          this.isListening() &&
	          this.isVisible())
	      );
	    },
	    /**
	         * show node
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Node}
	         */
	    show: function() {
	      this.setVisible(true);
	      return this;
	    },
	    /**
	         * hide node.  Hidden nodes are no longer detectable
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Node}
	         */
	    hide: function() {
	      this.setVisible(false);
	      return this;
	    },
	    /**
	         * get zIndex relative to the node's siblings who share the same parent
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Integer}
	         */
	    getZIndex: function() {
	      return this.index || 0;
	    },
	    /**
	         * get absolute z-index which takes into account sibling
	         *  and ancestor indices
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Integer}
	         */
	    getAbsoluteZIndex: function() {
	      var depth = this.getDepth(),
	        that = this,
	        index = 0,
	        nodes,
	        len,
	        n,
	        child;
	
	      function addChildren(children) {
	        nodes = [];
	        len = children.length;
	        for (n = 0; n < len; n++) {
	          child = children[n];
	          index++;
	
	          if (child.nodeType !== SHAPE) {
	            nodes = nodes.concat(child.getChildren().toArray());
	          }
	
	          if (child._id === that._id) {
	            n = len;
	          }
	        }
	
	        if (nodes.length > 0 && nodes[0].getDepth() <= depth) {
	          addChildren(nodes);
	        }
	      }
	      if (that.nodeType !== UPPER_STAGE) {
	        addChildren(that.getStage().getChildren());
	      }
	
	      return index;
	    },
	    /**
	         * get node depth in node tree.  Returns an integer.
	         *  e.g. Stage depth will always be 0.  Layers will always be 1.  Groups and Shapes will always
	         *  be >= 2
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Integer}
	         */
	    getDepth: function() {
	      var depth = 0,
	        parent = this.parent;
	
	      while (parent) {
	        depth++;
	        parent = parent.parent;
	      }
	      return depth;
	    },
	    setPosition: function(pos) {
	      this.setX(pos.x);
	      this.setY(pos.y);
	      return this;
	    },
	    getPosition: function() {
	      return {
	        x: this.getX(),
	        y: this.getY()
	      };
	    },
	    /**
	         * get absolute position relative to the top left corner of the stage container div
	         * or relative to passed node
	         * @method
	         * @param {Object} [top] optional parent node
	         * @memberof Konva.Node.prototype
	         * @returns {Object}
	         */
	    getAbsolutePosition: function(top) {
	      var absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(),
	        absoluteTransform = new Konva.Transform(),
	        offset = this.offset();
	
	      // clone the matrix array
	      absoluteTransform.m = absoluteMatrix.slice();
	      absoluteTransform.translate(offset.x, offset.y);
	
	      return absoluteTransform.getTranslation();
	    },
	    /**
	         * set absolute position
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Object} pos
	         * @param {Number} pos.x
	         * @param {Number} pos.y
	         * @returns {Konva.Node}
	         */
	    setAbsolutePosition: function(pos) {
	      var origTrans = this._clearTransform(),
	        it;
	
	      // don't clear translation
	      this.attrs.x = origTrans.x;
	      this.attrs.y = origTrans.y;
	      delete origTrans.x;
	      delete origTrans.y;
	
	      // unravel transform
	      it = this.getAbsoluteTransform();
	
	      it.invert();
	      it.translate(pos.x, pos.y);
	      pos = {
	        x: this.attrs.x + it.getTranslation().x,
	        y: this.attrs.y + it.getTranslation().y
	      };
	
	      this.setPosition({ x: pos.x, y: pos.y });
	      this._setTransform(origTrans);
	
	      return this;
	    },
	    _setTransform: function(trans) {
	      var key;
	
	      for (key in trans) {
	        this.attrs[key] = trans[key];
	      }
	
	      this._clearCache(TRANSFORM);
	      this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
	    },
	    _clearTransform: function() {
	      var trans = {
	        x: this.getX(),
	        y: this.getY(),
	        rotation: this.getRotation(),
	        scaleX: this.getScaleX(),
	        scaleY: this.getScaleY(),
	        offsetX: this.getOffsetX(),
	        offsetY: this.getOffsetY(),
	        skewX: this.getSkewX(),
	        skewY: this.getSkewY()
	      };
	
	      this.attrs.x = 0;
	      this.attrs.y = 0;
	      this.attrs.rotation = 0;
	      this.attrs.scaleX = 1;
	      this.attrs.scaleY = 1;
	      this.attrs.offsetX = 0;
	      this.attrs.offsetY = 0;
	      this.attrs.skewX = 0;
	      this.attrs.skewY = 0;
	
	      this._clearCache(TRANSFORM);
	      this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
	
	      // return original transform
	      return trans;
	    },
	    /**
	         * move node by an amount relative to its current position
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Object} change
	         * @param {Number} change.x
	         * @param {Number} change.y
	         * @returns {Konva.Node}
	         * @example
	         * // move node in x direction by 1px and y direction by 2px
	         * node.move({
	         *   x: 1,
	         *   y: 2)
	         * });
	         */
	    move: function(change) {
	      var changeX = change.x,
	        changeY = change.y,
	        x = this.getX(),
	        y = this.getY();
	
	      if (changeX !== undefined) {
	        x += changeX;
	      }
	
	      if (changeY !== undefined) {
	        y += changeY;
	      }
	
	      this.setPosition({ x: x, y: y });
	      return this;
	    },
	    _eachAncestorReverse: function(func, top) {
	      var family = [],
	        parent = this.getParent(),
	        len,
	        n;
	
	      // if top node is defined, and this node is top node,
	      // there's no need to build a family tree.  just execute
	      // func with this because it will be the only node
	      if (top && top._id === this._id) {
	        func(this);
	        return true;
	      }
	
	      family.unshift(this);
	
	      while (parent && (!top || parent._id !== top._id)) {
	        family.unshift(parent);
	        parent = parent.parent;
	      }
	
	      len = family.length;
	      for (n = 0; n < len; n++) {
	        func(family[n]);
	      }
	    },
	    /**
	         * rotate node by an amount in degrees relative to its current rotation
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Number} theta
	         * @returns {Konva.Node}
	         */
	    rotate: function(theta) {
	      this.setRotation(this.getRotation() + theta);
	      return this;
	    },
	    /**
	         * move node to the top of its siblings
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Boolean}
	         */
	    moveToTop: function() {
	      if (!this.parent) {
	        Konva.Util.warn('Node has no parent. moveToTop function is ignored.');
	        return false;
	      }
	      var index = this.index;
	      this.parent.children.splice(index, 1);
	      this.parent.children.push(this);
	      this.parent._setChildrenIndices();
	      return true;
	    },
	    /**
	         * move node up
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Boolean} flag is moved or not
	         */
	    moveUp: function() {
	      if (!this.parent) {
	        Konva.Util.warn('Node has no parent. moveUp function is ignored.');
	        return false;
	      }
	      var index = this.index,
	        len = this.parent.getChildren().length;
	      if (index < len - 1) {
	        this.parent.children.splice(index, 1);
	        this.parent.children.splice(index + 1, 0, this);
	        this.parent._setChildrenIndices();
	        return true;
	      }
	      return false;
	    },
	    /**
	         * move node down
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Boolean}
	         */
	    moveDown: function() {
	      if (!this.parent) {
	        Konva.Util.warn('Node has no parent. moveDown function is ignored.');
	        return false;
	      }
	      var index = this.index;
	      if (index > 0) {
	        this.parent.children.splice(index, 1);
	        this.parent.children.splice(index - 1, 0, this);
	        this.parent._setChildrenIndices();
	        return true;
	      }
	      return false;
	    },
	    /**
	         * move node to the bottom of its siblings
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Boolean}
	         */
	    moveToBottom: function() {
	      if (!this.parent) {
	        Konva.Util.warn(
	          'Node has no parent. moveToBottom function is ignored.'
	        );
	        return false;
	      }
	      var index = this.index;
	      if (index > 0) {
	        this.parent.children.splice(index, 1);
	        this.parent.children.unshift(this);
	        this.parent._setChildrenIndices();
	        return true;
	      }
	      return false;
	    },
	    /**
	         * set zIndex relative to siblings
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Integer} zIndex
	         * @returns {Konva.Node}
	         */
	    setZIndex: function(zIndex) {
	      if (!this.parent) {
	        Konva.Util.warn('Node has no parent. zIndex parameter is ignored.');
	        return false;
	      }
	      var index = this.index;
	      this.parent.children.splice(index, 1);
	      this.parent.children.splice(zIndex, 0, this);
	      this.parent._setChildrenIndices();
	      return this;
	    },
	    /**
	         * get absolute opacity
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Number}
	         */
	    getAbsoluteOpacity: function() {
	      return this._getCache(ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
	    },
	    _getAbsoluteOpacity: function() {
	      var absOpacity = this.getOpacity();
	      var parent = this.getParent();
	      if (parent && !parent._isUnderCache) {
	        absOpacity *= this.getParent().getAbsoluteOpacity();
	      }
	      return absOpacity;
	    },
	    /**
	         * move node to another container
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Container} newContainer
	         * @returns {Konva.Node}
	         * @example
	         * // move node from current layer into layer2
	         * node.moveTo(layer2);
	         */
	    moveTo: function(newContainer) {
	      // do nothing if new container is already parent
	      if (this.getParent() !== newContainer) {
	        // this.remove my be overrided by drag and drop
	        // buy we need original
	        (this.__originalRemove || this.remove).call(this);
	        newContainer.add(this);
	      }
	      return this;
	    },
	    /**
	         * convert Node into an object for serialization.  Returns an object.
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Object}
	         */
	    toObject: function() {
	      var obj = {},
	        attrs = this.getAttrs(),
	        key,
	        val,
	        getter,
	        defaultValue;
	
	      obj.attrs = {};
	
	      for (key in attrs) {
	        val = attrs[key];
	        getter = this[key];
	        // remove attr value so that we can extract the default value from the getter
	        delete attrs[key];
	        defaultValue = getter ? getter.call(this) : null;
	        // restore attr value
	        attrs[key] = val;
	        if (defaultValue !== val) {
	          obj.attrs[key] = val;
	        }
	      }
	
	      obj.className = this.getClassName();
	      return Konva.Util._prepareToStringify(obj);
	    },
	    /**
	         * convert Node into a JSON string.  Returns a JSON string.
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {String}}
	         */
	    toJSON: function() {
	      return JSON.stringify(this.toObject());
	    },
	    /**
	         * get parent container
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Node}
	         */
	    getParent: function() {
	      return this.parent;
	    },
	    /**
	         * get all ancestros (parent then parent of the parent, etc) of the node
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} [selector] selector for search
	         * @param {Boolean} [includeSelf] show we think that node is ancestro itself?
	         * @param {Konva.Node} [stopNode] optional node where we need to stop searching (one of ancestors)
	         * @returns {Array} [ancestors]
	         * @example
	         * // get one of the parent group
	         * var parentGroups = node.findAncestors('Group');
	         */
	    findAncestors: function(selector, includeSelf, stopNode) {
	      var res = [];
	
	      if (includeSelf && this._isMatch(selector)) {
	        res.push(this);
	      }
	      var ancestor = this.parent;
	      while (ancestor) {
	        if (ancestor === stopNode) {
	          return res;
	        }
	        if (ancestor._isMatch(selector)) {
	          res.push(ancestor);
	        }
	        ancestor = ancestor.parent;
	      }
	      return res;
	    },
	    /**
	         * get ancestor (parent or parent of the parent, etc) of the node that match passed selector
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} [selector] selector for search
	         * @param {Boolean} [includeSelf] show we think that node is ancestro itself?
	         * @param {Konva.Node} [stopNode] optional node where we need to stop searching (one of ancestors)
	         * @returns {Konva.Node} ancestor
	         * @example
	         * // get one of the parent group
	         * var group = node.findAncestors('.mygroup');
	         */
	    findAncestor: function(selector, includeSelf, stopNode) {
	      return this.findAncestors(selector, includeSelf, stopNode)[0];
	    },
	    // is current node match passed selector?
	    _isMatch: function(selector) {
	      if (!selector) {
	        return false;
	      }
	      var selectorArr = selector.replace(/ /g, '').split(','),
	        len = selectorArr.length,
	        n,
	        sel;
	
	      for (n = 0; n < len; n++) {
	        sel = selectorArr[n];
	        if (!Konva.Util.isValidSelector(sel)) {
	          Konva.Util.warn(
	            'Selector "' +
	              sel +
	              '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'
	          );
	          Konva.Util.warn(
	            'If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'
	          );
	          Konva.Util.warn('Konva is awesome, right?');
	        }
	        // id selector
	        if (sel.charAt(0) === '#') {
	          if (this.id() === sel.slice(1)) {
	            return true;
	          }
	        } else if (sel.charAt(0) === '.') {
	          // name selector
	          if (this.hasName(sel.slice(1))) {
	            return true;
	          }
	        } else if (this._get(sel).length !== 0) {
	          return true;
	        }
	      }
	      return false;
	    },
	    /**
	         * get layer ancestor
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Layer}
	         */
	    getLayer: function() {
	      var parent = this.getParent();
	      return parent ? parent.getLayer() : null;
	    },
	    /**
	         * get stage ancestor
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Stage}
	         */
	    getStage: function() {
	      return this._getCache(STAGE, this._getStage);
	    },
	    _getStage: function() {
	      var parent = this.getParent();
	      if (parent) {
	        return parent.getStage();
	      } else {
	        return undefined;
	      }
	    },
	    /**
	         * fire event
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} eventType event type.  can be a regular event, like click, mouseover, or mouseout, or it can be a custom event, like myCustomEvent
	         * @param {Event} [evt] event object
	         * @param {Boolean} [bubble] setting the value to false, or leaving it undefined, will result in the event
	         *  not bubbling.  Setting the value to true will result in the event bubbling.
	         * @returns {Konva.Node}
	         * @example
	         * // manually fire click event
	         * node.fire('click');
	         *
	         * // fire custom event
	         * node.fire('foo');
	         *
	         * // fire custom event with custom event object
	         * node.fire('foo', {
	         *   bar: 10
	         * });
	         *
	         * // fire click event that bubbles
	         * node.fire('click', null, true);
	         */
	    fire: function(eventType, evt, bubble) {
	      evt = evt || {};
	      evt.target = evt.target || this;
	      // bubble
	      if (bubble) {
	        this._fireAndBubble(eventType, evt);
	      } else {
	        // no bubble
	        this._fire(eventType, evt);
	      }
	      return this;
	    },
	    /**
	         * get absolute transform of the node which takes into
	         *  account its ancestor transforms
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Transform}
	         */
	    getAbsoluteTransform: function(top) {
	      // if using an argument, we can't cache the result.
	      if (top) {
	        return this._getAbsoluteTransform(top);
	      } else {
	        // if no argument, we can cache the result
	        return this._getCache(ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
	      }
	    },
	    _getAbsoluteTransform: function(top) {
	      var at = new Konva.Transform(),
	        transformsEnabled,
	        trans;
	
	      // start with stage and traverse downwards to self
	      this._eachAncestorReverse(function(node) {
	        transformsEnabled = node.transformsEnabled();
	        trans = node.getTransform();
	
	        if (transformsEnabled === 'all') {
	          at.multiply(trans);
	        } else if (transformsEnabled === 'position') {
	          at.translate(node.x(), node.y());
	        }
	      }, top);
	      return at;
	    },
	    /**
	         * get absolute scale of the node which takes into
	         *  account its ancestor scales
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Transform}
	         */
	    getAbsoluteScale: function(top) {
	      // if using an argument, we can't cache the result.
	      if (top) {
	        return this._getAbsoluteScale(top);
	      } else {
	        // if no argument, we can cache the result
	        return this._getCache(ABSOLUTE_SCALE, this._getAbsoluteScale);
	      }
	    },
	    _getAbsoluteScale: function(top) {
	      // this is special logic for caching with some shapes with shadow
	      var parent = this;
	      while (parent) {
	        if (parent._isUnderCache) {
	          top = parent;
	        }
	        parent = parent.getParent();
	      }
	
	      var scaleX = 1,
	        scaleY = 1;
	
	      // start with stage and traverse downwards to self
	      this._eachAncestorReverse(function(node) {
	        scaleX *= node.scaleX();
	        scaleY *= node.scaleY();
	      }, top);
	      return {
	        x: scaleX,
	        y: scaleY
	      };
	    },
	    /**
	         * get transform of the node
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Transform}
	         */
	    getTransform: function() {
	      return this._getCache(TRANSFORM, this._getTransform);
	    },
	    _getTransform: function() {
	      var m = new Konva.Transform(),
	        x = this.getX(),
	        y = this.getY(),
	        rotation = Konva.getAngle(this.getRotation()),
	        scaleX = this.getScaleX(),
	        scaleY = this.getScaleY(),
	        skewX = this.getSkewX(),
	        skewY = this.getSkewY(),
	        offsetX = this.getOffsetX(),
	        offsetY = this.getOffsetY();
	
	      if (x !== 0 || y !== 0) {
	        m.translate(x, y);
	      }
	      if (rotation !== 0) {
	        m.rotate(rotation);
	      }
	      if (skewX !== 0 || skewY !== 0) {
	        m.skew(skewX, skewY);
	      }
	      if (scaleX !== 1 || scaleY !== 1) {
	        m.scale(scaleX, scaleY);
	      }
	      if (offsetX !== 0 || offsetY !== 0) {
	        m.translate(-1 * offsetX, -1 * offsetY);
	      }
	
	      return m;
	    },
	    /**
	         * clone node.  Returns a new Node instance with identical attributes.  You can also override
	         *  the node properties with an object literal, enabling you to use an existing node as a template
	         *  for another node
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Object} obj override attrs
	         * @returns {Konva.Node}
	         * @example
	         * // simple clone
	         * var clone = node.clone();
	         *
	         * // clone a node and override the x position
	         * var clone = rect.clone({
	         *   x: 5
	         * });
	         */
	    clone: function(obj) {
	      // instantiate new node
	      var attrs = Konva.Util.cloneObject(this.attrs),
	        key,
	        allListeners,
	        len,
	        n,
	        listener;
	      // filter black attrs
	      for (var i in CLONE_BLACK_LIST) {
	        var blockAttr = CLONE_BLACK_LIST[i];
	        delete attrs[blockAttr];
	      }
	      // apply attr overrides
	      for (key in obj) {
	        attrs[key] = obj[key];
	      }
	
	      var node = new this.constructor(attrs);
	      // copy over listeners
	      for (key in this.eventListeners) {
	        allListeners = this.eventListeners[key];
	        len = allListeners.length;
	        for (n = 0; n < len; n++) {
	          listener = allListeners[n];
	          /*
	                     * don't include konva namespaced listeners because
	                     *  these are generated by the constructors
	                     */
	          if (listener.name.indexOf(KONVA) < 0) {
	            // if listeners array doesn't exist, then create it
	            if (!node.eventListeners[key]) {
	              node.eventListeners[key] = [];
	            }
	            node.eventListeners[key].push(listener);
	          }
	        }
	      }
	      return node;
	    },
	    _toKonvaCanvas: function(config) {
	      config = config || {};
	
	      var stage = this.getStage(),
	        x = config.x || 0,
	        y = config.y || 0,
	        pixelRatio = config.pixelRatio || 1,
	        canvas = new Konva.SceneCanvas({
	          width:
	            config.width || this.getWidth() || (stage ? stage.getWidth() : 0),
	          height:
	            config.height ||
	            this.getHeight() ||
	            (stage ? stage.getHeight() : 0),
	          pixelRatio: pixelRatio
	        }),
	        context = canvas.getContext();
	
	      context.save();
	
	      if (x || y) {
	        context.translate(-1 * x, -1 * y);
	      }
	
	      this.drawScene(canvas);
	      context.restore();
	
	      return canvas;
	    },
	    /**
	         * converts node into an canvas element.
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Object} config
	         * @param {Function} config.callback function executed when the composite has completed
	         * @param {Number} [config.x] x position of canvas section
	         * @param {Number} [config.y] y position of canvas section
	         * @param {Number} [config.width] width of canvas section
	         * @param {Number} [config.height] height of canvas section
	         * @paremt {Number} [config.pixelRatio] pixelRatio of ouput image.  Default is 1.
	         * @example
	         * var canvas = node.toCanvas();
	         */
	    toCanvas: function(config) {
	      return this._toKonvaCanvas(config)._canvas;
	    },
	    /**
	         * Creates a composite data URL. If MIME type is not
	         * specified, then "image/png" will result. For "image/jpeg", specify a quality
	         * level as quality (range 0.0 - 1.0)
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Object} config
	         * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
	         *  "image/png" is the default
	         * @param {Number} [config.x] x position of canvas section
	         * @param {Number} [config.y] y position of canvas section
	         * @param {Number} [config.width] width of canvas section
	         * @param {Number} [config.height] height of canvas section
	         * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
	         *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
	         *  is very high quality
	         * @paremt {Number} [config.pixelRatio] pixelRatio of ouput image url. Default is 1
	         * @returns {String}
	         */
	    toDataURL: function(config) {
	      config = config || {};
	      var mimeType = config.mimeType || null,
	        quality = config.quality || null;
	      return this._toKonvaCanvas(config).toDataURL(mimeType, quality);
	    },
	    /**
	         * converts node into an image.  Since the toImage
	         *  method is asynchronous, a callback is required.  toImage is most commonly used
	         *  to cache complex drawings as an image so that they don't have to constantly be redrawn
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {Object} config
	         * @param {Function} config.callback function executed when the composite has completed
	         * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
	         *  "image/png" is the default
	         * @param {Number} [config.x] x position of canvas section
	         * @param {Number} [config.y] y position of canvas section
	         * @param {Number} [config.width] width of canvas section
	         * @param {Number} [config.height] height of canvas section
	         * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
	         *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
	         *  is very high quality
	         * @paremt {Number} [config.pixelRatio] pixelRatio of ouput image.  Default is 1.
	         * @example
	         * var image = node.toImage({
	         *   callback: function(img) {
	         *     // do stuff with img
	         *   }
	         * });
	         */
	    toImage: function(config) {
	      if (!config || !config.callback) {
	        throw 'callback required for toImage method config argument';
	      }
	      Konva.Util._getImage(this.toDataURL(config), function(img) {
	        config.callback(img);
	      });
	    },
	    setSize: function(size) {
	      this.setWidth(size.width);
	      this.setHeight(size.height);
	      return this;
	    },
	    getSize: function() {
	      return {
	        width: this.getWidth(),
	        height: this.getHeight()
	      };
	    },
	    getWidth: function() {
	      return this.attrs.width || 0;
	    },
	    getHeight: function() {
	      return this.attrs.height || 0;
	    },
	    /**
	         * get class name, which may return Stage, Layer, Group, or shape class names like Rect, Circle, Text, etc.
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {String}
	         */
	    getClassName: function() {
	      return this.className || this.nodeType;
	    },
	    /**
	         * get the node type, which may return Stage, Layer, Group, or Node
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {String}
	         */
	    getType: function() {
	      return this.nodeType;
	    },
	    getDragDistance: function() {
	      // compare with undefined because we need to track 0 value
	      if (this.attrs.dragDistance !== undefined) {
	        return this.attrs.dragDistance;
	      } else if (this.parent) {
	        return this.parent.getDragDistance();
	      } else {
	        return Konva.dragDistance;
	      }
	    },
	    _get: function(selector) {
	      return this.className === selector || this.nodeType === selector
	        ? [this]
	        : [];
	    },
	    _off: function(type, name) {
	      var evtListeners = this.eventListeners[type],
	        i,
	        evtName;
	
	      for (i = 0; i < evtListeners.length; i++) {
	        evtName = evtListeners[i].name;
	        // the following two conditions must be true in order to remove a handler:
	        // 1) the current event name cannot be konva unless the event name is konva
	        //    this enables developers to force remove a konva specific listener for whatever reason
	        // 2) an event name is not specified, or if one is specified, it matches the current event name
	        if (
	          (evtName !== 'konva' || name === 'konva') &&
	          (!name || evtName === name)
	        ) {
	          evtListeners.splice(i, 1);
	          if (evtListeners.length === 0) {
	            delete this.eventListeners[type];
	            break;
	          }
	          i--;
	        }
	      }
	    },
	    _fireChangeEvent: function(attr, oldVal, newVal) {
	      this._fire(attr + CHANGE, {
	        oldVal: oldVal,
	        newVal: newVal
	      });
	    },
	    setId: function(id) {
	      var oldId = this.getId();
	
	      Konva._removeId(oldId);
	      Konva._addId(this, id);
	      this._setAttr(ID, id);
	      return this;
	    },
	    setName: function(name) {
	      var oldNames = (this.getName() || '').split(/\s/g);
	      var newNames = (name || '').split(/\s/g);
	      var subname, i;
	      // remove all subnames
	      for (i = 0; i < oldNames.length; i++) {
	        subname = oldNames[i];
	        if (newNames.indexOf(subname) === -1 && subname) {
	          Konva._removeName(subname, this._id);
	        }
	      }
	
	      // add new names
	      for (i = 0; i < newNames.length; i++) {
	        subname = newNames[i];
	        if (oldNames.indexOf(subname) === -1 && subname) {
	          Konva._addName(this, subname);
	        }
	      }
	
	      this._setAttr(NAME, name);
	      return this;
	    },
	    // naming methods
	    /**
	         * add name to node
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} name
	         * @returns {Konva.Node}
	         * @example
	         * node.name('red');
	         * node.addName('selected');
	         * node.name(); // return 'red selected'
	         */
	    addName: function(name) {
	      if (!this.hasName(name)) {
	        var oldName = this.name();
	        var newName = oldName ? oldName + ' ' + name : name;
	        this.setName(newName);
	      }
	      return this;
	    },
	    /**
	         * check is node has name
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} name
	         * @returns {Boolean}
	         * @example
	         * node.name('red');
	         * node.hasName('red');   // return true
	         * node.hasName('selected'); // return false
	         */
	    hasName: function(name) {
	      var names = (this.name() || '').split(/\s/g);
	      return names.indexOf(name) !== -1;
	    },
	    /**
	         * remove name from node
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} name
	         * @returns {Konva.Node}
	         * @example
	         * node.name('red selected');
	         * node.removeName('selected');
	         * node.hasName('selected'); // return false
	         * node.name(); // return 'red'
	         */
	    removeName: function(name) {
	      var names = (this.name() || '').split(/\s/g);
	      var index = names.indexOf(name);
	      if (index !== -1) {
	        names.splice(index, 1);
	        this.setName(names.join(' '));
	      }
	      return this;
	    },
	    /**
	         * set attr
	         * @method
	         * @memberof Konva.Node.prototype
	         * @param {String} attr
	         * @param {*} val
	         * @returns {Konva.Node}
	         * @example
	         * node.setAttr('x', 5);
	         */
	    setAttr: function(attr, val) {
	      var method = SET + Konva.Util._capitalize(attr),
	        func = this[method];
	
	      if (Konva.Util._isFunction(func)) {
	        func.call(this, val);
	      } else {
	        // otherwise set directly
	        this._setAttr(attr, val);
	      }
	      return this;
	    },
	    _setAttr: function(key, val) {
	      var oldVal;
	      oldVal = this.attrs[key];
	      if (oldVal === val) {
	        return;
	      }
	      if (val === undefined || val === null) {
	        delete this.attrs[key];
	      } else {
	        this.attrs[key] = val;
	      }
	      this._fireChangeEvent(key, oldVal, val);
	    },
	    _setComponentAttr: function(key, component, val) {
	      var oldVal;
	      if (val !== undefined) {
	        oldVal = this.attrs[key];
	
	        if (!oldVal) {
	          // set value to default value using getAttr
	          this.attrs[key] = this.getAttr(key);
	        }
	
	        this.attrs[key][component] = val;
	        this._fireChangeEvent(key, oldVal, val);
	      }
	    },
	    _fireAndBubble: function(eventType, evt, compareShape) {
	      var okayToRun = true;
	
	      if (evt && this.nodeType === SHAPE) {
	        evt.target = this;
	      }
	
	      if (
	        eventType === MOUSEENTER &&
	        compareShape &&
	        (this._id === compareShape._id ||
	          (this.isAncestorOf && this.isAncestorOf(compareShape)))
	      ) {
	        okayToRun = false;
	      } else if (
	        eventType === MOUSELEAVE &&
	        compareShape &&
	        (this._id === compareShape._id ||
	          (this.isAncestorOf && this.isAncestorOf(compareShape)))
	      ) {
	        okayToRun = false;
	      }
	      if (okayToRun) {
	        this._fire(eventType, evt);
	
	        // simulate event bubbling
	        var stopBubble =
	          (eventType === MOUSEENTER || eventType === MOUSELEAVE) &&
	          (compareShape &&
	            compareShape.isAncestorOf &&
	            compareShape.isAncestorOf(this) &&
	            !compareShape.isAncestorOf(this.parent));
	        if (
	          ((evt && !evt.cancelBubble) || !evt) &&
	          this.parent &&
	          this.parent.isListening() &&
	          !stopBubble
	        ) {
	          if (compareShape && compareShape.parent) {
	            this._fireAndBubble.call(
	              this.parent,
	              eventType,
	              evt,
	              compareShape.parent
	            );
	          } else {
	            this._fireAndBubble.call(this.parent, eventType, evt);
	          }
	        }
	      }
	    },
	    _fire: function(eventType, evt) {
	      var events = this.eventListeners[eventType],
	        i;
	
	      evt = evt || {};
	      evt.currentTarget = this;
	      evt.type = eventType;
	
	      if (events) {
	        for (i = 0; i < events.length; i++) {
	          events[i].handler.call(this, evt);
	        }
	      }
	    },
	    /**
	         * draw both scene and hit graphs.  If the node being drawn is the stage, all of the layers will be cleared and redrawn
	         * @method
	         * @memberof Konva.Node.prototype
	         * @returns {Konva.Node}
	         */
	    draw: function() {
	      this.drawScene();
	      this.drawHit();
	      return this;
	    }
	  });
	
	  /**
	     * create node with JSON string or an Object.  De-serializtion does not generate custom
	     *  shape drawing functions, images, or event handlers (this would make the
	     *  serialized object huge).  If your app uses custom shapes, images, and
	     *  event handlers (it probably does), then you need to select the appropriate
	     *  shapes after loading the stage and set these properties via on(), setDrawFunc(),
	     *  and setImage() methods
	     * @method
	     * @memberof Konva.Node
	     * @param {String|Object} json string or object
	     * @param {Element} [container] optional container dom element used only if you're
	     *  creating a stage node
	     */
	  Konva.Node.create = function(data, container) {
	    if (Konva.Util._isString(data)) {
	      data = JSON.parse(data);
	    }
	    return this._createNode(data, container);
	  };
	  Konva.Node._createNode = function(obj, container) {
	    var className = Konva.Node.prototype.getClassName.call(obj),
	      children = obj.children,
	      no,
	      len,
	      n;
	
	    // if container was passed in, add it to attrs
	    if (container) {
	      obj.attrs.container = container;
	    }
	
	    no = new Konva[className](obj.attrs);
	    if (children) {
	      len = children.length;
	      for (n = 0; n < len; n++) {
	        no.add(this._createNode(children[n]));
	      }
	    }
	
	    return no;
	  };
	
	  // =========================== add getters setters ===========================
	
	  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'position');
	  /**
	     * get/set node position relative to parent
	     * @name position
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Object} pos
	     * @param {Number} pos.x
	     * @param {Number} pos.y
	     * @returns {Object}
	     * @example
	     * // get position
	     * var position = node.position();
	     *
	     * // set position
	     * node.position({
	     *   x: 5
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'x', 0);
	
	  /**
	     * get/set x position
	     * @name x
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} x
	     * @returns {Object}
	     * @example
	     * // get x
	     * var x = node.x();
	     *
	     * // set x
	     * node.x(5);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'y', 0);
	
	  /**
	     * get/set y position
	     * @name y
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} y
	     * @returns {Integer}
	     * @example
	     * // get y
	     * var y = node.y();
	     *
	     * // set y
	     * node.y(5);
	     */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'globalCompositeOperation',
	    'source-over'
	  );
	
	  /**
	     * get/set globalCompositeOperation of a shape
	     * @name globalCompositeOperation
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} blur
	     * @returns {Number}
	     * @example
	     * // get shadow blur
	     * var globalCompositeOperation = shape.globalCompositeOperation();
	     *
	     * // set shadow blur
	     * shape.globalCompositeOperation('source-in');
	     */
	  Konva.Factory.addGetterSetter(Konva.Node, 'opacity', 1);
	
	  /**
	     * get/set opacity.  Opacity values range from 0 to 1.
	     *  A node with an opacity of 0 is fully transparent, and a node
	     *  with an opacity of 1 is fully opaque
	     * @name opacity
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Object} opacity
	     * @returns {Number}
	     * @example
	     * // get opacity
	     * var opacity = node.opacity();
	     *
	     * // set opacity
	     * node.opacity(0.5);
	     */
	
	  Konva.Factory.addGetter(Konva.Node, 'name');
	  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'name');
	
	  /**
	     * get/set name
	     * @name name
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {String} name
	     * @returns {String}
	     * @example
	     * // get name
	     * var name = node.name();
	     *
	     * // set name
	     * node.name('foo');
	     *
	     * // also node may have multiple names (as css classes)
	     * node.name('foo bar');
	     */
	
	  Konva.Factory.addGetter(Konva.Node, 'id');
	  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'id');
	
	  /**
	     * get/set id. Id is global for whole page.
	     * @name id
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {String} id
	     * @returns {String}
	     * @example
	     * // get id
	     * var name = node.id();
	     *
	     * // set id
	     * node.id('foo');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'rotation', 0);
	
	  /**
	     * get/set rotation in degrees
	     * @name rotation
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} rotation
	     * @returns {Number}
	     * @example
	     * // get rotation in degrees
	     * var rotation = node.rotation();
	     *
	     * // set rotation in degrees
	     * node.rotation(45);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(Konva.Node, 'scale', ['x', 'y']);
	
	  /**
	     * get/set scale
	     * @name scale
	     * @param {Object} scale
	     * @param {Number} scale.x
	     * @param {Number} scale.y
	     * @method
	     * @memberof Konva.Node.prototype
	     * @returns {Object}
	     * @example
	     * // get scale
	     * var scale = node.scale();
	     *
	     * // set scale
	     * shape.scale({
	     *   x: 2
	     *   y: 3
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'scaleX', 1);
	
	  /**
	     * get/set scale x
	     * @name scaleX
	     * @param {Number} x
	     * @method
	     * @memberof Konva.Node.prototype
	     * @returns {Number}
	     * @example
	     * // get scale x
	     * var scaleX = node.scaleX();
	     *
	     * // set scale x
	     * node.scaleX(2);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'scaleY', 1);
	
	  /**
	     * get/set scale y
	     * @name scaleY
	     * @param {Number} y
	     * @method
	     * @memberof Konva.Node.prototype
	     * @returns {Number}
	     * @example
	     * // get scale y
	     * var scaleY = node.scaleY();
	     *
	     * // set scale y
	     * node.scaleY(2);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(Konva.Node, 'skew', ['x', 'y']);
	
	  /**
	     * get/set skew
	     * @name skew
	     * @param {Object} skew
	     * @param {Number} skew.x
	     * @param {Number} skew.y
	     * @method
	     * @memberof Konva.Node.prototype
	     * @returns {Object}
	     * @example
	     * // get skew
	     * var skew = node.skew();
	     *
	     * // set skew
	     * node.skew({
	     *   x: 20
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'skewX', 0);
	
	  /**
	     * get/set skew x
	     * @name skewX
	     * @param {Number} x
	     * @method
	     * @memberof Konva.Node.prototype
	     * @returns {Number}
	     * @example
	     * // get skew x
	     * var skewX = node.skewX();
	     *
	     * // set skew x
	     * node.skewX(3);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'skewY', 0);
	
	  /**
	     * get/set skew y
	     * @name skewY
	     * @param {Number} y
	     * @method
	     * @memberof Konva.Node.prototype
	     * @returns {Number}
	     * @example
	     * // get skew y
	     * var skewY = node.skewY();
	     *
	     * // set skew y
	     * node.skewY(3);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(Konva.Node, 'offset', ['x', 'y']);
	
	  /**
	     * get/set offset.  Offsets the default position and rotation point
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Object} offset
	     * @param {Number} offset.x
	     * @param {Number} offset.y
	     * @returns {Object}
	     * @example
	     * // get offset
	     * var offset = node.offset();
	     *
	     * // set offset
	     * node.offset({
	     *   x: 20
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'offsetX', 0);
	
	  /**
	     * get/set offset x
	     * @name offsetX
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get offset x
	     * var offsetX = node.offsetX();
	     *
	     * // set offset x
	     * node.offsetX(3);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'offsetY', 0);
	
	  /**
	     * get/set offset y
	     * @name offsetY
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get offset y
	     * var offsetY = node.offsetY();
	     *
	     * // set offset y
	     * node.offsetY(3);
	     */
	
	  Konva.Factory.addSetter(Konva.Node, 'dragDistance');
	  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'dragDistance');
	
	  /**
	     * get/set drag distance
	     * @name dragDistance
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} distance
	     * @returns {Number}
	     * @example
	     * // get drag distance
	     * var dragDistance = node.dragDistance();
	     *
	     * // set distance
	     * // node starts dragging only if pointer moved more then 3 pixels
	     * node.dragDistance(3);
	     * // or set globally
	     * Konva.dragDistance = 3;
	     */
	
	  Konva.Factory.addSetter(Konva.Node, 'width', 0);
	  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'width');
	  /**
	     * get/set width
	     * @name width
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} width
	     * @returns {Number}
	     * @example
	     * // get width
	     * var width = node.width();
	     *
	     * // set width
	     * node.width(100);
	     */
	
	  Konva.Factory.addSetter(Konva.Node, 'height', 0);
	  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'height');
	  /**
	     * get/set height
	     * @name height
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Number} height
	     * @returns {Number}
	     * @example
	     * // get height
	     * var height = node.height();
	     *
	     * // set height
	     * node.height(100);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'listening', 'inherit');
	  /**
	     * get/set listenig attr.  If you need to determine if a node is listening or not
	     *   by taking into account its parents, use the isListening() method
	     * @name listening
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Boolean|String} listening Can be "inherit", true, or false.  The default is "inherit".
	     * @returns {Boolean|String}
	     * @example
	     * // get listening attr
	     * var listening = node.listening();
	     *
	     * // stop listening for events
	     * node.listening(false);
	     *
	     * // listen for events
	     * node.listening(true);
	     *
	     * // listen to events according to the parent
	     * node.listening('inherit');
	     */
	
	  /**
	      * get/set preventDefault
	      * By default all shapes will prevent default behaviour
	      * of a browser on a pointer move or tap.
	      * that will prevent native scrolling when you are trying to drag&drop a node
	      * but sometimes you may need to enable default actions
	      * in that case you can set the property to false
	      * @name preventDefault
	      * @method
	      * @memberof Konva.Node.prototype
	      * @param {Number} preventDefault
	      * @returns {Number}
	      * @example
	      * // get preventDefault
	      * var shouldPrevent = shape.preventDefault();
	      *
	      * // set preventDefault
	      * shape.preventDefault(false);
	      */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'preventDefault', true);
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'filters', undefined, function(
	    val
	  ) {
	    this._filterUpToDate = false;
	    return val;
	  });
	  /**
	     * get/set filters.  Filters are applied to cached canvases
	     * @name filters
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Array} filters array of filters
	     * @returns {Array}
	     * @example
	     * // get filters
	     * var filters = node.filters();
	     *
	     * // set a single filter
	     * node.cache();
	     * node.filters([Konva.Filters.Blur]);
	     *
	     * // set multiple filters
	     * node.cache();
	     * node.filters([
	     *   Konva.Filters.Blur,
	     *   Konva.Filters.Sepia,
	     *   Konva.Filters.Invert
	     * ]);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'visible', 'inherit');
	  /**
	     * get/set visible attr.  Can be "inherit", true, or false.  The default is "inherit".
	     *   If you need to determine if a node is visible or not
	     *   by taking into account its parents, use the isVisible() method
	     * @name visible
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Boolean|String} visible
	     * @returns {Boolean|String}
	     * @example
	     * // get visible attr
	     * var visible = node.visible();
	     *
	     * // make invisible
	     * node.visible(false);
	     *
	     * // make visible
	     * node.visible(true);
	     *
	     * // make visible according to the parent
	     * node.visible('inherit');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'transformsEnabled', 'all');
	
	  /**
	     * get/set transforms that are enabled.  Can be "all", "none", or "position".  The default
	     *  is "all"
	     * @name transformsEnabled
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {String} enabled
	     * @returns {String}
	     * @example
	     * // enable position transform only to improve draw performance
	     * node.transformsEnabled('position');
	     *
	     * // enable all transforms
	     * node.transformsEnabled('all');
	     */
	
	  /**
	     * get/set node size
	     * @name size
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Object} size
	     * @param {Number} size.width
	     * @param {Number} size.height
	     * @returns {Object}
	     * @example
	     * // get node size
	     * var size = node.size();
	     * var x = size.x;
	     * var y = size.y;
	     *
	     * // set size
	     * node.size({
	     *   width: 100,
	     *   height: 200
	     * });
	     */
	  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'size');
	
	  Konva.Factory.backCompat(Konva.Node, {
	    rotateDeg: 'rotate',
	    setRotationDeg: 'setRotation',
	    getRotationDeg: 'getRotation'
	  });
	
	  Konva.Collection.mapMethods(Konva.Node);
	})(Konva);


/***/ }),
/* 341 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';
	  /**
	     * Container constructor.&nbsp; Containers are used to contain nodes or other containers
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Node
	     * @abstract
	     * @param {Object} config
	     * @@nodeParams
	     * @@containerParams
	     */
	  Konva.Container = function(config) {
	    this.__init(config);
	  };
	
	  Konva.Util.addMethods(Konva.Container, {
	    __init: function(config) {
	      this.children = new Konva.Collection();
	      Konva.Node.call(this, config);
	    },
	    /**
	         * returns a {@link Konva.Collection} of direct descendant nodes
	         * @method
	         * @memberof Konva.Container.prototype
	         * @param {Function} [filterFunc] filter function
	         * @returns {Konva.Collection}
	         * @example
	         * // get all children
	         * var children = layer.getChildren();
	         *
	         * // get only circles
	         * var circles = layer.getChildren(function(node){
	         *    return node.getClassName() === 'Circle';
	         * });
	         */
	    getChildren: function(filterFunc) {
	      if (!filterFunc) {
	        return this.children;
	      }
	
	      var results = new Konva.Collection();
	      this.children.each(function(child) {
	        if (filterFunc(child)) {
	          results.push(child);
	        }
	      });
	      return results;
	    },
	    /**
	         * determine if node has children
	         * @method
	         * @memberof Konva.Container.prototype
	         * @returns {Boolean}
	         */
	    hasChildren: function() {
	      return this.getChildren().length > 0;
	    },
	    /**
	         * remove all children
	         * @method
	         * @memberof Konva.Container.prototype
	         */
	    removeChildren: function() {
	      var children = Konva.Collection.toCollection(this.children);
	      var child;
	      for (var i = 0; i < children.length; i++) {
	        child = children[i];
	        // reset parent to prevent many _setChildrenIndices calls
	        delete child.parent;
	        child.index = 0;
	        child.remove();
	      }
	      children = null;
	      this.children = new Konva.Collection();
	      return this;
	    },
	    /**
	         * destroy all children
	         * @method
	         * @memberof Konva.Container.prototype
	         */
	    destroyChildren: function() {
	      var children = Konva.Collection.toCollection(this.children);
	      var child;
	      for (var i = 0; i < children.length; i++) {
	        child = children[i];
	        // reset parent to prevent many _setChildrenIndices calls
	        delete child.parent;
	        child.index = 0;
	        child.destroy();
	      }
	      children = null;
	      this.children = new Konva.Collection();
	      return this;
	    },
	    /**
	         * Add node or nodes to container.
	         * @method
	         * @memberof Konva.Container.prototype
	         * @param {...Konva.Node} child
	         * @returns {Container}
	         * @example
	         * layer.add(shape1, shape2, shape3);
	         */
	    add: function(child) {
	      if (arguments.length > 1) {
	        for (var i = 0; i < arguments.length; i++) {
	          this.add(arguments[i]);
	        }
	        return this;
	      }
	      if (child.getParent()) {
	        child.moveTo(this);
	        return this;
	      }
	      var children = this.children;
	      this._validateAdd(child);
	      child.index = children.length;
	      child.parent = this;
	      children.push(child);
	      this._fire('add', {
	        child: child
	      });
	
	      // if node under drag we need to update drag animation
	      if (Konva.DD && child.isDragging()) {
	        Konva.DD.anim.setLayers(child.getLayer());
	      }
	
	      // chainable
	      return this;
	    },
	    destroy: function() {
	      // destroy children
	      if (this.hasChildren()) {
	        this.destroyChildren();
	      }
	      // then destroy self
	      Konva.Node.prototype.destroy.call(this);
	      return this;
	    },
	    /**
	         * return a {@link Konva.Collection} of nodes that match the selector.  Use '#' for id selections
	         * and '.' for name selections.  You can also select by type or class name. Pass multiple selectors
	         * separated by a space.
	         * @method
	         * @memberof Konva.Container.prototype
	         * @param {String} selector
	         * @returns {Collection}
	         * @example
	         * // select node with id foo
	         * var node = stage.find('#foo');
	         *
	         * // select nodes with name bar inside layer
	         * var nodes = layer.find('.bar');
	         *
	         * // select all groups inside layer
	         * var nodes = layer.find('Group');
	         *
	         * // select all rectangles inside layer
	         * var nodes = layer.find('Rect');
	         *
	         * // select node with an id of foo or a name of bar inside layer
	         * var nodes = layer.find('#foo, .bar');
	         */
	    find: function(selector) {
	      var retArr = [],
	        selectorArr = selector.replace(/ /g, '').split(','),
	        len = selectorArr.length,
	        n,
	        i,
	        sel,
	        arr,
	        node,
	        children,
	        clen;
	
	      for (n = 0; n < len; n++) {
	        sel = selectorArr[n];
	        if (!Konva.Util.isValidSelector(sel)) {
	          Konva.Util.warn(
	            'Selector "' +
	              sel +
	              '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'
	          );
	          Konva.Util.warn(
	            'If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'
	          );
	          Konva.Util.warn('Konva is awesome, right?');
	        }
	        // id selector
	        if (sel.charAt(0) === '#') {
	          node = this._getNodeById(sel.slice(1));
	          if (node) {
	            retArr.push(node);
	          }
	        } else if (sel.charAt(0) === '.') {
	          // name selector
	          arr = this._getNodesByName(sel.slice(1));
	          retArr = retArr.concat(arr);
	        } else {
	          // unrecognized selector, pass to children
	          children = this.getChildren();
	          clen = children.length;
	          for (i = 0; i < clen; i++) {
	            retArr = retArr.concat(children[i]._get(sel));
	          }
	        }
	      }
	
	      return Konva.Collection.toCollection(retArr);
	    },
	    /**
	         * return a first node from `find` method
	         * @method
	         * @memberof Konva.Container.prototype
	         * @param {String} selector
	         * @returns {Konva.Node}
	         * @example
	         * // select node with id foo
	         * var node = stage.findOne('#foo');
	         *
	         * // select node with name bar inside layer
	         * var nodes = layer.findOne('.bar');
	         */
	    findOne: function(selector) {
	      return this.find(selector)[0];
	    },
	    _getNodeById: function(key) {
	      var node = Konva.ids[key];
	
	      if (node !== undefined && this.isAncestorOf(node)) {
	        return node;
	      }
	      return null;
	    },
	    _getNodesByName: function(key) {
	      var arr = Konva.names[key] || [];
	      return this._getDescendants(arr);
	    },
	    _get: function(selector) {
	      var retArr = Konva.Node.prototype._get.call(this, selector);
	      var children = this.getChildren();
	      var len = children.length;
	      for (var n = 0; n < len; n++) {
	        retArr = retArr.concat(children[n]._get(selector));
	      }
	      return retArr;
	    },
	    // extenders
	    toObject: function() {
	      var obj = Konva.Node.prototype.toObject.call(this);
	
	      obj.children = [];
	
	      var children = this.getChildren();
	      var len = children.length;
	      for (var n = 0; n < len; n++) {
	        var child = children[n];
	        obj.children.push(child.toObject());
	      }
	
	      return obj;
	    },
	    _getDescendants: function(arr) {
	      var retArr = [];
	      var len = arr.length;
	      for (var n = 0; n < len; n++) {
	        var node = arr[n];
	        if (this.isAncestorOf(node)) {
	          retArr.push(node);
	        }
	      }
	
	      return retArr;
	    },
	    /**
	         * determine if node is an ancestor
	         * of descendant
	         * @method
	         * @memberof Konva.Container.prototype
	         * @param {Konva.Node} node
	         */
	    isAncestorOf: function(node) {
	      var parent = node.getParent();
	      while (parent) {
	        if (parent._id === this._id) {
	          return true;
	        }
	        parent = parent.getParent();
	      }
	
	      return false;
	    },
	    clone: function(obj) {
	      // call super method
	      var node = Konva.Node.prototype.clone.call(this, obj);
	
	      this.getChildren().each(function(no) {
	        node.add(no.clone());
	      });
	      return node;
	    },
	    /**
	         * get all shapes that intersect a point.  Note: because this method must clear a temporary
	         * canvas and redraw every shape inside the container, it should only be used for special sitations
	         * because it performs very poorly.  Please use the {@link Konva.Stage#getIntersection} method if at all possible
	         * because it performs much better
	         * @method
	         * @memberof Konva.Container.prototype
	         * @param {Object} pos
	         * @param {Number} pos.x
	         * @param {Number} pos.y
	         * @returns {Array} array of shapes
	         */
	    getAllIntersections: function(pos) {
	      var arr = [];
	
	      this.find('Shape').each(function(shape) {
	        if (shape.isVisible() && shape.intersects(pos)) {
	          arr.push(shape);
	        }
	      });
	
	      return arr;
	    },
	    _setChildrenIndices: function() {
	      this.children.each(function(child, n) {
	        child.index = n;
	      });
	    },
	    drawScene: function(can, top, caching) {
	      var layer = this.getLayer(),
	        canvas = can || (layer && layer.getCanvas()),
	        context = canvas && canvas.getContext(),
	        cachedCanvas = this._cache.canvas,
	        cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
	
	      if (this.isVisible()) {
	        if (!caching && cachedSceneCanvas) {
	          context.save();
	          layer._applyTransform(this, context, top);
	          this._drawCachedSceneCanvas(context);
	          context.restore();
	        } else {
	          this._drawChildren(canvas, 'drawScene', top, false, caching);
	        }
	      }
	      return this;
	    },
	    drawHit: function(can, top, caching) {
	      var layer = this.getLayer(),
	        canvas = can || (layer && layer.hitCanvas),
	        context = canvas && canvas.getContext(),
	        cachedCanvas = this._cache.canvas,
	        cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
	
	      if (this.shouldDrawHit(canvas)) {
	        if (layer) {
	          layer.clearHitCache();
	        }
	        if (!caching && cachedHitCanvas) {
	          context.save();
	          layer._applyTransform(this, context, top);
	          this._drawCachedHitCanvas(context);
	          context.restore();
	        } else {
	          this._drawChildren(canvas, 'drawHit', top);
	        }
	      }
	      return this;
	    },
	    _drawChildren: function(canvas, drawMethod, top, caching, skipBuffer) {
	      var layer = this.getLayer(),
	        context = canvas && canvas.getContext(),
	        clipWidth = this.getClipWidth(),
	        clipHeight = this.getClipHeight(),
	        clipFunc = this.getClipFunc(),
	        hasClip = (clipWidth && clipHeight) || clipFunc,
	        clipX,
	        clipY;
	
	      if (hasClip && layer) {
	        context.save();
	        var transform = this.getAbsoluteTransform(top);
	        var m = transform.getMatrix();
	        context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	        context.beginPath();
	        if (clipFunc) {
	          clipFunc.call(this, context, this);
	        } else {
	          clipX = this.getClipX();
	          clipY = this.getClipY();
	          context.rect(clipX, clipY, clipWidth, clipHeight);
	        }
	        context.clip();
	        m = transform.copy().invert().getMatrix();
	        context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	      }
	
	      this.children.each(function(child) {
	        child[drawMethod](canvas, top, caching, skipBuffer);
	      });
	
	      if (hasClip) {
	        context.restore();
	      }
	    },
	    shouldDrawHit: function(canvas) {
	      var layer = this.getLayer();
	      var dd = Konva.DD;
	      var layerUnderDrag =
	        dd &&
	        Konva.isDragging() &&
	        Konva.DD.anim.getLayers().indexOf(layer) !== -1;
	      return (
	        (canvas && canvas.isCache) ||
	        (layer &&
	          layer.hitGraphEnabled() &&
	          this.isVisible() &&
	          !layerUnderDrag)
	      );
	    },
	    getClientRect: function(attrs) {
	      attrs = attrs || {};
	      var skipTransform = attrs.skipTransform;
	      var relativeTo = attrs.relativeTo;
	
	      var minX, minY, maxX, maxY;
	      var selfRect = {
	        x: 0,
	        y: 0,
	        width: 0,
	        height: 0
	      };
	      var that = this;
	      this.children.each(function(child) {
	        // skip invisible children
	        if (!child.isVisible()) {
	          return;
	        }
	        var rect = child.getClientRect({ relativeTo: that });
	
	        // skip invisible children (like empty groups)
	        // or don't skip... hmmm...
	        // if (rect.width === 0 && rect.height === 0) {
	        //     return;
	        // }
	
	        if (minX === undefined) {
	          // initial value for first child
	          minX = rect.x;
	          minY = rect.y;
	          maxX = rect.x + rect.width;
	          maxY = rect.y + rect.height;
	        } else {
	          minX = Math.min(minX, rect.x);
	          minY = Math.min(minY, rect.y);
	          maxX = Math.max(maxX, rect.x + rect.width);
	          maxY = Math.max(maxY, rect.y + rect.height);
	        }
	      });
	
	      if (this.children.length !== 0) {
	        selfRect = {
	          x: minX,
	          y: minY,
	          width: maxX - minX,
	          height: maxY - minY
	        };
	      }
	
	      if (!skipTransform) {
	        return this._transformedRect(selfRect, relativeTo);
	      }
	      return selfRect;
	    }
	  });
	
	  Konva.Util.extend(Konva.Container, Konva.Node);
	  // deprecated methods
	  Konva.Container.prototype.get = Konva.Container.prototype.find;
	
	  // add getters setters
	  Konva.Factory.addComponentsGetterSetter(Konva.Container, 'clip', [
	    'x',
	    'y',
	    'width',
	    'height'
	  ]);
	  /**
	     * get/set clip
	     * @method
	     * @name clip
	     * @memberof Konva.Container.prototype
	     * @param {Object} clip
	     * @param {Number} clip.x
	     * @param {Number} clip.y
	     * @param {Number} clip.width
	     * @param {Number} clip.height
	     * @returns {Object}
	     * @example
	     * // get clip
	     * var clip = container.clip();
	     *
	     * // set clip
	     * container.setClip({
	     *   x: 20,
	     *   y: 20,
	     *   width: 20,
	     *   height: 20
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Container, 'clipX');
	  /**
	     * get/set clip x
	     * @name clipX
	     * @method
	     * @memberof Konva.Container.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get clip x
	     * var clipX = container.clipX();
	     *
	     * // set clip x
	     * container.clipX(10);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Container, 'clipY');
	  /**
	     * get/set clip y
	     * @name clipY
	     * @method
	     * @memberof Konva.Container.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get clip y
	     * var clipY = container.clipY();
	     *
	     * // set clip y
	     * container.clipY(10);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Container, 'clipWidth');
	  /**
	     * get/set clip width
	     * @name clipWidth
	     * @method
	     * @memberof Konva.Container.prototype
	     * @param {Number} width
	     * @returns {Number}
	     * @example
	     * // get clip width
	     * var clipWidth = container.clipWidth();
	     *
	     * // set clip width
	     * container.clipWidth(100);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Container, 'clipHeight');
	  /**
	     * get/set clip height
	     * @name clipHeight
	     * @method
	     * @memberof Konva.Container.prototype
	     * @param {Number} height
	     * @returns {Number}
	     * @example
	     * // get clip height
	     * var clipHeight = container.clipHeight();
	     *
	     * // set clip height
	     * container.clipHeight(100);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Container, 'clipFunc');
	  /**
	      * get/set clip function
	      * @name clipFunc
	      * @method
	      * @memberof Konva.Container.prototype
	      * @param {Function} function
	      * @returns {Function}
	      * @example
	      * // get clip function
	      * var clipFunction = container.clipFunc();
	      *
	      * // set clip height
	      * container.clipFunc(function(ctx) {
	      *   ctx.rect(0, 0, 100, 100);
	      * });
	      */
	
	  Konva.Collection.mapMethods(Konva.Container);
	})();


/***/ }),
/* 342 */
/***/ (function(module, exports) {

	(function(Konva) {
	  'use strict';
	  var HAS_SHADOW = 'hasShadow';
	  var SHADOW_RGBA = 'shadowRGBA';
	
	  function _fillFunc(context) {
	    context.fill();
	  }
	  function _strokeFunc(context) {
	    context.stroke();
	  }
	  function _fillFuncHit(context) {
	    context.fill();
	  }
	  function _strokeFuncHit(context) {
	    context.stroke();
	  }
	
	  function _clearHasShadowCache() {
	    this._clearCache(HAS_SHADOW);
	  }
	
	  function _clearGetShadowRGBACache() {
	    this._clearCache(SHADOW_RGBA);
	  }
	
	  /**
	     * Shape constructor.  Shapes are primitive objects such as rectangles,
	     *  circles, text, lines, etc.
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Node
	     * @param {Object} config
	     * @@shapeParams
	     * @@nodeParams
	     * @example
	     * var customShape = new Konva.Shape({
	         *   x: 5,
	         *   y: 10,
	         *   fill: 'red',
	         *   // a Konva.Canvas renderer is passed into the drawFunc function
	         *   drawFunc: function(context) {
	         *     context.beginPath();
	         *     context.moveTo(200, 50);
	         *     context.lineTo(420, 80);
	         *     context.quadraticCurveTo(300, 100, 260, 170);
	         *     context.closePath();
	         *     context.fillStrokeShape(this);
	         *   }
	         *});
	     */
	  Konva.Shape = function(config) {
	    this.__init(config);
	  };
	
	  Konva.Util.addMethods(Konva.Shape, {
	    __init: function(config) {
	      this.nodeType = 'Shape';
	      this._fillFunc = _fillFunc;
	      this._strokeFunc = _strokeFunc;
	      this._fillFuncHit = _fillFuncHit;
	      this._strokeFuncHit = _strokeFuncHit;
	
	      // set colorKey
	      var shapes = Konva.shapes;
	      var key;
	
	      while (true) {
	        key = Konva.Util.getRandomColor();
	        if (key && !(key in shapes)) {
	          break;
	        }
	      }
	
	      this.colorKey = key;
	      shapes[key] = this;
	
	      // call super constructor
	      Konva.Node.call(this, config);
	
	      this.on(
	        'shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva',
	        _clearHasShadowCache
	      );
	
	      this.on(
	        'shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva',
	        _clearGetShadowRGBACache
	      );
	    },
	    hasChildren: function() {
	      return false;
	    },
	    getChildren: function() {
	      return [];
	    },
	    /**
	         * get canvas context tied to the layer
	         * @method
	         * @memberof Konva.Shape.prototype
	         * @returns {Konva.Context}
	         */
	    getContext: function() {
	      return this.getLayer().getContext();
	    },
	    /**
	         * get canvas renderer tied to the layer.  Note that this returns a canvas renderer, not a canvas element
	         * @method
	         * @memberof Konva.Shape.prototype
	         * @returns {Konva.Canvas}
	         */
	    getCanvas: function() {
	      return this.getLayer().getCanvas();
	    },
	    /**
	         * returns whether or not a shadow will be rendered
	         * @method
	         * @memberof Konva.Shape.prototype
	         * @returns {Boolean}
	         */
	    hasShadow: function() {
	      return this._getCache(HAS_SHADOW, this._hasShadow);
	    },
	    _hasShadow: function() {
	      return (
	        this.getShadowEnabled() &&
	        (this.getShadowOpacity() !== 0 &&
	          !!(this.getShadowColor() ||
	            this.getShadowBlur() ||
	            this.getShadowOffsetX() ||
	            this.getShadowOffsetY()))
	      );
	    },
	    getShadowRGBA: function() {
	      return this._getCache(SHADOW_RGBA, this._getShadowRGBA);
	    },
	    _getShadowRGBA: function() {
	      if (this.hasShadow()) {
	        var rgba = Konva.Util.colorToRGBA(this.shadowColor());
	        return (
	          'rgba(' +
	          rgba.r +
	          ',' +
	          rgba.g +
	          ',' +
	          rgba.b +
	          ',' +
	          rgba.a * (this.getShadowOpacity() || 1) +
	          ')'
	        );
	      }
	    },
	    /**
	         * returns whether or not the shape will be filled
	         * @method
	         * @memberof Konva.Shape.prototype
	         * @returns {Boolean}
	         */
	    hasFill: function() {
	      return !!(this.getFill() ||
	        this.getFillPatternImage() ||
	        this.getFillLinearGradientColorStops() ||
	        this.getFillRadialGradientColorStops());
	    },
	    /**
	         * returns whether or not the shape will be stroked
	         * @method
	         * @memberof Konva.Shape.prototype
	         * @returns {Boolean}
	         */
	    hasStroke: function() {
	      return this.strokeEnabled() && !!this.stroke();
	    },
	    /**
	         * determines if point is in the shape, regardless if other shapes are on top of it.  Note: because
	         *  this method clears a temporary canvas and then redraws the shape, it performs very poorly if executed many times
	         *  consecutively.  Please use the {@link Konva.Stage#getIntersection} method if at all possible
	         *  because it performs much better
	         * @method
	         * @memberof Konva.Shape.prototype
	         * @param {Object} point
	         * @param {Number} point.x
	         * @param {Number} point.y
	         * @returns {Boolean}
	         */
	    intersects: function(point) {
	      var stage = this.getStage(), bufferHitCanvas = stage.bufferHitCanvas, p;
	
	      bufferHitCanvas.getContext().clear();
	      this.drawHit(bufferHitCanvas);
	      p = bufferHitCanvas.context.getImageData(
	        Math.round(point.x),
	        Math.round(point.y),
	        1,
	        1
	      ).data;
	      return p[3] > 0;
	    },
	    // extends Node.prototype.destroy
	    destroy: function() {
	      Konva.Node.prototype.destroy.call(this);
	      delete Konva.shapes[this.colorKey];
	      return this;
	    },
	    _useBufferCanvas: function(caching) {
	      return (
	        (!caching &&
	          (this.perfectDrawEnabled() &&
	            this.getAbsoluteOpacity() !== 1 &&
	            this.hasFill() &&
	            this.hasStroke() &&
	            this.getStage())) ||
	        (this.perfectDrawEnabled() &&
	          this.hasShadow() &&
	          this.getAbsoluteOpacity() !== 1 &&
	          this.hasFill() &&
	          this.hasStroke() &&
	          this.getStage())
	      );
	    },
	    /**
	         * return self rectangle (x, y, width, height) of shape.
	         * This method are not taken into account transformation and styles.
	         * @method
	         * @memberof Konva.Shape.prototype
	         * @returns {Object} rect with {x, y, width, height} properties
	         * @example
	         *
	         * rect.getSelfRect();  // return {x:0, y:0, width:rect.width(), height:rect.height()}
	         * circle.getSelfRect();  // return {x: - circle.width() / 2, y: - circle.height() / 2, width:circle.width(), height:circle.height()}
	         *
	         */
	    getSelfRect: function() {
	      var size = this.getSize();
	      return {
	        x: this._centroid ? Math.round(-size.width / 2) : 0,
	        y: this._centroid ? Math.round(-size.height / 2) : 0,
	        width: size.width,
	        height: size.height
	      };
	    },
	    getClientRect: function(attrs) {
	      attrs = attrs || {};
	      var skipTransform = attrs.skipTransform;
	      var relativeTo = attrs.relativeTo;
	
	      var fillRect = this.getSelfRect();
	
	      var strokeWidth = (this.hasStroke() && this.strokeWidth()) || 0;
	      var fillAndStrokeWidth = fillRect.width + strokeWidth;
	      var fillAndStrokeHeight = fillRect.height + strokeWidth;
	
	      var shadowOffsetX = this.hasShadow() ? this.shadowOffsetX() : 0;
	      var shadowOffsetY = this.hasShadow() ? this.shadowOffsetY() : 0;
	
	      var preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
	      var preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
	
	      var blurRadius = (this.hasShadow() && this.shadowBlur()) || 0;
	
	      var width = preWidth + blurRadius * 2;
	      var height = preHeight + blurRadius * 2;
	
	      // if stroke, for example = 3
	      // we need to set x to 1.5, but after Math.round it will be 2
	      // as we have additional offset we need to increase width and height by 1 pixel
	      var roundingOffset = 0;
	      if (Math.round(strokeWidth / 2) !== strokeWidth / 2) {
	        roundingOffset = 1;
	      }
	      var rect = {
	        width: width + roundingOffset,
	        height: height + roundingOffset,
	        x: -Math.round(strokeWidth / 2 + blurRadius) +
	          Math.min(shadowOffsetX, 0) +
	          fillRect.x,
	        y: -Math.round(strokeWidth / 2 + blurRadius) +
	          Math.min(shadowOffsetY, 0) +
	          fillRect.y
	      };
	      if (!skipTransform) {
	        return this._transformedRect(rect, relativeTo);
	      }
	      return rect;
	    },
	    drawScene: function(can, top, caching, skipBuffer) {
	      var layer = this.getLayer(),
	        canvas = can || layer.getCanvas(),
	        context = canvas.getContext(),
	        cachedCanvas = this._cache.canvas,
	        drawFunc = this.sceneFunc(),
	        hasShadow = this.hasShadow(),
	        hasStroke = this.hasStroke(),
	        stage,
	        bufferCanvas,
	        bufferContext;
	
	      if (!this.isVisible()) {
	        return this;
	      }
	      if (cachedCanvas) {
	        context.save();
	        layer._applyTransform(this, context, top);
	        this._drawCachedSceneCanvas(context);
	        context.restore();
	        return this;
	      }
	      if (!drawFunc) {
	        return this;
	      }
	      context.save();
	      // if buffer canvas is needed
	      if (this._useBufferCanvas(caching) && !skipBuffer) {
	        stage = this.getStage();
	        bufferCanvas = stage.bufferCanvas;
	        bufferContext = bufferCanvas.getContext();
	        bufferContext.clear();
	        bufferContext.save();
	        bufferContext._applyLineJoin(this);
	        // layer might be undefined if we are using cache before adding to layer
	        if (!caching) {
	          if (layer) {
	            layer._applyTransform(this, bufferContext, top);
	          } else {
	            var m = this.getAbsoluteTransform(top).getMatrix();
	            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	          }
	        }
	
	        drawFunc.call(this, bufferContext);
	        bufferContext.restore();
	
	        var ratio = bufferCanvas.pixelRatio;
	        if (hasShadow && !canvas.hitCanvas) {
	          context.save();
	
	          context._applyShadow(this);
	          context._applyOpacity(this);
	          context._applyGlobalCompositeOperation(this);
	          context.drawImage(
	            bufferCanvas._canvas,
	            0,
	            0,
	            bufferCanvas.width / ratio,
	            bufferCanvas.height / ratio
	          );
	          context.restore();
	        } else {
	          context._applyOpacity(this);
	          context._applyGlobalCompositeOperation(this);
	          context.drawImage(
	            bufferCanvas._canvas,
	            0,
	            0,
	            bufferCanvas.width / ratio,
	            bufferCanvas.height / ratio
	          );
	        }
	      } else {
	        // if buffer canvas is not needed
	        context._applyLineJoin(this);
	        // layer might be undefined if we are using cache before adding to layer
	        if (!caching) {
	          if (layer) {
	            layer._applyTransform(this, context, top);
	          } else {
	            var o = this.getAbsoluteTransform(top).getMatrix();
	            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
	          }
	        }
	
	        if (hasShadow && hasStroke && !canvas.hitCanvas) {
	          context.save();
	          // apply shadow
	          if (!caching) {
	            context._applyOpacity(this);
	            context._applyGlobalCompositeOperation(this);
	          }
	          context._applyShadow(this);
	
	          drawFunc.call(this, context);
	          context.restore();
	          // if shape has stroke we need to redraw shape
	          // otherwise we will see a shadow under stroke (and over fill)
	          // but I think this is unexpected behavior
	          if (this.hasFill() && this.getShadowForStrokeEnabled()) {
	            drawFunc.call(this, context);
	          }
	        } else if (hasShadow && !canvas.hitCanvas) {
	          context.save();
	          if (!caching) {
	            context._applyOpacity(this);
	            context._applyGlobalCompositeOperation(this);
	          }
	          context._applyShadow(this);
	          drawFunc.call(this, context);
	          context.restore();
	        } else {
	          if (!caching) {
	            context._applyOpacity(this);
	            context._applyGlobalCompositeOperation(this);
	          }
	          drawFunc.call(this, context);
	        }
	      }
	      context.restore();
	      return this;
	    },
	    drawHit: function(can, top, caching) {
	      var layer = this.getLayer(),
	        canvas = can || layer.hitCanvas,
	        context = canvas.getContext(),
	        drawFunc = this.hitFunc() || this.sceneFunc(),
	        cachedCanvas = this._cache.canvas,
	        cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
	
	      if (!this.shouldDrawHit(canvas)) {
	        return this;
	      }
	      if (layer) {
	        layer.clearHitCache();
	      }
	      if (cachedHitCanvas) {
	        context.save();
	        layer._applyTransform(this, context, top);
	        this._drawCachedHitCanvas(context);
	        context.restore();
	        return this;
	      }
	      if (!drawFunc) {
	        return this;
	      }
	      context.save();
	      context._applyLineJoin(this);
	      if (!caching) {
	        if (layer) {
	          layer._applyTransform(this, context, top);
	        } else {
	          var o = this.getAbsoluteTransform(top).getMatrix();
	          context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
	        }
	      }
	      drawFunc.call(this, context);
	      context.restore();
	      return this;
	    },
	    /**
	        * draw hit graph using the cached scene canvas
	        * @method
	        * @memberof Konva.Shape.prototype
	        * @param {Integer} alphaThreshold alpha channel threshold that determines whether or not
	        *  a pixel should be drawn onto the hit graph.  Must be a value between 0 and 255.
	        *  The default is 0
	        * @returns {Konva.Shape}
	        * @example
	        * shape.cache();
	        * shape.drawHitFromCache();
	        */
	    drawHitFromCache: function(alphaThreshold) {
	      var threshold = alphaThreshold || 0,
	        cachedCanvas = this._cache.canvas,
	        sceneCanvas = this._getCachedSceneCanvas(),
	        hitCanvas = cachedCanvas.hit,
	        hitContext = hitCanvas.getContext(),
	        hitWidth = hitCanvas.getWidth(),
	        hitHeight = hitCanvas.getHeight(),
	        hitImageData,
	        hitData,
	        len,
	        rgbColorKey,
	        i,
	        alpha;
	
	      hitContext.clear();
	      hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
	
	      try {
	        hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
	        hitData = hitImageData.data;
	        len = hitData.length;
	        rgbColorKey = Konva.Util._hexToRgb(this.colorKey);
	
	        // replace non transparent pixels with color key
	        for (i = 0; i < len; i += 4) {
	          alpha = hitData[i + 3];
	          if (alpha > threshold) {
	            hitData[i] = rgbColorKey.r;
	            hitData[i + 1] = rgbColorKey.g;
	            hitData[i + 2] = rgbColorKey.b;
	            hitData[i + 3] = 255;
	          } else {
	            hitData[i + 3] = 0;
	          }
	        }
	        hitContext.putImageData(hitImageData, 0, 0);
	      } catch (e) {
	        Konva.Util.error(
	          'Unable to draw hit graph from cached scene canvas. ' + e.message
	        );
	      }
	
	      return this;
	    }
	  });
	  Konva.Util.extend(Konva.Shape, Konva.Node);
	
	  // add getters and setters
	  Konva.Factory.addGetterSetter(Konva.Shape, 'stroke');
	
	  /**
	     * get/set stroke color
	     * @name stroke
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {String} color
	     * @returns {String}
	     * @example
	     * // get stroke color
	     * var stroke = shape.stroke();
	     *
	     * // set stroke color with color string
	     * shape.stroke('green');
	     *
	     * // set stroke color with hex
	     * shape.stroke('#00ff00');
	     *
	     * // set stroke color with rgb
	     * shape.stroke('rgb(0,255,0)');
	     *
	     * // set stroke color with rgba and make it 50% opaque
	     * shape.stroke('rgba(0,255,0,0.5');
	     */
	
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'strokeRed',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'strokeGreen',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'strokeBlue',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'strokeAlpha',
	    1,
	    Konva.Validators.alphaComponent
	  );
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'strokeWidth', 2);
	
	  /**
	     * get/set stroke width
	     * @name strokeWidth
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} strokeWidth
	     * @returns {Number}
	     * @example
	     * // get stroke width
	     * var strokeWidth = shape.strokeWidth();
	     *
	     * // set stroke width
	     * shape.strokeWidth();
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'strokeHitEnabled', true);
	
	  /**
	     * get/set strokeHitEnabled property. Useful for performance optimization.
	     * You may set `shape.strokeHitEnabled(false)`. In this case stroke will be no draw on hit canvas, so hit area
	     * of shape will be decreased (by lineWidth / 2). Remember that non closed line with `strokeHitEnabled = false`
	     * will be not drawn on hit canvas, that is mean line will no trigger pointer events (like mouseover)
	     * Default value is true
	     * @name strokeHitEnabled
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Boolean} strokeHitEnabled
	     * @returns {Boolean}
	     * @example
	     * // get strokeHitEnabled
	     * var strokeHitEnabled = shape.strokeHitEnabled();
	     *
	     * // set strokeHitEnabled
	     * shape.strokeHitEnabled();
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'perfectDrawEnabled', true);
	
	  /**
	     * get/set perfectDrawEnabled. If a shape has fill, stroke and opacity you may set `perfectDrawEnabled` to false to improve performance.
	     * See http://konvajs.github.io/docs/performance/Disable_Perfect_Draw.html for more information.
	     * Default value is true
	     * @name perfectDrawEnabled
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Boolean} perfectDrawEnabled
	     * @returns {Boolean}
	     * @example
	     * // get perfectDrawEnabled
	     * var perfectDrawEnabled = shape.perfectDrawEnabled();
	     *
	     * // set perfectDrawEnabled
	     * shape.perfectDrawEnabled();
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'shadowForStrokeEnabled', true);
	
	  /**
	     * get/set shadowForStrokeEnabled. Useful for performance optimization.
	     * You may set `shape.shadowForStrokeEnabled(false)`. In this case stroke will be no draw shadow for stroke.
	     * Remember if you set `shadowForStrokeEnabled = false` for non closed line - that line with have no shadow!.
	     * Default value is true
	     * @name shadowForStrokeEnabled
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Boolean} shadowForStrokeEnabled
	     * @returns {Boolean}
	     * @example
	     * // get shadowForStrokeEnabled
	     * var shadowForStrokeEnabled = shape.shadowForStrokeEnabled();
	     *
	     * // set shadowForStrokeEnabled
	     * shape.shadowForStrokeEnabled();
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'lineJoin');
	
	  /**
	     * get/set line join.  Can be miter, round, or bevel.  The
	     *  default is miter
	     * @name lineJoin
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {String} lineJoin
	     * @returns {String}
	     * @example
	     * // get line join
	     * var lineJoin = shape.lineJoin();
	     *
	     * // set line join
	     * shape.lineJoin('round');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'lineCap');
	
	  /**
	     * get/set line cap.  Can be butt, round, or square
	     * @name lineCap
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {String} lineCap
	     * @returns {String}
	     * @example
	     * // get line cap
	     * var lineCap = shape.lineCap();
	     *
	     * // set line cap
	     * shape.lineCap('round');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'sceneFunc');
	
	  /**
	     * get/set scene draw function
	     * @name sceneFunc
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Function} drawFunc drawing function
	     * @returns {Function}
	     * @example
	     * // get scene draw function
	     * var sceneFunc = shape.sceneFunc();
	     *
	     * // set scene draw function
	     * shape.sceneFunc(function(context) {
	     *   context.beginPath();
	     *   context.rect(0, 0, this.width(), this.height());
	     *   context.closePath();
	     *   context.fillStrokeShape(this);
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'hitFunc');
	
	  /**
	     * get/set hit draw function
	     * @name hitFunc
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Function} drawFunc drawing function
	     * @returns {Function}
	     * @example
	     * // get hit draw function
	     * var hitFunc = shape.hitFunc();
	     *
	     * // set hit draw function
	     * shape.hitFunc(function(context) {
	     *   context.beginPath();
	     *   context.rect(0, 0, this.width(), this.height());
	     *   context.closePath();
	     *   context.fillStrokeShape(this);
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'dash');
	
	  /**
	     * get/set dash array for stroke.
	     * @name dash
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Array} dash
	     * @returns {Array}
	     * @example
	     *  // apply dashed stroke that is 10px long and 5 pixels apart
	     *  line.dash([10, 5]);
	     *  // apply dashed stroke that is made up of alternating dashed
	     *  // lines that are 10px long and 20px apart, and dots that have
	     *  // a radius of 5px and are 20px apart
	     *  line.dash([10, 20, 0.001, 20]);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'dashOffset', 0);
	
	  /**
	     * get/set dash offset for stroke.
	     * @name dash
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} dash offset
	     * @returns {Number}
	     * @example
	     *  // apply dashed stroke that is 10px long and 5 pixels apart with an offset of 5px
	     *  line.dash([10, 5]);
	     *  line.dashOffset(5);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'shadowColor');
	
	  /**
	     * get/set shadow color
	     * @name shadowColor
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {String} color
	     * @returns {String}
	     * @example
	     * // get shadow color
	     * var shadow = shape.shadowColor();
	     *
	     * // set shadow color with color string
	     * shape.shadowColor('green');
	     *
	     * // set shadow color with hex
	     * shape.shadowColor('#00ff00');
	     *
	     * // set shadow color with rgb
	     * shape.shadowColor('rgb(0,255,0)');
	     *
	     * // set shadow color with rgba and make it 50% opaque
	     * shape.shadowColor('rgba(0,255,0,0.5');
	     */
	
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'shadowRed',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'shadowGreen',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'shadowBlue',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'shadowAlpha',
	    1,
	    Konva.Validators.alphaComponent
	  );
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'shadowBlur');
	
	  /**
	     * get/set shadow blur
	     * @name shadowBlur
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} blur
	     * @returns {Number}
	     * @example
	     * // get shadow blur
	     * var shadowBlur = shape.shadowBlur();
	     *
	     * // set shadow blur
	     * shape.shadowBlur(10);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'shadowOpacity');
	
	  /**
	     * get/set shadow opacity.  must be a value between 0 and 1
	     * @name shadowOpacity
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} opacity
	     * @returns {Number}
	     * @example
	     * // get shadow opacity
	     * var shadowOpacity = shape.shadowOpacity();
	     *
	     * // set shadow opacity
	     * shape.shadowOpacity(0.5);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(Konva.Shape, 'shadowOffset', [
	    'x',
	    'y'
	  ]);
	
	  /**
	     * get/set shadow offset
	     * @name shadowOffset
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Object} offset
	     * @param {Number} offset.x
	     * @param {Number} offset.y
	     * @returns {Object}
	     * @example
	     * // get shadow offset
	     * var shadowOffset = shape.shadowOffset();
	     *
	     * // set shadow offset
	     * shape.shadowOffset({
	     *   x: 20
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'shadowOffsetX', 0);
	
	  /**
	     * get/set shadow offset x
	     * @name shadowOffsetX
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get shadow offset x
	     * var shadowOffsetX = shape.shadowOffsetX();
	     *
	     * // set shadow offset x
	     * shape.shadowOffsetX(5);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'shadowOffsetY', 0);
	
	  /**
	     * get/set shadow offset y
	     * @name shadowOffsetY
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get shadow offset y
	     * var shadowOffsetY = shape.shadowOffsetY();
	     *
	     * // set shadow offset y
	     * shape.shadowOffsetY(5);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternImage');
	
	  /**
	     * get/set fill pattern image
	     * @name fillPatternImage
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Image} image object
	     * @returns {Image}
	     * @example
	     * // get fill pattern image
	     * var fillPatternImage = shape.fillPatternImage();
	     *
	     * // set fill pattern image
	     * var imageObj = new Image();
	     * imageObj.onload = function() {
	     *   shape.fillPatternImage(imageObj);
	     * };
	     * imageObj.src = 'path/to/image/jpg';
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fill');
	
	  /**
	     * get/set fill color
	     * @name fill
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {String} color
	     * @returns {String}
	     * @example
	     * // get fill color
	     * var fill = shape.fill();
	     *
	     * // set fill color with color string
	     * shape.fill('green');
	     *
	     * // set fill color with hex
	     * shape.fill('#00ff00');
	     *
	     * // set fill color with rgb
	     * shape.fill('rgb(0,255,0)');
	     *
	     * // set fill color with rgba and make it 50% opaque
	     * shape.fill('rgba(0,255,0,0.5');
	     *
	     * // shape without fill
	     * shape.fill(null);
	     */
	
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'fillRed',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'fillGreen',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'fillBlue',
	    0,
	    Konva.Validators.RGBComponent
	  );
	  Konva.Factory.addDeprecatedGetterSetter(
	    Konva.Shape,
	    'fillAlpha',
	    1,
	    Konva.Validators.alphaComponent
	  );
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternX', 0);
	
	  /**
	     * get/set fill pattern x
	     * @name fillPatternX
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get fill pattern x
	     * var fillPatternX = shape.fillPatternX();
	     * // set fill pattern x
	     * shape.fillPatternX(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternY', 0);
	
	  /**
	     * get/set fill pattern y
	     * @name fillPatternY
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get fill pattern y
	     * var fillPatternY = shape.fillPatternY();
	     * // set fill pattern y
	     * shape.fillPatternY(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillLinearGradientColorStops');
	
	  /**
	     * get/set fill linear gradient color stops
	     * @name fillLinearGradientColorStops
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Array} colorStops
	     * @returns {Array} colorStops
	     * @example
	     * // get fill linear gradient color stops
	     * var colorStops = shape.fillLinearGradientColorStops();
	     *
	     * // create a linear gradient that starts with red, changes to blue
	     * // halfway through, and then changes to green
	     * shape.fillLinearGradientColorStops(0, 'red', 0.5, 'blue', 1, 'green');
	     */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Shape,
	    'fillRadialGradientStartRadius',
	    0
	  );
	
	  /**
	     * get/set fill radial gradient start radius
	     * @name fillRadialGradientStartRadius
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} radius
	     * @returns {Number}
	     * @example
	     * // get radial gradient start radius
	     * var startRadius = shape.fillRadialGradientStartRadius();
	     *
	     * // set radial gradient start radius
	     * shape.fillRadialGradientStartRadius(0);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillRadialGradientEndRadius', 0);
	
	  /**
	     * get/set fill radial gradient end radius
	     * @name fillRadialGradientEndRadius
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} radius
	     * @returns {Number}
	     * @example
	     * // get radial gradient end radius
	     * var endRadius = shape.fillRadialGradientEndRadius();
	     *
	     * // set radial gradient end radius
	     * shape.fillRadialGradientEndRadius(100);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillRadialGradientColorStops');
	
	  /**
	     * get/set fill radial gradient color stops
	     * @name fillRadialGradientColorStops
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} colorStops
	     * @returns {Array}
	     * @example
	     * // get fill radial gradient color stops
	     * var colorStops = shape.fillRadialGradientColorStops();
	     *
	     * // create a radial gradient that starts with red, changes to blue
	     * // halfway through, and then changes to green
	     * shape.fillRadialGradientColorStops(0, 'red', 0.5, 'blue', 1, 'green');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternRepeat', 'repeat');
	
	  /**
	     * get/set fill pattern repeat.  Can be 'repeat', 'repeat-x', 'repeat-y', or 'no-repeat'.  The default is 'repeat'
	     * @name fillPatternRepeat
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {String} repeat
	     * @returns {String}
	     * @example
	     * // get fill pattern repeat
	     * var repeat = shape.fillPatternRepeat();
	     *
	     * // repeat pattern in x direction only
	     * shape.fillPatternRepeat('repeat-x');
	     *
	     * // do not repeat the pattern
	     * shape.fillPatternRepeat('no repeat');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillEnabled', true);
	
	  /**
	     * get/set fill enabled flag
	     * @name fillEnabled
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Boolean} enabled
	     * @returns {Boolean}
	     * @example
	     * // get fill enabled flag
	     * var fillEnabled = shape.fillEnabled();
	     *
	     * // disable fill
	     * shape.fillEnabled(false);
	     *
	     * // enable fill
	     * shape.fillEnabled(true);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'strokeEnabled', true);
	
	  /**
	     * get/set stroke enabled flag
	     * @name strokeEnabled
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Boolean} enabled
	     * @returns {Boolean}
	     * @example
	     * // get stroke enabled flag
	     * var strokeEnabled = shape.strokeEnabled();
	     *
	     * // disable stroke
	     * shape.strokeEnabled(false);
	     *
	     * // enable stroke
	     * shape.strokeEnabled(true);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'shadowEnabled', true);
	
	  /**
	     * get/set shadow enabled flag
	     * @name shadowEnabled
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Boolean} enabled
	     * @returns {Boolean}
	     * @example
	     * // get shadow enabled flag
	     * var shadowEnabled = shape.shadowEnabled();
	     *
	     * // disable shadow
	     * shape.shadowEnabled(false);
	     *
	     * // enable shadow
	     * shape.shadowEnabled(true);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'dashEnabled', true);
	
	  /**
	     * get/set dash enabled flag
	     * @name dashEnabled
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Boolean} enabled
	     * @returns {Boolean}
	     * @example
	     * // get dash enabled flag
	     * var dashEnabled = shape.dashEnabled();
	     *
	     * // disable dash
	     * shape.dashEnabled(false);
	     *
	     * // enable dash
	     * shape.dashEnabled(true);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'strokeScaleEnabled', true);
	
	  /**
	     * get/set strokeScale enabled flag
	     * @name strokeScaleEnabled
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Boolean} enabled
	     * @returns {Boolean}
	     * @example
	     * // get stroke scale enabled flag
	     * var strokeScaleEnabled = shape.strokeScaleEnabled();
	     *
	     * // disable stroke scale
	     * shape.strokeScaleEnabled(false);
	     *
	     * // enable stroke scale
	     * shape.strokeScaleEnabled(true);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPriority', 'color');
	
	  /**
	     * get/set fill priority.  can be color, pattern, linear-gradient, or radial-gradient.  The default is color.
	     *   This is handy if you want to toggle between different fill types.
	     * @name fillPriority
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {String} priority
	     * @returns {String}
	     * @example
	     * // get fill priority
	     * var fillPriority = shape.fillPriority();
	     *
	     * // set fill priority
	     * shape.fillPriority('linear-gradient');
	     */
	
	  Konva.Factory.addComponentsGetterSetter(Konva.Shape, 'fillPatternOffset', [
	    'x',
	    'y'
	  ]);
	
	  /**
	     * get/set fill pattern offset
	     * @name fillPatternOffset
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Object} offset
	     * @param {Number} offset.x
	     * @param {Number} offset.y
	     * @returns {Object}
	     * @example
	     * // get fill pattern offset
	     * var patternOffset = shape.fillPatternOffset();
	     *
	     * // set fill pattern offset
	     * shape.fillPatternOffset({
	     *   x: 20
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternOffsetX', 0);
	  /**
	     * get/set fill pattern offset x
	     * @name fillPatternOffsetX
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get fill pattern offset x
	     * var patternOffsetX = shape.fillPatternOffsetX();
	     *
	     * // set fill pattern offset x
	     * shape.fillPatternOffsetX(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternOffsetY', 0);
	  /**
	     * get/set fill pattern offset y
	     * @name fillPatternOffsetY
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get fill pattern offset y
	     * var patternOffsetY = shape.fillPatternOffsetY();
	     *
	     * // set fill pattern offset y
	     * shape.fillPatternOffsetY(10);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(Konva.Shape, 'fillPatternScale', [
	    'x',
	    'y'
	  ]);
	
	  /**
	     * get/set fill pattern scale
	     * @name fillPatternScale
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Object} scale
	     * @param {Number} scale.x
	     * @param {Number} scale.y
	     * @returns {Object}
	     * @example
	     * // get fill pattern scale
	     * var patternScale = shape.fillPatternScale();
	     *
	     * // set fill pattern scale
	     * shape.fillPatternScale({
	     *   x: 2
	     *   y: 2
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternScaleX', 1);
	  /**
	     * get/set fill pattern scale x
	     * @name fillPatternScaleX
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get fill pattern scale x
	     * var patternScaleX = shape.fillPatternScaleX();
	     *
	     * // set fill pattern scale x
	     * shape.fillPatternScaleX(2);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternScaleY', 1);
	  /**
	     * get/set fill pattern scale y
	     * @name fillPatternScaleY
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get fill pattern scale y
	     * var patternScaleY = shape.fillPatternScaleY();
	     *
	     * // set fill pattern scale y
	     * shape.fillPatternScaleY(2);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(
	    Konva.Shape,
	    'fillLinearGradientStartPoint',
	    ['x', 'y']
	  );
	
	  /**
	     * get/set fill linear gradient start point
	     * @name fillLinearGradientStartPoint
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Object} startPoint
	     * @param {Number} startPoint.x
	     * @param {Number} startPoint.y
	     * @returns {Object}
	     * @example
	     * // get fill linear gradient start point
	     * var startPoint = shape.fillLinearGradientStartPoint();
	     *
	     * // set fill linear gradient start point
	     * shape.fillLinearGradientStartPoint({
	     *   x: 20
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Shape,
	    'fillLinearGradientStartPointX',
	    0
	  );
	  /**
	     * get/set fill linear gradient start point x
	     * @name fillLinearGradientStartPointX
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get fill linear gradient start point x
	     * var startPointX = shape.fillLinearGradientStartPointX();
	     *
	     * // set fill linear gradient start point x
	     * shape.fillLinearGradientStartPointX(20);
	     */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Shape,
	    'fillLinearGradientStartPointY',
	    0
	  );
	  /**
	     * get/set fill linear gradient start point y
	     * @name fillLinearGradientStartPointY
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get fill linear gradient start point y
	     * var startPointY = shape.fillLinearGradientStartPointY();
	     *
	     * // set fill linear gradient start point y
	     * shape.fillLinearGradientStartPointY(20);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(
	    Konva.Shape,
	    'fillLinearGradientEndPoint',
	    ['x', 'y']
	  );
	
	  /**
	     * get/set fill linear gradient end point
	     * @name fillLinearGradientEndPoint
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Object} endPoint
	     * @param {Number} endPoint.x
	     * @param {Number} endPoint.y
	     * @returns {Object}
	     * @example
	     * // get fill linear gradient end point
	     * var endPoint = shape.fillLinearGradientEndPoint();
	     *
	     * // set fill linear gradient end point
	     * shape.fillLinearGradientEndPoint({
	     *   x: 20
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillLinearGradientEndPointX', 0);
	  /**
	     * get/set fill linear gradient end point x
	     * @name fillLinearGradientEndPointX
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get fill linear gradient end point x
	     * var endPointX = shape.fillLinearGradientEndPointX();
	     *
	     * // set fill linear gradient end point x
	     * shape.fillLinearGradientEndPointX(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillLinearGradientEndPointY', 0);
	  /**
	     * get/set fill linear gradient end point y
	     * @name fillLinearGradientEndPointY
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get fill linear gradient end point y
	     * var endPointY = shape.fillLinearGradientEndPointY();
	     *
	     * // set fill linear gradient end point y
	     * shape.fillLinearGradientEndPointY(20);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(
	    Konva.Shape,
	    'fillRadialGradientStartPoint',
	    ['x', 'y']
	  );
	
	  /**
	     * get/set fill radial gradient start point
	     * @name fillRadialGradientStartPoint
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Object} startPoint
	     * @param {Number} startPoint.x
	     * @param {Number} startPoint.y
	     * @returns {Object}
	     * @example
	     * // get fill radial gradient start point
	     * var startPoint = shape.fillRadialGradientStartPoint();
	     *
	     * // set fill radial gradient start point
	     * shape.fillRadialGradientStartPoint({
	     *   x: 20
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Shape,
	    'fillRadialGradientStartPointX',
	    0
	  );
	  /**
	     * get/set fill radial gradient start point x
	     * @name fillRadialGradientStartPointX
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get fill radial gradient start point x
	     * var startPointX = shape.fillRadialGradientStartPointX();
	     *
	     * // set fill radial gradient start point x
	     * shape.fillRadialGradientStartPointX(20);
	     */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Shape,
	    'fillRadialGradientStartPointY',
	    0
	  );
	  /**
	     * get/set fill radial gradient start point y
	     * @name fillRadialGradientStartPointY
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get fill radial gradient start point y
	     * var startPointY = shape.fillRadialGradientStartPointY();
	     *
	     * // set fill radial gradient start point y
	     * shape.fillRadialGradientStartPointY(20);
	     */
	
	  Konva.Factory.addComponentsGetterSetter(
	    Konva.Shape,
	    'fillRadialGradientEndPoint',
	    ['x', 'y']
	  );
	
	  /**
	     * get/set fill radial gradient end point
	     * @name fillRadialGradientEndPoint
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Object} endPoint
	     * @param {Number} endPoint.x
	     * @param {Number} endPoint.y
	     * @returns {Object}
	     * @example
	     * // get fill radial gradient end point
	     * var endPoint = shape.fillRadialGradientEndPoint();
	     *
	     * // set fill radial gradient end point
	     * shape.fillRadialGradientEndPoint({
	     *   x: 20
	     *   y: 10
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillRadialGradientEndPointX', 0);
	  /**
	     * get/set fill radial gradient end point x
	     * @name fillRadialGradientEndPointX
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get fill radial gradient end point x
	     * var endPointX = shape.fillRadialGradientEndPointX();
	     *
	     * // set fill radial gradient end point x
	     * shape.fillRadialGradientEndPointX(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillRadialGradientEndPointY', 0);
	  /**
	     * get/set fill radial gradient end point y
	     * @name fillRadialGradientEndPointY
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get fill radial gradient end point y
	     * var endPointY = shape.fillRadialGradientEndPointY();
	     *
	     * // set fill radial gradient end point y
	     * shape.fillRadialGradientEndPointY(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Shape, 'fillPatternRotation', 0);
	
	  /**
	     * get/set fill pattern rotation in degrees
	     * @name fillPatternRotation
	     * @method
	     * @memberof Konva.Shape.prototype
	     * @param {Number} rotation
	     * @returns {Konva.Shape}
	     * @example
	     * // get fill pattern rotation
	     * var patternRotation = shape.fillPatternRotation();
	     *
	     * // set fill pattern rotation
	     * shape.fillPatternRotation(20);
	     */
	
	  Konva.Factory.backCompat(Konva.Shape, {
	    dashArray: 'dash',
	    getDashArray: 'getDash',
	    setDashArray: 'getDash',
	
	    drawFunc: 'sceneFunc',
	    getDrawFunc: 'getSceneFunc',
	    setDrawFunc: 'setSceneFunc',
	
	    drawHitFunc: 'hitFunc',
	    getDrawHitFunc: 'getHitFunc',
	    setDrawHitFunc: 'setHitFunc'
	  });
	
	  Konva.Collection.mapMethods(Konva.Shape);
	})(Konva);


/***/ }),
/* 343 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';
	  // CONSTANTS
	  var STAGE = 'Stage',
	    STRING = 'string',
	    PX = 'px',
	    MOUSEOUT = 'mouseout',
	    MOUSELEAVE = 'mouseleave',
	    MOUSEOVER = 'mouseover',
	    MOUSEENTER = 'mouseenter',
	    MOUSEMOVE = 'mousemove',
	    MOUSEDOWN = 'mousedown',
	    MOUSEUP = 'mouseup',
	    CONTEXTMENU = 'contextmenu',
	    CLICK = 'click',
	    DBL_CLICK = 'dblclick',
	    TOUCHSTART = 'touchstart',
	    TOUCHEND = 'touchend',
	    TAP = 'tap',
	    DBL_TAP = 'dbltap',
	    TOUCHMOVE = 'touchmove',
	    WHEEL = 'wheel',
	    CONTENT_MOUSEOUT = 'contentMouseout',
	    CONTENT_MOUSEOVER = 'contentMouseover',
	    CONTENT_MOUSEMOVE = 'contentMousemove',
	    CONTENT_MOUSEDOWN = 'contentMousedown',
	    CONTENT_MOUSEUP = 'contentMouseup',
	    CONTENT_CONTEXTMENU = 'contentContextmenu',
	    CONTENT_CLICK = 'contentClick',
	    CONTENT_DBL_CLICK = 'contentDblclick',
	    CONTENT_TOUCHSTART = 'contentTouchstart',
	    CONTENT_TOUCHEND = 'contentTouchend',
	    CONTENT_DBL_TAP = 'contentDbltap',
	    CONTENT_TAP = 'contentTap',
	    CONTENT_TOUCHMOVE = 'contentTouchmove',
	    CONTENT_WHEEL = 'contentWheel',
	    DIV = 'div',
	    RELATIVE = 'relative',
	    KONVA_CONTENT = 'konvajs-content',
	    SPACE = ' ',
	    UNDERSCORE = '_',
	    CONTAINER = 'container',
	    EMPTY_STRING = '',
	    EVENTS = [
	      MOUSEDOWN,
	      MOUSEMOVE,
	      MOUSEUP,
	      MOUSEOUT,
	      TOUCHSTART,
	      TOUCHMOVE,
	      TOUCHEND,
	      MOUSEOVER,
	      WHEEL,
	      CONTEXTMENU
	    ],
	    // cached variables
	    eventsLength = EVENTS.length;
	
	  function addEvent(ctx, eventName) {
	    ctx.content.addEventListener(
	      eventName,
	      function(evt) {
	        ctx[UNDERSCORE + eventName](evt);
	      },
	      false
	    );
	  }
	
	  /**
	     * Stage constructor.  A stage is used to contain multiple layers
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Container
	     * @param {Object} config
	     * @param {String|Element} config.container Container selector or DOM element
	     * @@nodeParams
	     * @example
	     * var stage = new Konva.Stage({
	         *   width: 500,
	         *   height: 800,
	         *   container: 'containerId' // or "#containerId" or ".containerClass"
	         * });
	     */
	  Konva.Stage = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Util.addMethods(Konva.Stage, {
	    ___init: function(config) {
	      this.nodeType = STAGE;
	      // call super constructor
	      Konva.Container.call(this, config);
	      this._id = Konva.idCounter++;
	      this._buildDOM();
	      this._bindContentEvents();
	      this._enableNestedTransforms = false;
	      Konva.stages.push(this);
	    },
	    _validateAdd: function(child) {
	      if (child.getType() !== 'Layer') {
	        Konva.Util.throw('You may only add layers to the stage.');
	      }
	    },
	    /**
	         * set container dom element which contains the stage wrapper div element
	         * @method
	         * @memberof Konva.Stage.prototype
	         * @param {DomElement} container can pass in a dom element or id string
	         */
	    setContainer: function(container) {
	      if (typeof container === STRING) {
	        if (container.charAt(0) === '.') {
	          var className = container.slice(1);
	          container = Konva.document.getElementsByClassName(className)[0];
	        } else {
	          var id;
	          if (container.charAt(0) !== '#') {
	            id = container;
	          } else {
	            id = container.slice(1);
	          }
	          container = Konva.document.getElementById(id);
	        }
	        if (!container) {
	          throw 'Can not find container in document with id ' + id;
	        }
	      }
	      this._setAttr(CONTAINER, container);
	      return this;
	    },
	    shouldDrawHit: function() {
	      return true;
	    },
	    draw: function() {
	      Konva.Node.prototype.draw.call(this);
	      return this;
	    },
	    /**
	         * draw layer scene graphs
	         * @name draw
	         * @method
	         * @memberof Konva.Stage.prototype
	         */
	
	    /**
	         * draw layer hit graphs
	         * @name drawHit
	         * @method
	         * @memberof Konva.Stage.prototype
	         */
	
	    /**
	         * set height
	         * @method
	         * @memberof Konva.Stage.prototype
	         * @param {Number} height
	         */
	    setHeight: function(height) {
	      Konva.Node.prototype.setHeight.call(this, height);
	      this._resizeDOM();
	      return this;
	    },
	    /**
	         * set width
	         * @method
	         * @memberof Konva.Stage.prototype
	         * @param {Number} width
	         */
	    setWidth: function(width) {
	      Konva.Node.prototype.setWidth.call(this, width);
	      this._resizeDOM();
	      return this;
	    },
	    /**
	         * clear all layers
	         * @method
	         * @memberof Konva.Stage.prototype
	         */
	    clear: function() {
	      var layers = this.children,
	        len = layers.length,
	        n;
	
	      for (n = 0; n < len; n++) {
	        layers[n].clear();
	      }
	      return this;
	    },
	    clone: function(obj) {
	      if (!obj) {
	        obj = {};
	      }
	      obj.container = Konva.document.createElement(DIV);
	      return Konva.Container.prototype.clone.call(this, obj);
	    },
	    /**
	         * destroy stage
	         * @method
	         * @memberof Konva.Stage.prototype
	         */
	    destroy: function() {
	      var content = this.content;
	      Konva.Container.prototype.destroy.call(this);
	
	      if (content && Konva.Util._isInDocument(content)) {
	        this.getContainer().removeChild(content);
	      }
	      var index = Konva.stages.indexOf(this);
	      if (index > -1) {
	        Konva.stages.splice(index, 1);
	      }
	      return this;
	    },
	    /**
	         * get pointer position which can be a touch position or mouse position
	         * @method
	         * @memberof Konva.Stage.prototype
	         * @returns {Object}
	         */
	    getPointerPosition: function() {
	      return this.pointerPos;
	    },
	    getStage: function() {
	      return this;
	    },
	    /**
	         * get stage content div element which has the
	         *  the class name "konvajs-content"
	         * @method
	         * @memberof Konva.Stage.prototype
	         */
	    getContent: function() {
	      return this.content;
	    },
	    /**
	         * Creates a composite data URL
	         * @method
	         * @memberof Konva.Stage.prototype
	         * @param {Object} config
	         * @param {Function} [config.callback] function executed when the composite has completed. Deprecated as method is sync now.
	         * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
	         *  "image/png" is the default
	         * @param {Number} [config.x] x position of canvas section
	         * @param {Number} [config.y] y position of canvas section
	         * @param {Number} [config.width] width of canvas section
	         * @param {Number} [config.height] height of canvas section
	         * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
	         *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
	         *  is very high quality
	         */
	    toDataURL: function(config) {
	      config = config || {};
	
	      var mimeType = config.mimeType || null,
	        quality = config.quality || null,
	        x = config.x || 0,
	        y = config.y || 0,
	        canvas = new Konva.SceneCanvas({
	          width: config.width || this.getWidth(),
	          height: config.height || this.getHeight(),
	          pixelRatio: config.pixelRatio
	        }),
	        _context = canvas.getContext()._context,
	        layers = this.children;
	
	      if (x || y) {
	        _context.translate(-1 * x, -1 * y);
	      }
	
	      layers.each(function(layer) {
	        var width = layer.getCanvas().getWidth();
	        var height = layer.getCanvas().getHeight();
	        var ratio = layer.getCanvas().getPixelRatio();
	        _context.drawImage(
	          layer.getCanvas()._canvas,
	          0,
	          0,
	          width / ratio,
	          height / ratio
	        );
	      });
	      var src = canvas.toDataURL(mimeType, quality);
	
	      if (config.callback) {
	        config.callback(src);
	      }
	
	      return src;
	    },
	    /**
	         * converts stage into an image.
	         * @method
	         * @memberof Konva.Stage.prototype
	         * @param {Object} config
	         * @param {Function} config.callback function executed when the composite has completed
	         * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
	         *  "image/png" is the default
	         * @param {Number} [config.x] x position of canvas section
	         * @param {Number} [config.y] y position of canvas section
	         * @param {Number} [config.width] width of canvas section
	         * @param {Number} [config.height] height of canvas section
	         * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
	         *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
	         *  is very high quality
	         */
	    toImage: function(config) {
	      var cb = config.callback;
	
	      config.callback = function(dataUrl) {
	        Konva.Util._getImage(dataUrl, function(img) {
	          cb(img);
	        });
	      };
	      this.toDataURL(config);
	    },
	    /**
	         * get visible intersection shape. This is the preferred
	         *  method for determining if a point intersects a shape or not
	         * @method
	         * @memberof Konva.Stage.prototype
	         * @param {Object} pos
	         * @param {Number} pos.x
	         * @param {Number} pos.y
	         * @param {String} [selector]
	         * @returns {Konva.Node}
	         * @example
	         * var shape = stage.getIntersection({x: 50, y: 50});
	         * // or if you interested in shape parent:
	         * var group = stage.getIntersection({x: 50, y: 50}, 'Group');
	         */
	    getIntersection: function(pos, selector) {
	      var layers = this.getChildren(),
	        len = layers.length,
	        end = len - 1,
	        n,
	        shape;
	
	      for (n = end; n >= 0; n--) {
	        shape = layers[n].getIntersection(pos, selector);
	        if (shape) {
	          return shape;
	        }
	      }
	
	      return null;
	    },
	    _resizeDOM: function() {
	      if (this.content) {
	        var width = this.getWidth(),
	          height = this.getHeight(),
	          layers = this.getChildren(),
	          len = layers.length,
	          n,
	          layer;
	
	        // set content dimensions
	        this.content.style.width = width + PX;
	        this.content.style.height = height + PX;
	
	        this.bufferCanvas.setSize(width, height);
	        this.bufferHitCanvas.setSize(width, height);
	
	        // set layer dimensions
	        for (n = 0; n < len; n++) {
	          layer = layers[n];
	          layer.setSize(width, height);
	          layer.draw();
	        }
	      }
	    },
	    /**
	         * add layer or layers to stage
	         * @method
	         * @memberof Konva.Stage.prototype
	         * @param {...Konva.Layer} layer
	         * @example
	         * stage.add(layer1, layer2, layer3);
	         */
	    add: function(layer) {
	      if (arguments.length > 1) {
	        for (var i = 0; i < arguments.length; i++) {
	          this.add(arguments[i]);
	        }
	        return this;
	      }
	      Konva.Container.prototype.add.call(this, layer);
	      layer._setCanvasSize(this.width(), this.height());
	
	      // draw layer and append canvas to container
	      layer.draw();
	
	      if (Konva.isBrowser) {
	        this.content.appendChild(layer.canvas._canvas);
	      }
	
	      // chainable
	      return this;
	    },
	    getParent: function() {
	      return null;
	    },
	    getLayer: function() {
	      return null;
	    },
	    /**
	         * returns a {@link Konva.Collection} of layers
	         * @method
	         * @memberof Konva.Stage.prototype
	         */
	    getLayers: function() {
	      return this.getChildren();
	    },
	    _bindContentEvents: function() {
	      if (!Konva.isBrowser) {
	        return;
	      }
	      for (var n = 0; n < eventsLength; n++) {
	        addEvent(this, EVENTS[n]);
	      }
	    },
	    _mouseover: function(evt) {
	      if (!Konva.UA.mobile) {
	        this._setPointerPosition(evt);
	        this._fire(CONTENT_MOUSEOVER, { evt: evt });
	      }
	    },
	    _mouseout: function(evt) {
	      if (!Konva.UA.mobile) {
	        this._setPointerPosition(evt);
	        var targetShape = this.targetShape;
	
	        if (targetShape && !Konva.isDragging()) {
	          targetShape._fireAndBubble(MOUSEOUT, { evt: evt });
	          targetShape._fireAndBubble(MOUSELEAVE, { evt: evt });
	          this.targetShape = null;
	        }
	        this.pointerPos = undefined;
	
	        this._fire(CONTENT_MOUSEOUT, { evt: evt });
	      }
	    },
	    _mousemove: function(evt) {
	      // workaround for mobile IE to force touch event when unhandled pointer event elevates into a mouse event
	      if (Konva.UA.ieMobile) {
	        return this._touchmove(evt);
	      }
	      // workaround fake mousemove event in chrome browser https://code.google.com/p/chromium/issues/detail?id=161464
	      if (
	        (typeof evt.movementX !== 'undefined' ||
	          typeof evt.movementY !== 'undefined') &&
	        evt.movementY === 0 &&
	        evt.movementX === 0
	      ) {
	        return null;
	      }
	      if (Konva.UA.mobile) {
	        return null;
	      }
	      this._setPointerPosition(evt);
	      var shape;
	
	      if (!Konva.isDragging()) {
	        shape = this.getIntersection(this.getPointerPosition());
	        if (shape && shape.isListening()) {
	          if (
	            !Konva.isDragging() &&
	            (!this.targetShape || this.targetShape._id !== shape._id)
	          ) {
	            if (this.targetShape) {
	              this.targetShape._fireAndBubble(MOUSEOUT, { evt: evt }, shape);
	              this.targetShape._fireAndBubble(MOUSELEAVE, { evt: evt }, shape);
	            }
	            shape._fireAndBubble(MOUSEOVER, { evt: evt }, this.targetShape);
	            shape._fireAndBubble(MOUSEENTER, { evt: evt }, this.targetShape);
	            this.targetShape = shape;
	          } else {
	            shape._fireAndBubble(MOUSEMOVE, { evt: evt });
	          }
	        } else {
	          /*
	                 * if no shape was detected, clear target shape and try
	                 * to run mouseout from previous target shape
	                 */
	          if (this.targetShape && !Konva.isDragging()) {
	            this.targetShape._fireAndBubble(MOUSEOUT, { evt: evt });
	            this.targetShape._fireAndBubble(MOUSELEAVE, { evt: evt });
	            this.targetShape = null;
	          }
	        }
	
	        // content event
	        this._fire(CONTENT_MOUSEMOVE, { evt: evt });
	      }
	
	      // always call preventDefault for desktop events because some browsers
	      // try to drag and drop the canvas element
	      if (evt.preventDefault) {
	        evt.preventDefault();
	      }
	    },
	    _mousedown: function(evt) {
	      // workaround for mobile IE to force touch event when unhandled pointer event elevates into a mouse event
	      if (Konva.UA.ieMobile) {
	        return this._touchstart(evt);
	      }
	      if (!Konva.UA.mobile) {
	        this._setPointerPosition(evt);
	        var shape = this.getIntersection(this.getPointerPosition());
	
	        Konva.listenClickTap = true;
	
	        if (shape && shape.isListening()) {
	          this.clickStartShape = shape;
	          shape._fireAndBubble(MOUSEDOWN, { evt: evt });
	        }
	
	        // content event
	        this._fire(CONTENT_MOUSEDOWN, { evt: evt });
	      }
	
	      // always call preventDefault for desktop events because some browsers
	      // try to drag and drop the canvas element
	      if (evt.preventDefault) {
	        evt.preventDefault();
	      }
	    },
	    _mouseup: function(evt) {
	      // workaround for mobile IE to force touch event when unhandled pointer event elevates into a mouse event
	      if (Konva.UA.ieMobile) {
	        return this._touchend(evt);
	      }
	      if (!Konva.UA.mobile) {
	        this._setPointerPosition(evt);
	        var shape = this.getIntersection(this.getPointerPosition()),
	          clickStartShape = this.clickStartShape,
	          clickEndShape = this.clickEndShape,
	          fireDblClick = false,
	          dd = Konva.DD;
	
	        if (Konva.inDblClickWindow) {
	          fireDblClick = true;
	          Konva.inDblClickWindow = false;
	        } else if (!dd || !dd.justDragged) {
	          // don't set inDblClickWindow after dragging
	          Konva.inDblClickWindow = true;
	        } else if (dd) {
	          dd.justDragged = false;
	        }
	
	        setTimeout(function() {
	          Konva.inDblClickWindow = false;
	        }, Konva.dblClickWindow);
	
	        if (shape && shape.isListening()) {
	          this.clickEndShape = shape;
	          shape._fireAndBubble(MOUSEUP, { evt: evt });
	
	          // detect if click or double click occurred
	          if (
	            Konva.listenClickTap &&
	            clickStartShape &&
	            clickStartShape._id === shape._id
	          ) {
	            shape._fireAndBubble(CLICK, { evt: evt });
	
	            if (
	              fireDblClick &&
	              clickEndShape &&
	              clickEndShape._id === shape._id
	            ) {
	              shape._fireAndBubble(DBL_CLICK, { evt: evt });
	            }
	          }
	        }
	        // content events
	        this._fire(CONTENT_MOUSEUP, { evt: evt });
	        if (Konva.listenClickTap) {
	          this._fire(CONTENT_CLICK, { evt: evt });
	          if (fireDblClick) {
	            this._fire(CONTENT_DBL_CLICK, { evt: evt });
	          }
	        }
	
	        Konva.listenClickTap = false;
	      }
	
	      // always call preventDefault for desktop events because some browsers
	      // try to drag and drop the canvas element
	      if (evt.preventDefault) {
	        evt.preventDefault();
	      }
	    },
	    _contextmenu: function(evt) {
	      this._fire(CONTENT_CONTEXTMENU, { evt: evt });
	    },
	    _touchstart: function(evt) {
	      this._setPointerPosition(evt);
	      var shape = this.getIntersection(this.getPointerPosition());
	
	      Konva.listenClickTap = true;
	
	      if (shape && shape.isListening()) {
	        this.tapStartShape = shape;
	        shape._fireAndBubble(TOUCHSTART, { evt: evt });
	
	        // only call preventDefault if the shape is listening for events
	        if (
	          shape.isListening() &&
	          shape.preventDefault() &&
	          evt.preventDefault
	        ) {
	          evt.preventDefault();
	        }
	      }
	      // content event
	      this._fire(CONTENT_TOUCHSTART, { evt: evt });
	    },
	    _touchend: function(evt) {
	      this._setPointerPosition(evt);
	      var shape = this.getIntersection(this.getPointerPosition()),
	        fireDblClick = false;
	
	      if (Konva.inDblClickWindow) {
	        fireDblClick = true;
	        Konva.inDblClickWindow = false;
	      } else {
	        Konva.inDblClickWindow = true;
	      }
	
	      setTimeout(function() {
	        Konva.inDblClickWindow = false;
	      }, Konva.dblClickWindow);
	
	      if (shape && shape.isListening()) {
	        shape._fireAndBubble(TOUCHEND, { evt: evt });
	
	        // detect if tap or double tap occurred
	        if (
	          Konva.listenClickTap &&
	          this.tapStartShape &&
	          shape._id === this.tapStartShape._id
	        ) {
	          shape._fireAndBubble(TAP, { evt: evt });
	
	          if (fireDblClick) {
	            shape._fireAndBubble(DBL_TAP, { evt: evt });
	          }
	        }
	        // only call preventDefault if the shape is listening for events
	        if (
	          shape.isListening() &&
	          shape.preventDefault() &&
	          evt.preventDefault
	        ) {
	          evt.preventDefault();
	        }
	      }
	      // content events
	      this._fire(CONTENT_TOUCHEND, { evt: evt });
	      if (Konva.listenClickTap) {
	        this._fire(CONTENT_TAP, { evt: evt });
	        if (fireDblClick) {
	          this._fire(CONTENT_DBL_TAP, { evt: evt });
	        }
	      }
	
	      Konva.listenClickTap = false;
	    },
	    _touchmove: function(evt) {
	      this._setPointerPosition(evt);
	      var dd = Konva.DD,
	        shape;
	      if (!Konva.isDragging()) {
	        shape = this.getIntersection(this.getPointerPosition());
	        if (shape && shape.isListening()) {
	          shape._fireAndBubble(TOUCHMOVE, { evt: evt });
	          // only call preventDefault if the shape is listening for events
	          if (
	            shape.isListening() &&
	            shape.preventDefault() &&
	            evt.preventDefault
	          ) {
	            evt.preventDefault();
	          }
	        }
	        this._fire(CONTENT_TOUCHMOVE, { evt: evt });
	      }
	      if (dd) {
	        if (Konva.isDragging() && Konva.DD.node.preventDefault()) {
	          evt.preventDefault();
	        }
	      }
	    },
	    _wheel: function(evt) {
	      this._setPointerPosition(evt);
	      var shape = this.getIntersection(this.getPointerPosition());
	
	      if (shape && shape.isListening()) {
	        shape._fireAndBubble(WHEEL, { evt: evt });
	      }
	      this._fire(CONTENT_WHEEL, { evt: evt });
	    },
	    _setPointerPosition: function(evt) {
	      var contentPosition = this._getContentPosition(),
	        x = null,
	        y = null;
	      evt = evt ? evt : window.event;
	
	      // touch events
	      if (evt.touches !== undefined) {
	        // currently, only handle one finger
	        if (evt.touches.length > 0) {
	          var touch = evt.touches[0];
	          // get the information for finger #1
	          x = touch.clientX - contentPosition.left;
	          y = touch.clientY - contentPosition.top;
	        }
	      } else {
	        // mouse events
	        x = evt.clientX - contentPosition.left;
	        y = evt.clientY - contentPosition.top;
	      }
	      if (x !== null && y !== null) {
	        this.pointerPos = {
	          x: x,
	          y: y
	        };
	      }
	    },
	    _getContentPosition: function() {
	      var rect = this.content.getBoundingClientRect
	        ? this.content.getBoundingClientRect()
	        : { top: 0, left: 0 };
	      return {
	        top: rect.top,
	        left: rect.left
	      };
	    },
	    _buildDOM: function() {
	      // the buffer canvas pixel ratio must be 1 because it is used as an
	      // intermediate canvas before copying the result onto a scene canvas.
	      // not setting it to 1 will result in an over compensation
	      this.bufferCanvas = new Konva.SceneCanvas();
	      this.bufferHitCanvas = new Konva.HitCanvas({ pixelRatio: 1 });
	
	      if (!Konva.isBrowser) {
	        return;
	      }
	      var container = this.getContainer();
	      if (!container) {
	        throw 'Stage has no container. A container is required.';
	      }
	      // clear content inside container
	      container.innerHTML = EMPTY_STRING;
	
	      // content
	      this.content = Konva.document.createElement(DIV);
	      this.content.style.position = RELATIVE;
	      this.content.className = KONVA_CONTENT;
	      this.content.setAttribute('role', 'presentation');
	
	      container.appendChild(this.content);
	
	      this._resizeDOM();
	    },
	    _onContent: function(typesStr, handler) {
	      var types = typesStr.split(SPACE),
	        len = types.length,
	        n,
	        baseEvent;
	
	      for (n = 0; n < len; n++) {
	        baseEvent = types[n];
	        this.content.addEventListener(baseEvent, handler, false);
	      }
	    },
	    // currently cache function is now working for stage, because stage has no its own canvas element
	    // TODO: may be it is better to cache all children layers?
	    cache: function() {
	      Konva.Util.warn(
	        'Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.'
	      );
	    },
	    clearCache: function() {}
	  });
	  Konva.Util.extend(Konva.Stage, Konva.Container);
	
	  // add getters and setters
	  Konva.Factory.addGetter(Konva.Stage, 'container');
	  Konva.Factory.addOverloadedGetterSetter(Konva.Stage, 'container');
	
	  /**
	     * get container DOM element
	     * @name container
	     * @method
	     * @memberof Konva.Stage.prototype
	     * @returns {DomElement} container
	     * @example
	     * // get container
	     * var container = stage.container();
	     * // set container
	     * var container = document.createElement('div');
	     * body.appendChild(container);
	     * stage.container(container);
	     */
	})();


/***/ }),
/* 344 */
/***/ (function(module, exports) {

	(function(Konva) {
	  'use strict';
	  /**
	     * BaseLayer constructor.
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Container
	     * @param {Object} config
	     * @param {Boolean} [config.clearBeforeDraw] set this property to false if you don't want
	     * to clear the canvas before each layer draw.  The default value is true.
	     * @@nodeParams
	     * @@containerParams
	     */
	  Konva.BaseLayer = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Util.addMethods(Konva.BaseLayer, {
	    ___init: function(config) {
	      this.nodeType = 'Layer';
	      Konva.Container.call(this, config);
	    },
	    createPNGStream: function() {
	      return this.canvas._canvas.createPNGStream();
	    },
	    /**
	     * get layer canvas
	     * @method
	     * @memberof Konva.BaseLayer.prototype
	     */
	    getCanvas: function() {
	      return this.canvas;
	    },
	    /**
	     * get layer hit canvas
	     * @method
	     * @memberof Konva.BaseLayer.prototype
	     */
	    getHitCanvas: function() {
	      return this.hitCanvas;
	    },
	    /**
	     * get layer canvas context
	     * @method
	     * @memberof Konva.BaseLayer.prototype
	     */
	    getContext: function() {
	      return this.getCanvas().getContext();
	    },
	    /**
	     * clear scene and hit canvas contexts tied to the layer
	     * @method
	     * @memberof Konva.BaseLayer.prototype
	     * @param {Object} [bounds]
	     * @param {Number} [bounds.x]
	     * @param {Number} [bounds.y]
	     * @param {Number} [bounds.width]
	     * @param {Number} [bounds.height]
	     * @example
	     * layer.clear();
	     * layer.clear({
	     *   x : 0,
	     *   y : 0,
	     *   width : 100,
	     *   height : 100
	     * });
	     */
	    clear: function(bounds) {
	      this.getContext().clear(bounds);
	      return this;
	    },
	    clearHitCache: function() {
	      this._hitImageData = undefined;
	    },
	    // extend Node.prototype.setZIndex
	    setZIndex: function(index) {
	      Konva.Node.prototype.setZIndex.call(this, index);
	      var stage = this.getStage();
	      if (stage) {
	        stage.content.removeChild(this.getCanvas()._canvas);
	
	        if (index < stage.getChildren().length - 1) {
	          stage.content.insertBefore(
	            this.getCanvas()._canvas,
	            stage.getChildren()[index + 1].getCanvas()._canvas
	          );
	        } else {
	          stage.content.appendChild(this.getCanvas()._canvas);
	        }
	      }
	      return this;
	    },
	    // extend Node.prototype.moveToTop
	    moveToTop: function() {
	      Konva.Node.prototype.moveToTop.call(this);
	      var stage = this.getStage();
	      if (stage) {
	        stage.content.removeChild(this.getCanvas()._canvas);
	        stage.content.appendChild(this.getCanvas()._canvas);
	      }
	      return this;
	    },
	    // extend Node.prototype.moveUp
	    moveUp: function() {
	      var moved = Konva.Node.prototype.moveUp.call(this);
	      if (!moved) {
	        return this;
	      }
	      var stage = this.getStage();
	      if (!stage) {
	        return this;
	      }
	      stage.content.removeChild(this.getCanvas()._canvas);
	
	      if (this.index < stage.getChildren().length - 1) {
	        stage.content.insertBefore(
	          this.getCanvas()._canvas,
	          stage.getChildren()[this.index + 1].getCanvas()._canvas
	        );
	      } else {
	        stage.content.appendChild(this.getCanvas()._canvas);
	      }
	      return this;
	    },
	    // extend Node.prototype.moveDown
	    moveDown: function() {
	      if (Konva.Node.prototype.moveDown.call(this)) {
	        var stage = this.getStage();
	        if (stage) {
	          var children = stage.getChildren();
	          stage.content.removeChild(this.getCanvas()._canvas);
	          stage.content.insertBefore(
	            this.getCanvas()._canvas,
	            children[this.index + 1].getCanvas()._canvas
	          );
	        }
	      }
	      return this;
	    },
	    // extend Node.prototype.moveToBottom
	    moveToBottom: function() {
	      if (Konva.Node.prototype.moveToBottom.call(this)) {
	        var stage = this.getStage();
	        if (stage) {
	          var children = stage.getChildren();
	          stage.content.removeChild(this.getCanvas()._canvas);
	          stage.content.insertBefore(
	            this.getCanvas()._canvas,
	            children[1].getCanvas()._canvas
	          );
	        }
	      }
	      return this;
	    },
	    getLayer: function() {
	      return this;
	    },
	    remove: function() {
	      var _canvas = this.getCanvas()._canvas;
	
	      Konva.Node.prototype.remove.call(this);
	
	      if (_canvas && _canvas.parentNode && Konva.Util._isInDocument(_canvas)) {
	        _canvas.parentNode.removeChild(_canvas);
	      }
	      return this;
	    },
	    getStage: function() {
	      return this.parent;
	    },
	    setSize: function(width, height) {
	      this.canvas.setSize(width, height);
	      return this;
	    },
	    /**
	     * get/set width of layer.getter return width of stage. setter doing nothing.
	     * if you want change width use `stage.width(value);`
	     * @name width
	     * @method
	     * @memberof Konva.BaseLayer.prototype
	     * @returns {Number}
	     * @example
	     * var width = layer.width();
	     */
	    getWidth: function() {
	      if (this.parent) {
	        return this.parent.getWidth();
	      }
	    },
	    setWidth: function() {
	      Konva.Util.warn(
	        'Can not change width of layer. Use "stage.width(value)" function instead.'
	      );
	    },
	    /**
	     * get/set height of layer.getter return height of stage. setter doing nothing.
	     * if you want change height use `stage.height(value);`
	     * @name height
	     * @method
	     * @memberof Konva.BaseLayer.prototype
	     * @returns {Number}
	     * @example
	     * var height = layer.height();
	     */
	    getHeight: function() {
	      if (this.parent) {
	        return this.parent.getHeight();
	      }
	    },
	    setHeight: function() {
	      Konva.Util.warn(
	        'Can not change height of layer. Use "stage.height(value)" function instead.'
	      );
	    },
	    // the apply transform method is handled by the Layer and FastLayer class
	    // because it is up to the layer to decide if an absolute or relative transform
	    // should be used
	    _applyTransform: function(shape, context, top) {
	      var m = shape.getAbsoluteTransform(top).getMatrix();
	      context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	    }
	  });
	  Konva.Util.extend(Konva.BaseLayer, Konva.Container);
	
	  // add getters and setters
	  Konva.Factory.addGetterSetter(Konva.BaseLayer, 'clearBeforeDraw', true);
	  /**
	   * get/set clearBeforeDraw flag which determines if the layer is cleared or not
	   *  before drawing
	   * @name clearBeforeDraw
	   * @method
	   * @memberof Konva.BaseLayer.prototype
	   * @param {Boolean} clearBeforeDraw
	   * @returns {Boolean}
	   * @example
	   * // get clearBeforeDraw flag
	   * var clearBeforeDraw = layer.clearBeforeDraw();
	   *
	   * // disable clear before draw
	   * layer.clearBeforeDraw(false);
	   *
	   * // enable clear before draw
	   * layer.clearBeforeDraw(true);
	   */
	
	  Konva.Collection.mapMethods(Konva.BaseLayer);
	})(Konva);


/***/ }),
/* 345 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';
	  // constants
	  var HASH = '#',
	    BEFORE_DRAW = 'beforeDraw',
	    DRAW = 'draw',
	    /*
	         * 2 - 3 - 4
	         * |       |
	         * 1 - 0   5
	         *         |
	         * 8 - 7 - 6
	         */
	    INTERSECTION_OFFSETS = [
	      { x: 0, y: 0 }, // 0
	      { x: -1, y: 0 }, // 1
	      { x: -1, y: -1 }, // 2
	      { x: 0, y: -1 }, // 3
	      { x: 1, y: -1 }, // 4
	      { x: 1, y: 0 }, // 5
	      { x: 1, y: 1 }, // 6
	      { x: 0, y: 1 }, // 7
	      { x: -1, y: 1 } // 8
	    ],
	    INTERSECTION_OFFSETS_LEN = INTERSECTION_OFFSETS.length;
	
	  /**
	     * Layer constructor.  Layers are tied to their own canvas element and are used
	     * to contain groups or shapes.
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.BaseLayer
	     * @param {Object} config
	     * @param {Boolean} [config.clearBeforeDraw] set this property to false if you don't want
	     * to clear the canvas before each layer draw.  The default value is true.
	     * @@nodeParams
	     * @@containerParams
	     * @example
	     * var layer = new Konva.Layer();
	     */
	  Konva.Layer = function(config) {
	    this.____init(config);
	  };
	
	  Konva.Util.addMethods(Konva.Layer, {
	    ____init: function(config) {
	      this.nodeType = 'Layer';
	      this.canvas = new Konva.SceneCanvas();
	      this.hitCanvas = new Konva.HitCanvas({
	        pixelRatio: 1
	      });
	      // call super constructor
	      Konva.BaseLayer.call(this, config);
	    },
	    _setCanvasSize: function(width, height) {
	      this.canvas.setSize(width, height);
	      this.hitCanvas.setSize(width, height);
	    },
	    _validateAdd: function(child) {
	      var type = child.getType();
	      if (type !== 'Group' && type !== 'Shape') {
	        Konva.Util.throw('You may only add groups and shapes to a layer.');
	      }
	    },
	    /**
	         * get visible intersection shape. This is the preferred
	         * method for determining if a point intersects a shape or not
	         * also you may pass optional selector parametr to return ancestor of intersected shape
	         * @method
	         * @memberof Konva.Layer.prototype
	         * @param {Object} pos
	         * @param {Number} pos.x
	         * @param {Number} pos.y
	         * @param {String} [selector]
	         * @returns {Konva.Node}
	         * @example
	         * var shape = layer.getIntersection({x: 50, y: 50});
	         * // or if you interested in shape parent:
	         * var group = layer.getIntersection({x: 50, y: 50}, 'Group');
	         */
	    getIntersection: function(pos, selector) {
	      var obj, i, intersectionOffset, shape;
	
	      if (!this.hitGraphEnabled() || !this.isVisible()) {
	        return null;
	      }
	      // in some cases antialiased area may be bigger than 1px
	      // it is possible if we will cache node, then scale it a lot
	      // TODO: check { 0; 0 } point before loop, and remove it from INTERSECTION_OFFSETS.
	      var spiralSearchDistance = 1;
	      var continueSearch = false;
	      while (true) {
	        for (i = 0; i < INTERSECTION_OFFSETS_LEN; i++) {
	          intersectionOffset = INTERSECTION_OFFSETS[i];
	          obj = this._getIntersection({
	            x: pos.x + intersectionOffset.x * spiralSearchDistance,
	            y: pos.y + intersectionOffset.y * spiralSearchDistance
	          });
	          shape = obj.shape;
	          if (shape && selector) {
	            return shape.findAncestor(selector, true);
	          } else if (shape) {
	            return shape;
	          }
	          // we should continue search if we found antialiased pixel
	          // that means our node somewhere very close
	          continueSearch = !!obj.antialiased;
	          // stop search if found empty pixel
	          if (!obj.antialiased) {
	            break;
	          }
	        }
	        // if no shape, and no antialiased pixel, we should end searching
	        if (continueSearch) {
	          spiralSearchDistance += 1;
	        } else {
	          return null;
	        }
	      }
	    },
	    _getImageData: function(x, y) {
	      var width = this.hitCanvas.width || 1,
	        height = this.hitCanvas.height || 1,
	        index = Math.round(y) * width + Math.round(x);
	
	      if (!this._hitImageData) {
	        this._hitImageData = this.hitCanvas.context.getImageData(
	          0,
	          0,
	          width,
	          height
	        );
	      }
	
	      return [
	        this._hitImageData.data[4 * index + 0], // Red
	        this._hitImageData.data[4 * index + 1], // Green
	        this._hitImageData.data[4 * index + 2], // Blue
	        this._hitImageData.data[4 * index + 3] // Alpha
	      ];
	    },
	    _getIntersection: function(pos) {
	      var ratio = this.hitCanvas.pixelRatio;
	      var p = this.hitCanvas.context.getImageData(
	        Math.round(pos.x * ratio),
	        Math.round(pos.y * ratio),
	        1,
	        1
	      ).data,
	        p3 = p[3],
	        colorKey,
	        shape;
	      // fully opaque pixel
	      if (p3 === 255) {
	        colorKey = Konva.Util._rgbToHex(p[0], p[1], p[2]);
	        shape = Konva.shapes[HASH + colorKey];
	        if (shape) {
	          return {
	            shape: shape
	          };
	        }
	        return {
	          antialiased: true
	        };
	      } else if (p3 > 0) {
	        // antialiased pixel
	        return {
	          antialiased: true
	        };
	      }
	      // empty pixel
	      return {};
	    },
	    drawScene: function(can, top) {
	      var layer = this.getLayer(), canvas = can || (layer && layer.getCanvas());
	
	      this._fire(BEFORE_DRAW, {
	        node: this
	      });
	
	      if (this.getClearBeforeDraw()) {
	        canvas.getContext().clear();
	      }
	
	      Konva.Container.prototype.drawScene.call(this, canvas, top);
	
	      this._fire(DRAW, {
	        node: this
	      });
	
	      return this;
	    },
	    drawHit: function(can, top) {
	      var layer = this.getLayer(), canvas = can || (layer && layer.hitCanvas);
	
	      if (layer && layer.getClearBeforeDraw()) {
	        layer.getHitCanvas().getContext().clear();
	      }
	
	      Konva.Container.prototype.drawHit.call(this, canvas, top);
	      this.imageData = null; // Clear imageData cache
	      return this;
	    },
	    clear: function(bounds) {
	      Konva.BaseLayer.prototype.clear.call(this, bounds);
	      this.getHitCanvas().getContext().clear(bounds);
	      this.imageData = null; // Clear getImageData cache
	      return this;
	    },
	    // extend Node.prototype.setVisible
	    setVisible: function(visible) {
	      Konva.Node.prototype.setVisible.call(this, visible);
	      if (visible) {
	        this.getCanvas()._canvas.style.display = 'block';
	        this.hitCanvas._canvas.style.display = 'block';
	      } else {
	        this.getCanvas()._canvas.style.display = 'none';
	        this.hitCanvas._canvas.style.display = 'none';
	      }
	      return this;
	    },
	    /**
	         * enable hit graph
	         * @name enableHitGraph
	         * @method
	         * @memberof Konva.Layer.prototype
	         * @returns {Layer}
	         */
	    enableHitGraph: function() {
	      this.setHitGraphEnabled(true);
	      return this;
	    },
	    /**
	         * disable hit graph
	         * @name disableHitGraph
	         * @method
	         * @memberof Konva.Layer.prototype
	         * @returns {Layer}
	         */
	    disableHitGraph: function() {
	      this.setHitGraphEnabled(false);
	      return this;
	    },
	    setSize: function(width, height) {
	      Konva.BaseLayer.prototype.setSize.call(this, width, height);
	      this.hitCanvas.setSize(width, height);
	      return this;
	    }
	  });
	  Konva.Util.extend(Konva.Layer, Konva.BaseLayer);
	
	  Konva.Factory.addGetterSetter(Konva.Layer, 'hitGraphEnabled', true);
	  /**
	     * get/set hitGraphEnabled flag.  Disabling the hit graph will greatly increase
	     *  draw performance because the hit graph will not be redrawn each time the layer is
	     *  drawn.  This, however, also disables mouse/touch event detection
	     * @name hitGraphEnabled
	     * @method
	     * @memberof Konva.Layer.prototype
	     * @param {Boolean} enabled
	     * @returns {Boolean}
	     * @example
	     * // get hitGraphEnabled flag
	     * var hitGraphEnabled = layer.hitGraphEnabled();
	     *
	     * // disable hit graph
	     * layer.hitGraphEnabled(false);
	     *
	     * // enable hit graph
	     * layer.hitGraphEnabled(true);
	     */
	  Konva.Collection.mapMethods(Konva.Layer);
	})();


/***/ }),
/* 346 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';
	  /**
	     * FastLayer constructor. Layers are tied to their own canvas element and are used
	     * to contain shapes only.  If you don't need node nesting, mouse and touch interactions,
	     * or event pub/sub, you should use FastLayer instead of Layer to create your layers.
	     * It renders about 2x faster than normal layers.
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.BaseLayer
	     * @param {Object} config
	     * @param {Boolean} [config.clearBeforeDraw] set this property to false if you don't want
	     * to clear the canvas before each layer draw.  The default value is true.
	     * @param {Boolean} [config.visible]
	     * @param {String} [config.id] unique id
	     * @param {String} [config.name] non-unique name
	     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
	     * @@containerParams
	     * @example
	     * var layer = new Konva.FastLayer();
	     */
	  Konva.FastLayer = function(config) {
	    this.____init(config);
	  };
	
	  Konva.Util.addMethods(Konva.FastLayer, {
	    ____init: function(config) {
	      this.nodeType = 'Layer';
	      this.canvas = new Konva.SceneCanvas();
	      // call super constructor
	      Konva.BaseLayer.call(this, config);
	    },
	    _validateAdd: function(child) {
	      var type = child.getType();
	      if (type !== 'Shape') {
	        Konva.Util.throw('You may only add shapes to a fast layer.');
	      }
	    },
	    _setCanvasSize: function(width, height) {
	      this.canvas.setSize(width, height);
	    },
	    hitGraphEnabled: function() {
	      return false;
	    },
	    getIntersection: function() {
	      return null;
	    },
	    drawScene: function(can) {
	      var layer = this.getLayer(), canvas = can || (layer && layer.getCanvas());
	
	      if (this.getClearBeforeDraw()) {
	        canvas.getContext().clear();
	      }
	
	      Konva.Container.prototype.drawScene.call(this, canvas);
	
	      return this;
	    },
	    draw: function() {
	      this.drawScene();
	      return this;
	    },
	    // extend Node.prototype.setVisible
	    setVisible: function(visible) {
	      Konva.Node.prototype.setVisible.call(this, visible);
	      if (visible) {
	        this.getCanvas()._canvas.style.display = 'block';
	      } else {
	        this.getCanvas()._canvas.style.display = 'none';
	      }
	      return this;
	    }
	  });
	  Konva.Util.extend(Konva.FastLayer, Konva.BaseLayer);
	
	  Konva.Collection.mapMethods(Konva.FastLayer);
	})();


/***/ }),
/* 347 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';
	  /**
	     * Group constructor.  Groups are used to contain shapes or other groups.
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Container
	     * @param {Object} config
	     * @@nodeParams
	     * @@containerParams
	     * @example
	     * var group = new Konva.Group();
	     */
	  Konva.Group = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Util.addMethods(Konva.Group, {
	    ___init: function(config) {
	      this.nodeType = 'Group';
	      // call super constructor
	      Konva.Container.call(this, config);
	    },
	    _validateAdd: function(child) {
	      var type = child.getType();
	      if (type !== 'Group' && type !== 'Shape') {
	        Konva.Util.throw('You may only add groups and shapes to groups.');
	      }
	    }
	  });
	  Konva.Util.extend(Konva.Group, Konva.Container);
	
	  Konva.Collection.mapMethods(Konva.Group);
	})();


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Core = __webpack_require__(334);
	
	var _Core2 = _interopRequireDefault(_Core);
	
	__webpack_require__(349);
	
	__webpack_require__(350);
	
	__webpack_require__(351);
	
	var _customLodash = __webpack_require__(352);
	
	var _customLodash2 = _interopRequireDefault(_customLodash);
	
	var _helper = __webpack_require__(517);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _eventEmitter = __webpack_require__(520);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _design = __webpack_require__(521);
	
	var _design2 = _interopRequireDefault(_design);
	
	var _hermiteResize = __webpack_require__(528);
	
	var _hermiteResize2 = _interopRequireDefault(_hermiteResize);
	
	__webpack_require__(529);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PlacingLayer = function () {
	    function PlacingLayer(viewpointSize, stageSize, colour) {
	        var _this = this;
	
	        var editable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	        _classCallCheck(this, PlacingLayer);
	
	        this.events = new _eventEmitter2.default();
	        this.designs = [];
	        this.colour = colour;
	        this.padding = 50;
	        this.viewpointSize = viewpointSize;
	        this.stageSize = stageSize;
	        this.editable = editable;
	        this.konvaLayer = new _Core2.default.Layer({
	            listening: editable,
	            hitGraphEnabled: editable
	        });
	        this.background = new _Core2.default.Rect(stageSize);
	        this.placingArea = _helper2.default.getConstrainedSize(viewpointSize, {
	            width: stageSize.width - this.padding * 2,
	            height: stageSize.height - this.padding * 2
	        });
	        this.placingArea.x = stageSize.width / 2 - this.placingArea.width / 2;
	        this.placingArea.y = stageSize.height / 2 - this.placingArea.height / 2;
	        this.productImage = new _Core2.default.Image();
	        this.konvaLayer.add(this.background);
	        this.konvaLayer.add(this.productImage);
	
	        if (this.editable) {
	            this.konvaLayer.on('mousedown', function (evt) {
	                return _this.onMouseDown(evt);
	            });
	        }
	    }
	
	    PlacingLayer.prototype.setBackground = function setBackground(backgroundImageObj) {
	        var imgSize = _helper2.default.getConstrainedSize(backgroundImageObj, this.placingArea);
	        var placingAreaCenter = {
	            x: this.placingArea.x + this.placingArea.width / 2,
	            y: this.placingArea.y + this.placingArea.height / 2
	        };
	        this.productImage.setWidth(imgSize.width);
	        this.productImage.setHeight(imgSize.height);
	        this.productImage.setX(placingAreaCenter.x - imgSize.width / 2);
	        this.productImage.setY(placingAreaCenter.y - imgSize.height / 2);
	        this.productImage.image(backgroundImageObj);
	        this.productImage.setZIndex(1);
	        if (this.colour) {
	            this.productImage.cache();
	            this.productImage.filters([_Core2.default.Filters.RGBA]);
	            this.productImage.alpha(0.5);
	            this.productImage.red(parseInt(this.colour.substring(0, 2), 16));
	            this.productImage.green(parseInt(this.colour.substring(2, 4), 16));
	            this.productImage.blue(parseInt(this.colour.substring(4, 6), 16));
	        }
	        this.draw();
	    };
	
	    PlacingLayer.prototype.addComponent = function addComponent(component) {
	        this.konvaLayer.add(component.konvaObject);
	        this.draw();
	    };
	
	    PlacingLayer.prototype.getDesigns = function getDesigns() {
	        var _this2 = this;
	
	        return this.designs.map(function (d) {
	            var data = {
	                id: d.data.id || 0,
	                imageUrl: d.data.image,
	                instruction: d.getInstruction(),
	                reference: d.getReference(),
	                data: d.data,
	                resizable: d.resizable,
	                setResizable: function setResizable(resizable) {
	                    d.resizable = !!resizable;
	                }
	            };
	            var transformation = _this2.getDesignPrintTransform(d);
	            return _extends(data, transformation);
	        });
	    };
	
	    PlacingLayer.prototype.getDesignPrintTransform = function getDesignPrintTransform(design) {
	        var designPos = this.layerToPrintPos(design.getDesignLayerPos());
	        var designSize = design.getDesignSize();
	        var designRot = design.getDesignRotation();
	
	        return {
	            x: designPos.x,
	            y: designPos.y,
	            width: designSize.width,
	            height: designSize.height,
	            rotation: designRot,
	            zindex: design.getZIndex() - 1
	        };
	    };
	
	    PlacingLayer.prototype.addDesign = function addDesign(design) {
	        var _this3 = this;
	
	        this.designs.push(design);
	        this.addComponent(design);
	        this.resetDesignPlacement(design);
	        this.deselectDesigns(this.designs);
	        this.draw();
	
	        if (this.editable) {
	            design.events.on('delete', function (evt) {
	                return _this3.deleteDesign(design, evt);
	            });
	            design.events.on('select', function (evt) {
	                return _this3.onDesignSelect(design, evt);
	            });
	            design.events.on('rotate', function (evt) {
	                return _this3.onDesignRotate(design, evt);
	            });
	            design.events.on('resize', function (evt) {
	                return _this3.onDesignResize(design, evt);
	            });
	            design.events.on('dragend', function (evt) {
	                return _this3.onDesignDragEnd(design, evt);
	            });
	            design.events.on('instruction', function (evt) {
	                return _this3.onInstruction(design, evt);
	            });
	            design.setDraggable(true);
	        }
	    };
	
	    PlacingLayer.prototype.deleteDesign = function deleteDesign(design) {
	        _customLodash2.default.remove(this.designs, design);
	        design.destroy();
	        this.draw();
	        this.emitChange();
	    };
	
	    PlacingLayer.prototype.resetDesignPlacement = function resetDesignPlacement(design) {
	        var layerPos = {
	            x: this.konvaLayer.getWidth() / 2 - design.getDesignSize().width / 2,
	            y: this.konvaLayer.getHeight() / 2 - design.getDesignSize().height / 2
	        };
	
	        if (design.data.x && design.data.y) {
	            layerPos = this.printToLayerPos({
	                x: design.data.x,
	                y: design.data.y
	            });
	        }
	
	        if (design.data.zindex) {
	            design.setZIndex(design.data.zindex);
	        }
	
	        design.setDesignLayerPos(layerPos);
	        design.setDesignRotation(design.data.rotation || 0);
	        design.setDesignSize({
	            width: design.data.width,
	            height: design.data.height
	        });
	        this.draw();
	    };
	
	    PlacingLayer.prototype.layerToPrintPos = function layerToPrintPos(position) {
	        return {
	            x: position.x - this.placingArea.x,
	            y: position.y - this.placingArea.y
	        };
	    };
	
	    PlacingLayer.prototype.printToLayerPos = function printToLayerPos(position) {
	        return {
	            x: position.x + this.placingArea.x,
	            y: position.y + this.placingArea.y
	        };
	    };
	
	    PlacingLayer.prototype.onInstruction = function onInstruction(design) {
	        this.events.emit('instruction', design);
	    };
	
	    PlacingLayer.prototype.onMouseDown = function onMouseDown() {
	        this.deselectDesigns(this.designs);
	    };
	
	    PlacingLayer.prototype.onDesignSelect = function onDesignSelect(design) {
	        var top = this.designs.reduce(function (top, d) {
	            return d.getZIndex() > top.getZIndex() ? d : top;
	        });
	
	        // Only update if something will change.
	        if (design.getZIndex() !== top.getZIndex()) {
	            design.moveToTop();
	            this.emitChange();
	        }
	
	        var unselected = _customLodash2.default.filter(this.designs, function (p) {
	            return p !== design;
	        });
	        this.deselectDesigns(unselected);
	    };
	
	    PlacingLayer.prototype.onDesignDragEnd = function onDesignDragEnd(design) {
	        this.validatePlacement(design);
	        this.emitChange();
	    };
	
	    PlacingLayer.prototype.onDesignRotate = function onDesignRotate(design, event) {
	        var _this4 = this;
	
	        var centerPos = design.getDesignCenterLayerPos();
	        var designRot = design.getDesignRotation();
	        var startAngle = _helper2.default.getAngle(centerPos, event);
	        this.konvaLayer.on('mousemove.rotate', function (evt) {
	            var mousePos = { x: evt.evt.layerX, y: evt.evt.layerY };
	            var newAngle = _helper2.default.getAngle(centerPos, mousePos);
	            var angleDiff = newAngle - startAngle;
	            design.setDesignRotation(designRot + angleDiff);
	            _this4.draw();
	        });
	        this.konvaLayer.on('mouseup.rotate', function () {
	            _this4.validatePlacement(design);
	            _this4.emitChange();
	            _this4.konvaLayer.off('mousemove.rotate');
	            _this4.konvaLayer.off('mouseup.rotate');
	        });
	    };
	
	    PlacingLayer.prototype.onDesignResize = function onDesignResize(design, event) {
	        var _this5 = this;
	
	        var startSize = design.getDesignSize();
	        var centerPos = design.getDesignCenterLayerPos();
	        var startDistance = Math.hypot(event.x - centerPos.x, event.y - centerPos.y);
	        this.konvaLayer.on('mousemove', function (evt) {
	            var mousePos = { x: evt.evt.layerX, y: evt.evt.layerY };
	            var distance = Math.hypot(mousePos.x - centerPos.x, mousePos.y - centerPos.y);
	            var distanceDiff = distance - startDistance;
	            var newWidth = startSize.width + distanceDiff;
	            var newHeight = newWidth / startSize.width * startSize.height;
	            design.setDesignSize({ width: newWidth, height: newHeight });
	            design.setDesignLayerPos({
	                x: centerPos.x - newWidth / 2,
	                y: centerPos.y - newHeight / 2
	            });
	            _this5.draw();
	        });
	        this.konvaLayer.on('mouseup', function () {
	            _this5.validatePlacement(design);
	            _this5.emitChange();
	            _this5.konvaLayer.off('mousemove');
	            _this5.konvaLayer.off('mouseup');
	        });
	    };
	
	    PlacingLayer.prototype.validatePlacement = function validatePlacement(design) {
	        var productCorners = _helper2.default.getCorners(this.productImage);
	        var designCorners = design.getDesignCorners();
	        var isValid = _helper2.default.isIntersecting(productCorners, designCorners);
	
	        if (!isValid) {
	            this.resetDesignPlacement(design);
	        }
	    };
	
	    PlacingLayer.prototype.deselectDesigns = function deselectDesigns(designs) {
	        designs.forEach(function (d) {
	            return d.deselect();
	        });
	    };
	
	    PlacingLayer.prototype.clear = function clear() {
	        this.designs.forEach(function (d) {
	            return d.destroy();
	        });
	        this.designs = [];
	        this.konvaLayer.draw();
	    };
	
	    PlacingLayer.prototype.draw = function draw() {
	        this.konvaLayer.draw();
	    };
	
	    PlacingLayer.prototype.getImageData = function getImageData(maxSize) {
	        var _this6 = this;
	
	        // Create new canvas
	        var c = document.createElement('canvas');
	        var stage = new _Core2.default.Stage({
	            container: c,
	            width: this.placingArea.width,
	            height: this.placingArea.height,
	            listening: false
	        });
	
	        // Create new layer
	        var layer = new PlacingLayer(this.viewpointSize, this.stageSize, this.colour, false);
	        stage.add(layer.konvaLayer);
	        layer.konvaLayer.setOffset(this.placingArea);
	        layer.konvaLayer.draw();
	
	        // Add current designs
	        this.designs.forEach(function (d) {
	            var currentTransform = _this6.getDesignPrintTransform(d);
	            layer.addDesign(new _design2.default(currentTransform, d.imageObj, false));
	        });
	
	        // Set background
	        if (this.productImage.image()) {
	            layer.setBackground(this.productImage.image());
	        }
	
	        // Resize canvas and return dataUrl
	        var canvas = layer.konvaLayer.getCanvas()._canvas;
	        var size = _helper2.default.getConstrainedSize(canvas, maxSize);
	        (0, _hermiteResize2.default)(canvas, size);
	        layer.konvaLayer.destroy();
	        stage.destroy();
	        return canvas.toDataURL();
	    };
	
	    PlacingLayer.prototype.emitChange = function emitChange() {
	        this.events.emit('change');
	    };
	
	    return PlacingLayer;
	}();
	
	exports.default = PlacingLayer;

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';
	  /**
	     * Rect constructor
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {Number} [config.cornerRadius]
	     * @@shapeParams
	     * @@nodeParams
	     * @example
	     * var rect = new Konva.Rect({
	     *   width: 100,
	     *   height: 50,
	     *   fill: 'red',
	     *   stroke: 'black',
	     *   strokeWidth: 5
	     * });
	     */
	  Konva.Rect = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Rect.prototype = {
	    ___init: function(config) {
	      Konva.Shape.call(this, config);
	      this.className = 'Rect';
	      this.sceneFunc(this._sceneFunc);
	    },
	    _sceneFunc: function(context) {
	      var cornerRadius = this.getCornerRadius(),
	        width = this.getWidth(),
	        height = this.getHeight();
	
	      context.beginPath();
	
	      if (!cornerRadius) {
	        // simple rect - don't bother doing all that complicated maths stuff.
	        context.rect(0, 0, width, height);
	      } else {
	        // arcTo would be nicer, but browser support is patchy (Opera)
	        cornerRadius = Math.min(cornerRadius, width / 2, height / 2);
	        context.moveTo(cornerRadius, 0);
	        context.lineTo(width - cornerRadius, 0);
	        context.arc(
	          width - cornerRadius,
	          cornerRadius,
	          cornerRadius,
	          Math.PI * 3 / 2,
	          0,
	          false
	        );
	        context.lineTo(width, height - cornerRadius);
	        context.arc(
	          width - cornerRadius,
	          height - cornerRadius,
	          cornerRadius,
	          0,
	          Math.PI / 2,
	          false
	        );
	        context.lineTo(cornerRadius, height);
	        context.arc(
	          cornerRadius,
	          height - cornerRadius,
	          cornerRadius,
	          Math.PI / 2,
	          Math.PI,
	          false
	        );
	        context.lineTo(0, cornerRadius);
	        context.arc(
	          cornerRadius,
	          cornerRadius,
	          cornerRadius,
	          Math.PI,
	          Math.PI * 3 / 2,
	          false
	        );
	      }
	      context.closePath();
	      context.fillStrokeShape(this);
	    }
	  };
	
	  Konva.Util.extend(Konva.Rect, Konva.Shape);
	
	  Konva.Factory.addGetterSetter(Konva.Rect, 'cornerRadius', 0);
	  /**
	     * get/set corner radius
	     * @name cornerRadius
	     * @method
	     * @memberof Konva.Rect.prototype
	     * @param {Number} cornerRadius
	     * @returns {Number}
	     * @example
	     * // get corner radius
	     * var cornerRadius = rect.cornerRadius();
	     *
	     * // set corner radius
	     * rect.cornerRadius(10);
	     */
	
	  Konva.Collection.mapMethods(Konva.Rect);
	})();


/***/ }),
/* 350 */
/***/ (function(module, exports) {

	(function(Konva) {
	  'use strict';
	  var now = (function() {
	    if (Konva.global.performance && Konva.global.performance.now) {
	      return function() {
	        return Konva.global.performance.now();
	      };
	    }
	
	    return function() {
	      return new Date().getTime();
	    };
	  })();
	
	  function FRAF(callback) {
	    setTimeout(callback, 1000 / 60);
	  }
	
	  var RAF = (function() {
	    return (
	      Konva.global.requestAnimationFrame ||
	      Konva.global.webkitRequestAnimationFrame ||
	      Konva.global.mozRequestAnimationFrame ||
	      Konva.global.oRequestAnimationFrame ||
	      Konva.global.msRequestAnimationFrame ||
	      FRAF
	    );
	  })();
	
	  function requestAnimFrame() {
	    return RAF.apply(Konva.global, arguments);
	  }
	
	  /**
	     * Animation constructor.  A stage is used to contain multiple layers and handle
	     * @constructor
	     * @memberof Konva
	     * @param {Function} func function executed on each animation frame.  The function is passed a frame object, which contains
	     *  timeDiff, lastTime, time, and frameRate properties.  The timeDiff property is the number of milliseconds that have passed
	     *  since the last animation frame.  The lastTime property is time in milliseconds that elapsed from the moment the animation started
	     *  to the last animation frame.  The time property is the time in milliseconds that ellapsed from the moment the animation started
	     *  to the current animation frame.  The frameRate property is the current frame rate in frames / second. Return false from function,
	     *  if you don't need to redraw layer/layers on some frames.
	     * @param {Konva.Layer|Array} [layers] layer(s) to be redrawn on each animation frame. Can be a layer, an array of layers, or null.
	     *  Not specifying a node will result in no redraw.
	     * @example
	     * // move a node to the right at 50 pixels / second
	     * var velocity = 50;
	     *
	     * var anim = new Konva.Animation(function(frame) {
	     *   var dist = velocity * (frame.timeDiff / 1000);
	     *   node.move(dist, 0);
	     * }, layer);
	     *
	     * anim.start();
	     */
	  Konva.Animation = function(func, layers) {
	    var Anim = Konva.Animation;
	    this.func = func;
	    this.setLayers(layers);
	    this.id = Anim.animIdCounter++;
	    this.frame = {
	      time: 0,
	      timeDiff: 0,
	      lastTime: now()
	    };
	  };
	  /*
	     * Animation methods
	     */
	  Konva.Animation.prototype = {
	    /**
	         * set layers to be redrawn on each animation frame
	         * @method
	         * @memberof Konva.Animation.prototype
	         * @param {Konva.Layer|Array} [layers] layer(s) to be redrawn.&nbsp; Can be a layer, an array of layers, or null.  Not specifying a node will result in no redraw.
	         * @return {Konva.Animation} this
	         */
	    setLayers: function(layers) {
	      var lays = [];
	      // if passing in no layers
	      if (!layers) {
	        lays = [];
	      } else if (layers.length > 0) {
	        // if passing in an array of Layers
	        // NOTE: layers could be an array or Konva.Collection.  for simplicity, I'm just inspecting
	        // the length property to check for both cases
	        lays = layers;
	      } else {
	        // if passing in a Layer
	        lays = [layers];
	      }
	
	      this.layers = lays;
	      return this;
	    },
	    /**
	         * get layers
	         * @method
	         * @memberof Konva.Animation.prototype
	         * @return {Array} Array of Konva.Layer
	         */
	    getLayers: function() {
	      return this.layers;
	    },
	    /**
	         * add layer.  Returns true if the layer was added, and false if it was not
	         * @method
	         * @memberof Konva.Animation.prototype
	         * @param {Konva.Layer} layer to add
	         * @return {Bool} true if layer is added to animation, otherwise false
	         */
	    addLayer: function(layer) {
	      var layers = this.layers, len = layers.length, n;
	
	      // don't add the layer if it already exists
	      for (n = 0; n < len; n++) {
	        if (layers[n]._id === layer._id) {
	          return false;
	        }
	      }
	
	      this.layers.push(layer);
	      return true;
	    },
	    /**
	         * determine if animation is running or not.  returns true or false
	         * @method
	         * @memberof Konva.Animation.prototype
	         * @return {Bool} is animation running?
	         */
	    isRunning: function() {
	      var a = Konva.Animation,
	        animations = a.animations,
	        len = animations.length,
	        n;
	
	      for (n = 0; n < len; n++) {
	        if (animations[n].id === this.id) {
	          return true;
	        }
	      }
	      return false;
	    },
	    /**
	         * start animation
	         * @method
	         * @memberof Konva.Animation.prototype
	         * @return {Konva.Animation} this
	         */
	    start: function() {
	      var Anim = Konva.Animation;
	      this.stop();
	      this.frame.timeDiff = 0;
	      this.frame.lastTime = now();
	      Anim._addAnimation(this);
	      return this;
	    },
	    /**
	         * stop animation
	         * @method
	         * @memberof Konva.Animation.prototype
	         * @return {Konva.Animation} this
	         */
	    stop: function() {
	      Konva.Animation._removeAnimation(this);
	      return this;
	    },
	    _updateFrameObject: function(time) {
	      this.frame.timeDiff = time - this.frame.lastTime;
	      this.frame.lastTime = time;
	      this.frame.time += this.frame.timeDiff;
	      this.frame.frameRate = 1000 / this.frame.timeDiff;
	    }
	  };
	  Konva.Animation.animations = [];
	  Konva.Animation.animIdCounter = 0;
	  Konva.Animation.animRunning = false;
	
	  Konva.Animation._addAnimation = function(anim) {
	    this.animations.push(anim);
	    this._handleAnimation();
	  };
	  Konva.Animation._removeAnimation = function(anim) {
	    var id = anim.id, animations = this.animations, len = animations.length, n;
	
	    for (n = 0; n < len; n++) {
	      if (animations[n].id === id) {
	        this.animations.splice(n, 1);
	        break;
	      }
	    }
	  };
	
	  Konva.Animation._runFrames = function() {
	    var layerHash = {},
	      animations = this.animations,
	      anim,
	      layers,
	      func,
	      n,
	      i,
	      layersLen,
	      layer,
	      key,
	      needRedraw;
	    /*
	         * loop through all animations and execute animation
	         *  function.  if the animation object has specified node,
	         *  we can add the node to the nodes hash to eliminate
	         *  drawing the same node multiple times.  The node property
	         *  can be the stage itself or a layer
	         */
	    /*
	         * WARNING: don't cache animations.length because it could change while
	         * the for loop is running, causing a JS error
	         */
	
	    for (n = 0; n < animations.length; n++) {
	      anim = animations[n];
	      layers = anim.layers;
	      func = anim.func;
	
	      anim._updateFrameObject(now());
	      layersLen = layers.length;
	
	      // if animation object has a function, execute it
	      if (func) {
	        // allow anim bypassing drawing
	        needRedraw = func.call(anim, anim.frame) !== false;
	      } else {
	        needRedraw = true;
	      }
	      if (!needRedraw) {
	        continue;
	      }
	      for (i = 0; i < layersLen; i++) {
	        layer = layers[i];
	
	        if (layer._id !== undefined) {
	          layerHash[layer._id] = layer;
	        }
	      }
	    }
	
	    for (key in layerHash) {
	      if (!layerHash.hasOwnProperty(key)) {
	        continue;
	      }
	      layerHash[key].draw();
	    }
	  };
	  Konva.Animation._animationLoop = function() {
	    var Anim = Konva.Animation;
	    if (Anim.animations.length) {
	      Anim._runFrames();
	      requestAnimFrame(Anim._animationLoop);
	    } else {
	      Anim.animRunning = false;
	    }
	  };
	  Konva.Animation._handleAnimation = function() {
	    if (!this.animRunning) {
	      this.animRunning = true;
	      requestAnimFrame(this._animationLoop);
	    }
	  };
	
	  /**
	     * batch draw. this function will not do immediate draw
	     * but it will schedule drawing to next tick (requestAnimFrame)
	     * @method
	     * @return {Konva.Layer} this
	     * @memberof Konva.Base.prototype
	     */
	  Konva.BaseLayer.prototype.batchDraw = function() {
	    var that = this, Anim = Konva.Animation;
	
	    if (!this.batchAnim) {
	      this.batchAnim = new Anim(function() {
	        // stop animation after first tick
	        that.batchAnim.stop();
	      }, this);
	    }
	
	    if (!this.batchAnim.isRunning()) {
	      this.batchAnim.start();
	    }
	    return this;
	  };
	
	  /**
	     * batch draw
	     * @method
	     * @return {Konva.Stage} this
	     * @memberof Konva.Stage.prototype
	     */
	  Konva.Stage.prototype.batchDraw = function() {
	    this.getChildren().each(function(layer) {
	      layer.batchDraw();
	    });
	    return this;
	  };
	})(Konva);


/***/ }),
/* 351 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';
	  Konva.DD = {
	    // properties
	    anim: new Konva.Animation(function() {
	      var b = this.dirty;
	      this.dirty = false;
	      return b;
	    }),
	    isDragging: false,
	    justDragged: false,
	    offset: {
	      x: 0,
	      y: 0
	    },
	    node: null,
	
	    // methods
	    _drag: function(evt) {
	      var dd = Konva.DD,
	        node = dd.node;
	      if (node) {
	        if (!dd.isDragging) {
	          var pos = node.getStage().getPointerPosition();
	          // it is possible that pos is undefined
	          // reattach it
	          if (!pos) {
	            node.getStage()._setPointerPosition(evt);
	            pos = node.getStage().getPointerPosition();
	          }
	          var dragDistance = node.dragDistance();
	          var distance = Math.max(
	            Math.abs(pos.x - dd.startPointerPos.x),
	            Math.abs(pos.y - dd.startPointerPos.y)
	          );
	          if (distance < dragDistance) {
	            return;
	          }
	        }
	
	        node.getStage()._setPointerPosition(evt);
	        node._setDragPosition(evt);
	        if (!dd.isDragging) {
	          dd.isDragging = true;
	          node.fire(
	            'dragstart',
	            {
	              type: 'dragstart',
	              target: node,
	              evt: evt
	            },
	            true
	          );
	        }
	
	        // execute ondragmove if defined
	        node.fire(
	          'dragmove',
	          {
	            type: 'dragmove',
	            target: node,
	            evt: evt
	          },
	          true
	        );
	      }
	    },
	    _endDragBefore: function(evt) {
	      var dd = Konva.DD,
	        node = dd.node,
	        layer;
	
	      if (node) {
	        layer = node.getLayer();
	        dd.anim.stop();
	
	        // only fire dragend event if the drag and drop
	        // operation actually started.
	        if (dd.isDragging) {
	          dd.isDragging = false;
	          dd.justDragged = true;
	          Konva.listenClickTap = false;
	
	          if (evt) {
	            evt.dragEndNode = node;
	          }
	        }
	
	        delete dd.node;
	
	        if (node.getLayer() || layer || node instanceof Konva.Stage) {
	          (layer || node).draw();
	        }
	      }
	    },
	    _endDragAfter: function(evt) {
	      evt = evt || {};
	      var dragEndNode = evt.dragEndNode;
	
	      if (evt && dragEndNode) {
	        dragEndNode.fire(
	          'dragend',
	          {
	            type: 'dragend',
	            target: dragEndNode,
	            evt: evt
	          },
	          true
	        );
	      }
	    }
	  };
	
	  // Node extenders
	
	  /**
	     * initiate drag and drop
	     * @method
	     * @memberof Konva.Node.prototype
	     */
	  Konva.Node.prototype.startDrag = function() {
	    var dd = Konva.DD,
	      stage = this.getStage(),
	      layer = this.getLayer(),
	      pos = stage.getPointerPosition(),
	      ap = this.getAbsolutePosition();
	
	    if (pos) {
	      if (dd.node) {
	        dd.node.stopDrag();
	      }
	
	      dd.node = this;
	      dd.startPointerPos = pos;
	      dd.offset.x = pos.x - ap.x;
	      dd.offset.y = pos.y - ap.y;
	      dd.anim.setLayers(layer || this.getLayers());
	      dd.anim.start();
	
	      this._setDragPosition();
	    }
	  };
	
	  Konva.Node.prototype._setDragPosition = function(evt) {
	    var dd = Konva.DD,
	      pos = this.getStage().getPointerPosition(),
	      dbf = this.getDragBoundFunc();
	    if (!pos) {
	      return;
	    }
	    var newNodePos = {
	      x: pos.x - dd.offset.x,
	      y: pos.y - dd.offset.y
	    };
	
	    if (dbf !== undefined) {
	      newNodePos = dbf.call(this, newNodePos, evt);
	    }
	    this.setAbsolutePosition(newNodePos);
	
	    if (
	      !this._lastPos ||
	      this._lastPos.x !== newNodePos.x ||
	      this._lastPos.y !== newNodePos.y
	    ) {
	      dd.anim.dirty = true;
	    }
	
	    this._lastPos = newNodePos;
	  };
	
	  /**
	     * stop drag and drop
	     * @method
	     * @memberof Konva.Node.prototype
	     */
	  Konva.Node.prototype.stopDrag = function() {
	    var dd = Konva.DD,
	      evt = {};
	    dd._endDragBefore(evt);
	    dd._endDragAfter(evt);
	  };
	
	  Konva.Node.prototype.setDraggable = function(draggable) {
	    this._setAttr('draggable', draggable);
	    this._dragChange();
	  };
	
	  var origRemove = Konva.Node.prototype.remove;
	
	  Konva.Node.prototype.__originalRemove = origRemove;
	  Konva.Node.prototype.remove = function() {
	    var dd = Konva.DD;
	
	    // stop DD
	    if (dd.node && dd.node._id === this._id) {
	      this.stopDrag();
	    }
	
	    origRemove.call(this);
	  };
	
	  /**
	     * determine if node is currently in drag and drop mode
	     * @method
	     * @memberof Konva.Node.prototype
	     */
	  Konva.Node.prototype.isDragging = function() {
	    var dd = Konva.DD;
	    return !!(dd.node && dd.node._id === this._id && dd.isDragging);
	  };
	
	  Konva.Node.prototype._listenDrag = function() {
	    var that = this;
	
	    this._dragCleanup();
	
	    if (this.getClassName() === 'Stage') {
	      this.on('contentMousedown.konva contentTouchstart.konva', function(evt) {
	        if (!Konva.DD.node) {
	          that.startDrag(evt);
	        }
	      });
	    } else {
	      this.on('mousedown.konva touchstart.konva', function(evt) {
	        // ignore right and middle buttons
	        if (evt.evt.button === 1 || evt.evt.button === 2) {
	          return;
	        }
	        if (!Konva.DD.node) {
	          that.startDrag(evt);
	        }
	      });
	    }
	
	    // listening is required for drag and drop
	    /*
	        this._listeningEnabled = true;
	        this._clearSelfAndAncestorCache('listeningEnabled');
	        */
	  };
	
	  Konva.Node.prototype._dragChange = function() {
	    if (this.attrs.draggable) {
	      this._listenDrag();
	    } else {
	      // remove event listeners
	      this._dragCleanup();
	
	      /*
	             * force drag and drop to end
	             * if this node is currently in
	             * drag and drop mode
	             */
	      var stage = this.getStage();
	      var dd = Konva.DD;
	      if (stage && dd.node && dd.node._id === this._id) {
	        dd.node.stopDrag();
	      }
	    }
	  };
	
	  Konva.Node.prototype._dragCleanup = function() {
	    if (this.getClassName() === 'Stage') {
	      this.off('contentMousedown.konva');
	      this.off('contentTouchstart.konva');
	    } else {
	      this.off('mousedown.konva');
	      this.off('touchstart.konva');
	    }
	  };
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'dragBoundFunc');
	
	  /**
	     * get/set drag bound function.  This is used to override the default
	     *  drag and drop position
	     * @name dragBoundFunc
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Function} dragBoundFunc
	     * @returns {Function}
	     * @example
	     * // get drag bound function
	     * var dragBoundFunc = node.dragBoundFunc();
	     *
	     * // create vertical drag and drop
	     * node.dragBoundFunc(function(pos){
	     *   return {
	     *     x: this.getAbsolutePosition().x,
	     *     y: pos.y
	     *   };
	     * });
	     */
	
	  Konva.Factory.addGetter(Konva.Node, 'draggable', false);
	  Konva.Factory.addOverloadedGetterSetter(Konva.Node, 'draggable');
	
	  /**
	     * get/set draggable flag
	     * @name draggable
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Boolean} draggable
	     * @returns {Boolean}
	     * @example
	     * // get draggable flag
	     * var draggable = node.draggable();
	     *
	     * // enable drag and drop
	     * node.draggable(true);
	     *
	     * // disable drag and drop
	     * node.draggable(false);
	     */
	
	  if (Konva.isBrowser) {
	    var html = Konva.document.documentElement;
	    html.addEventListener('mouseup', Konva.DD._endDragBefore, true);
	    html.addEventListener('touchend', Konva.DD._endDragBefore, true);
	
	    html.addEventListener('mousemove', Konva.DD._drag);
	    html.addEventListener('touchmove', Konva.DD._drag);
	
	    html.addEventListener('mouseup', Konva.DD._endDragAfter, false);
	    html.addEventListener('touchend', Konva.DD._endDragAfter, false);
	  }
	})();


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _find = __webpack_require__(353);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _filter = __webpack_require__(475);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _forEach = __webpack_require__(482);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _isEmpty = __webpack_require__(485);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isUndefined = __webpack_require__(486);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _isNull = __webpack_require__(487);
	
	var _isNull2 = _interopRequireDefault(_isNull);
	
	var _remove = __webpack_require__(488);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _clamp = __webpack_require__(494);
	
	var _clamp2 = _interopRequireDefault(_clamp);
	
	var _extend = __webpack_require__(496);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _mapValues = __webpack_require__(514);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _round = __webpack_require__(515);
	
	var _round2 = _interopRequireDefault(_round);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = { find: _find2.default, filter: _filter2.default, forEach: _forEach2.default, isEmpty: _isEmpty2.default, isUndefined: _isUndefined2.default, isNull: _isNull2.default, remove: _remove2.default, clamp: _clamp2.default, extend: _extend2.default, mapValues: _mapValues2.default, round: _round2.default };

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(354),
	    findIndex = __webpack_require__(470);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(355),
	    isArrayLike = __webpack_require__(441),
	    keys = __webpack_require__(422);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(356),
	    baseMatchesProperty = __webpack_require__(450),
	    identity = __webpack_require__(466),
	    isArray = __webpack_require__(418),
	    property = __webpack_require__(467);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(357),
	    getMatchData = __webpack_require__(447),
	    matchesStrictComparable = __webpack_require__(449);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(358),
	    baseIsEqual = __webpack_require__(402);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(359),
	    stackClear = __webpack_require__(367),
	    stackDelete = __webpack_require__(368),
	    stackGet = __webpack_require__(369),
	    stackHas = __webpack_require__(370),
	    stackSet = __webpack_require__(371);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(360),
	    listCacheDelete = __webpack_require__(361),
	    listCacheGet = __webpack_require__(364),
	    listCacheHas = __webpack_require__(365),
	    listCacheSet = __webpack_require__(366);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(362);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(363);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 363 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(362);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(362);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(362);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(359);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 368 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 369 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 370 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(359),
	    Map = __webpack_require__(372),
	    MapCache = __webpack_require__(387);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(373),
	    root = __webpack_require__(378);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(374),
	    getValue = __webpack_require__(386);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(375),
	    isMasked = __webpack_require__(383),
	    isObject = __webpack_require__(382),
	    toSource = __webpack_require__(385);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(376),
	    isObject = __webpack_require__(382);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(377),
	    getRawTag = __webpack_require__(380),
	    objectToString = __webpack_require__(381);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(378);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(379);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 379 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(377);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 381 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(384);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(378);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 385 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 386 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(388),
	    mapCacheDelete = __webpack_require__(396),
	    mapCacheGet = __webpack_require__(399),
	    mapCacheHas = __webpack_require__(400),
	    mapCacheSet = __webpack_require__(401);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(389),
	    ListCache = __webpack_require__(359),
	    Map = __webpack_require__(372);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(390),
	    hashDelete = __webpack_require__(392),
	    hashGet = __webpack_require__(393),
	    hashHas = __webpack_require__(394),
	    hashSet = __webpack_require__(395);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(391);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(373);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 392 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(391);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(391);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(391);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(397);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(398);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 398 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(397);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(397);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(397);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(403),
	    isObjectLike = __webpack_require__(427);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(358),
	    equalArrays = __webpack_require__(404),
	    equalByTag = __webpack_require__(410),
	    equalObjects = __webpack_require__(414),
	    getTag = __webpack_require__(442),
	    isArray = __webpack_require__(418),
	    isBuffer = __webpack_require__(428),
	    isTypedArray = __webpack_require__(432);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(405),
	    arraySome = __webpack_require__(408),
	    cacheHas = __webpack_require__(409);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(387),
	    setCacheAdd = __webpack_require__(406),
	    setCacheHas = __webpack_require__(407);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 406 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 407 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 408 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 409 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(377),
	    Uint8Array = __webpack_require__(411),
	    eq = __webpack_require__(363),
	    equalArrays = __webpack_require__(404),
	    mapToArray = __webpack_require__(412),
	    setToArray = __webpack_require__(413);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(378);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 412 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 413 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(415);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(416),
	    getSymbols = __webpack_require__(419),
	    keys = __webpack_require__(422);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(417),
	    isArray = __webpack_require__(418);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 417 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 418 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(420),
	    stubArray = __webpack_require__(421);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 420 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 421 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(423),
	    baseKeys = __webpack_require__(437),
	    isArrayLike = __webpack_require__(441);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(424),
	    isArguments = __webpack_require__(425),
	    isArray = __webpack_require__(418),
	    isBuffer = __webpack_require__(428),
	    isIndex = __webpack_require__(431),
	    isTypedArray = __webpack_require__(432);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 424 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(426),
	    isObjectLike = __webpack_require__(427);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(376),
	    isObjectLike = __webpack_require__(427);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 427 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(378),
	    stubFalse = __webpack_require__(430);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(429)(module)))

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 430 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 431 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(433),
	    baseUnary = __webpack_require__(435),
	    nodeUtil = __webpack_require__(436);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(376),
	    isLength = __webpack_require__(434),
	    isObjectLike = __webpack_require__(427);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 434 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 435 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(379);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(429)(module)))

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(438),
	    nativeKeys = __webpack_require__(439);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 438 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(440);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 440 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(375),
	    isLength = __webpack_require__(434);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(443),
	    Map = __webpack_require__(372),
	    Promise = __webpack_require__(444),
	    Set = __webpack_require__(445),
	    WeakMap = __webpack_require__(446),
	    baseGetTag = __webpack_require__(376),
	    toSource = __webpack_require__(385);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(373),
	    root = __webpack_require__(378);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(373),
	    root = __webpack_require__(378);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(373),
	    root = __webpack_require__(378);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(373),
	    root = __webpack_require__(378);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(448),
	    keys = __webpack_require__(422);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(382);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 449 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(402),
	    get = __webpack_require__(451),
	    hasIn = __webpack_require__(463),
	    isKey = __webpack_require__(454),
	    isStrictComparable = __webpack_require__(448),
	    matchesStrictComparable = __webpack_require__(449),
	    toKey = __webpack_require__(462);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(452);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(453),
	    toKey = __webpack_require__(462);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(418),
	    isKey = __webpack_require__(454),
	    stringToPath = __webpack_require__(456),
	    toString = __webpack_require__(459);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(418),
	    isSymbol = __webpack_require__(455);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(376),
	    isObjectLike = __webpack_require__(427);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(457);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(458);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(387);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(460);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(377),
	    arrayMap = __webpack_require__(461),
	    isArray = __webpack_require__(418),
	    isSymbol = __webpack_require__(455);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 461 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(455);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(464),
	    hasPath = __webpack_require__(465);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 464 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(453),
	    isArguments = __webpack_require__(425),
	    isArray = __webpack_require__(418),
	    isIndex = __webpack_require__(431),
	    isLength = __webpack_require__(434),
	    toKey = __webpack_require__(462);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 466 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(468),
	    basePropertyDeep = __webpack_require__(469),
	    isKey = __webpack_require__(454),
	    toKey = __webpack_require__(462);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 468 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(452);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(471),
	    baseIteratee = __webpack_require__(355),
	    toInteger = __webpack_require__(472);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 471 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(473);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(474);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(382),
	    isSymbol = __webpack_require__(455);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(420),
	    baseFilter = __webpack_require__(476),
	    baseIteratee = __webpack_require__(355),
	    isArray = __webpack_require__(418);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(477);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(478),
	    createBaseEach = __webpack_require__(481);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(479),
	    keys = __webpack_require__(422);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(480);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 480 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(441);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(483),
	    baseEach = __webpack_require__(477),
	    castFunction = __webpack_require__(484),
	    isArray = __webpack_require__(418);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),
/* 483 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(466);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(437),
	    getTag = __webpack_require__(442),
	    isArguments = __webpack_require__(425),
	    isArray = __webpack_require__(418),
	    isArrayLike = __webpack_require__(441),
	    isBuffer = __webpack_require__(428),
	    isPrototype = __webpack_require__(438),
	    isTypedArray = __webpack_require__(432);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ }),
/* 486 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ }),
/* 487 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	 * @example
	 *
	 * _.isNull(null);
	 * // => true
	 *
	 * _.isNull(void 0);
	 * // => false
	 */
	function isNull(value) {
	  return value === null;
	}
	
	module.exports = isNull;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(355),
	    basePullAt = __webpack_require__(489);
	
	/**
	 * Removes all elements from `array` that `predicate` returns truthy for
	 * and returns an array of the removed elements. The predicate is invoked
	 * with three arguments: (value, index, array).
	 *
	 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	 * to pull elements from an array by value.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new array of removed elements.
	 * @example
	 *
	 * var array = [1, 2, 3, 4];
	 * var evens = _.remove(array, function(n) {
	 *   return n % 2 == 0;
	 * });
	 *
	 * console.log(array);
	 * // => [1, 3]
	 *
	 * console.log(evens);
	 * // => [2, 4]
	 */
	function remove(array, predicate) {
	  var result = [];
	  if (!(array && array.length)) {
	    return result;
	  }
	  var index = -1,
	      indexes = [],
	      length = array.length;
	
	  predicate = baseIteratee(predicate, 3);
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result.push(value);
	      indexes.push(index);
	    }
	  }
	  basePullAt(array, indexes);
	  return result;
	}
	
	module.exports = remove;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	var baseUnset = __webpack_require__(490),
	    isIndex = __webpack_require__(431);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * The base implementation of `_.pullAt` without support for individual
	 * indexes or capturing the removed elements.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {number[]} indexes The indexes of elements to remove.
	 * @returns {Array} Returns `array`.
	 */
	function basePullAt(array, indexes) {
	  var length = array ? indexes.length : 0,
	      lastIndex = length - 1;
	
	  while (length--) {
	    var index = indexes[length];
	    if (length == lastIndex || index !== previous) {
	      var previous = index;
	      if (isIndex(index)) {
	        splice.call(array, index, 1);
	      } else {
	        baseUnset(array, index);
	      }
	    }
	  }
	  return array;
	}
	
	module.exports = basePullAt;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(453),
	    last = __webpack_require__(491),
	    parent = __webpack_require__(492),
	    toKey = __webpack_require__(462);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ }),
/* 491 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(452),
	    baseSlice = __webpack_require__(493);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ }),
/* 493 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(495),
	    toNumber = __webpack_require__(474);
	
	/**
	 * Clamps `number` within the inclusive `lower` and `upper` bounds.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Number
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 * @example
	 *
	 * _.clamp(-10, -5, 5);
	 * // => -5
	 *
	 * _.clamp(10, -5, 5);
	 * // => 5
	 */
	function clamp(number, lower, upper) {
	  if (upper === undefined) {
	    upper = lower;
	    lower = undefined;
	  }
	  if (upper !== undefined) {
	    upper = toNumber(upper);
	    upper = upper === upper ? upper : 0;
	  }
	  if (lower !== undefined) {
	    lower = toNumber(lower);
	    lower = lower === lower ? lower : 0;
	  }
	  return baseClamp(toNumber(number), lower, upper);
	}
	
	module.exports = clamp;


/***/ }),
/* 495 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	module.exports = baseClamp;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(497);


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(498),
	    createAssigner = __webpack_require__(502),
	    keysIn = __webpack_require__(511);
	
	/**
	 * This method is like `_.assign` except that it iterates over own and
	 * inherited source properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assign
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	 */
	var assignIn = createAssigner(function(object, source) {
	  copyObject(source, keysIn(source), object);
	});
	
	module.exports = assignIn;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(499),
	    baseAssignValue = __webpack_require__(500);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(500),
	    eq = __webpack_require__(363);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(501);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(373);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(503),
	    isIterateeCall = __webpack_require__(510);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(466),
	    overRest = __webpack_require__(504),
	    setToString = __webpack_require__(506);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(505);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 505 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(507),
	    shortOut = __webpack_require__(509);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(508),
	    defineProperty = __webpack_require__(501),
	    identity = __webpack_require__(466);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 508 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 509 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(363),
	    isArrayLike = __webpack_require__(441),
	    isIndex = __webpack_require__(431),
	    isObject = __webpack_require__(382);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(423),
	    baseKeysIn = __webpack_require__(512),
	    isArrayLike = __webpack_require__(441);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(382),
	    isPrototype = __webpack_require__(438),
	    nativeKeysIn = __webpack_require__(513);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 513 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(500),
	    baseForOwn = __webpack_require__(478),
	    baseIteratee = __webpack_require__(355);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	var createRound = __webpack_require__(516);
	
	/**
	 * Computes `number` rounded to `precision`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.10.0
	 * @category Math
	 * @param {number} number The number to round.
	 * @param {number} [precision=0] The precision to round to.
	 * @returns {number} Returns the rounded number.
	 * @example
	 *
	 * _.round(4.006);
	 * // => 4
	 *
	 * _.round(4.006, 2);
	 * // => 4.01
	 *
	 * _.round(4060, -2);
	 * // => 4100
	 */
	var round = createRound('round');
	
	module.exports = round;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(472),
	    toNumber = __webpack_require__(474),
	    toString = __webpack_require__(459);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Creates a function like `_.round`.
	 *
	 * @private
	 * @param {string} methodName The name of the `Math` method to use when rounding.
	 * @returns {Function} Returns the new round function.
	 */
	function createRound(methodName) {
	  var func = Math[methodName];
	  return function(number, precision) {
	    number = toNumber(number);
	    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	    if (precision) {
	      // Shift with exponential notation to avoid floating-point issues.
	      // See [MDN](https://mdn.io/round#Examples) for more details.
	      var pair = (toString(number) + 'e').split('e'),
	          value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	      pair = (toString(value) + 'e').split('e');
	      return +(pair[0] + 'e' + (+pair[1] - precision));
	    }
	    return func(number);
	  };
	}
	
	module.exports = createRound;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _sat = __webpack_require__(518);
	
	var _sat2 = _interopRequireDefault(_sat);
	
	var _customLodash = __webpack_require__(352);
	
	var _customLodash2 = _interopRequireDefault(_customLodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Helper = function () {
	    function Helper() {
	        _classCallCheck(this, Helper);
	    }
	
	    Helper.prototype.getImage = function getImage(imageUrl) {
	        return new Promise(function (resolve, reject) {
	            var img = new Image();
	            img.onload = function () {
	                return resolve(img);
	            };
	            img.onerror = function (err) {
	                return reject(err);
	            };
	            img.crossOrigin = 'Anonymous';
	            img.src = imageUrl;
	        });
	    };
	
	    Helper.prototype.getAngle = function getAngle(firstPos, secondPos) {
	        var xDistance = firstPos.x - secondPos.x;
	        var yDistance = firstPos.y - secondPos.y;
	        var rad = Math.atan2(yDistance, xDistance);
	        return rad * (180 / Math.PI);
	    };
	
	    Helper.prototype.isIntersecting = function isIntersecting(rect1, rect2) {
	        var createVector = function createVector(corner) {
	            return new _sat2.default.Vector(corner.x, corner.y);
	        };
	        var createPolygon = function createPolygon(rect) {
	            return new _sat2.default.Polygon(new _sat2.default.Vector(), [createVector(rect.topLeft), createVector(rect.bottomLeft), createVector(rect.bottomRight), createVector(rect.topRight)]);
	        };
	
	        var p1 = createPolygon(rect1);
	        var p2 = createPolygon(rect2);
	
	        return _sat2.default.testPolygonPolygon(p1, p2);
	    };
	
	    Helper.prototype.getCorners = function getCorners(konvaObj) {
	        var size = {
	            width: konvaObj.getWidth(),
	            height: konvaObj.getHeight()
	        };
	        var corners = {
	            topLeft: { x: 0, y: 0 },
	            topRight: { x: size.width, y: 0 },
	            bottomLeft: { x: 0, y: size.height },
	            bottomRight: { x: size.width, y: size.height }
	        };
	        var transform = konvaObj.getAbsoluteTransform();
	        var tCorners = _customLodash2.default.mapValues(corners, function (c) {
	            return transform.point(c);
	        });
	
	        return tCorners;
	    };
	
	    Helper.prototype.getConstrainedSize = function getConstrainedSize(box, maxSize) {
	        var maxWidth = maxSize.width;
	        var maxHeight = maxSize.height;
	        var boxSize = { width: box.width, height: box.height };
	
	        var widthOverflow = boxSize.width - maxWidth;
	        if (widthOverflow > 0) {
	            boxSize.height = maxWidth / boxSize.width * boxSize.height;
	            boxSize.width = maxWidth;
	        }
	
	        var heightOverflow = boxSize.height - maxHeight;
	        if (heightOverflow > 0) {
	            boxSize.width = maxHeight / boxSize.height * boxSize.width;
	            boxSize.height = maxHeight;
	        }
	
	        return boxSize;
	    };
	
	    return Helper;
	}();
	
	exports.default = new Helper();

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {// Version 0.5.0 - Copyright 2012 - 2015 -  Jim Riecken <jimr@jimr.ca>
	//
	// Released under the MIT License - https://github.com/jriecken/sat-js
	//
	// A simple library for determining intersections of circles and
	// polygons using the Separating Axis Theorem.
	/** @preserve SAT.js - Version 0.5.0 - Copyright 2012 - 2015 - Jim Riecken <jimr@jimr.ca> - released under the MIT License. https://github.com/jriecken/sat-js */
	
	/*global define: false, module: false*/
	/*jshint shadow:true, sub:true, forin:true, noarg:true, noempty:true, 
	  eqeqeq:true, bitwise:true, strict:true, undef:true, 
	  curly:true, browser:true */
	
	// Create a UMD wrapper for SAT. Works in:
	//
	//  - Plain browser via global SAT variable
	//  - AMD loader (like require.js)
	//  - Node.js
	//
	// The quoted properties all over the place are used so that the Closure Compiler
	// does not mangle the exposed API in advanced mode.
	/**
	 * @param {*} root - The global scope
	 * @param {Function} factory - Factory that creates SAT module
	 */
	(function (root, factory) {
	  "use strict";
	  if ("function" === 'function' && __webpack_require__(519)['amd']) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (true) {
	    module['exports'] = factory();
	  } else {
	    root['SAT'] = factory();
	  }
	}(this, function () {
	  "use strict";
	
	  var SAT = {};
	
	  //
	  // ## Vector
	  //
	  // Represents a vector in two dimensions with `x` and `y` properties.
	
	
	  // Create a new Vector, optionally passing in the `x` and `y` coordinates. If
	  // a coordinate is not specified, it will be set to `0`
	  /** 
	   * @param {?number=} x The x position.
	   * @param {?number=} y The y position.
	   * @constructor
	   */
	  function Vector(x, y) {
	    this['x'] = x || 0;
	    this['y'] = y || 0;
	  }
	  SAT['Vector'] = Vector;
	  // Alias `Vector` as `V`
	  SAT['V'] = Vector;
	
	
	  // Copy the values of another Vector into this one.
	  /**
	   * @param {Vector} other The other Vector.
	   * @return {Vector} This for chaining.
	   */
	  Vector.prototype['copy'] = Vector.prototype.copy = function(other) {
	    this['x'] = other['x'];
	    this['y'] = other['y'];
	    return this;
	  };
	
	  // Create a new vector with the same coordinates as this on.
	  /**
	   * @return {Vector} The new cloned vector
	   */
	  Vector.prototype['clone'] = Vector.prototype.clone = function() {
	    return new Vector(this['x'], this['y']);
	  };
	
	  // Change this vector to be perpendicular to what it was before. (Effectively
	  // roatates it 90 degrees in a clockwise direction)
	  /**
	   * @return {Vector} This for chaining.
	   */
	  Vector.prototype['perp'] = Vector.prototype.perp = function() {
	    var x = this['x'];
	    this['x'] = this['y'];
	    this['y'] = -x;
	    return this;
	  };
	
	  // Rotate this vector (counter-clockwise) by the specified angle (in radians).
	  /**
	   * @param {number} angle The angle to rotate (in radians)
	   * @return {Vector} This for chaining.
	   */
	  Vector.prototype['rotate'] = Vector.prototype.rotate = function (angle) {
	    var x = this['x'];
	    var y = this['y'];
	    this['x'] = x * Math.cos(angle) - y * Math.sin(angle);
	    this['y'] = x * Math.sin(angle) + y * Math.cos(angle);
	    return this;
	  };
	
	  // Reverse this vector.
	  /**
	   * @return {Vector} This for chaining.
	   */
	  Vector.prototype['reverse'] = Vector.prototype.reverse = function() {
	    this['x'] = -this['x'];
	    this['y'] = -this['y'];
	    return this;
	  };
	  
	
	  // Normalize this vector.  (make it have length of `1`)
	  /**
	   * @return {Vector} This for chaining.
	   */
	  Vector.prototype['normalize'] = Vector.prototype.normalize = function() {
	    var d = this.len();
	    if(d > 0) {
	      this['x'] = this['x'] / d;
	      this['y'] = this['y'] / d;
	    }
	    return this;
	  };
	  
	  // Add another vector to this one.
	  /**
	   * @param {Vector} other The other Vector.
	   * @return {Vector} This for chaining.
	   */
	  Vector.prototype['add'] = Vector.prototype.add = function(other) {
	    this['x'] += other['x'];
	    this['y'] += other['y'];
	    return this;
	  };
	  
	  // Subtract another vector from this one.
	  /**
	   * @param {Vector} other The other Vector.
	   * @return {Vector} This for chaiing.
	   */
	  Vector.prototype['sub'] = Vector.prototype.sub = function(other) {
	    this['x'] -= other['x'];
	    this['y'] -= other['y'];
	    return this;
	  };
	  
	  // Scale this vector. An independant scaling factor can be provided
	  // for each axis, or a single scaling factor that will scale both `x` and `y`.
	  /**
	   * @param {number} x The scaling factor in the x direction.
	   * @param {?number=} y The scaling factor in the y direction.  If this
	   *   is not specified, the x scaling factor will be used.
	   * @return {Vector} This for chaining.
	   */
	  Vector.prototype['scale'] = Vector.prototype.scale = function(x,y) {
	    this['x'] *= x;
	    this['y'] *= y || x;
	    return this; 
	  };
	  
	  // Project this vector on to another vector.
	  /**
	   * @param {Vector} other The vector to project onto.
	   * @return {Vector} This for chaining.
	   */
	  Vector.prototype['project'] = Vector.prototype.project = function(other) {
	    var amt = this.dot(other) / other.len2();
	    this['x'] = amt * other['x'];
	    this['y'] = amt * other['y'];
	    return this;
	  };
	  
	  // Project this vector onto a vector of unit length. This is slightly more efficient
	  // than `project` when dealing with unit vectors.
	  /**
	   * @param {Vector} other The unit vector to project onto.
	   * @return {Vector} This for chaining.
	   */
	  Vector.prototype['projectN'] = Vector.prototype.projectN = function(other) {
	    var amt = this.dot(other);
	    this['x'] = amt * other['x'];
	    this['y'] = amt * other['y'];
	    return this;
	  };
	  
	  // Reflect this vector on an arbitrary axis.
	  /**
	   * @param {Vector} axis The vector representing the axis.
	   * @return {Vector} This for chaining.
	   */
	  Vector.prototype['reflect'] = Vector.prototype.reflect = function(axis) {
	    var x = this['x'];
	    var y = this['y'];
	    this.project(axis).scale(2);
	    this['x'] -= x;
	    this['y'] -= y;
	    return this;
	  };
	  
	  // Reflect this vector on an arbitrary axis (represented by a unit vector). This is
	  // slightly more efficient than `reflect` when dealing with an axis that is a unit vector.
	  /**
	   * @param {Vector} axis The unit vector representing the axis.
	   * @return {Vector} This for chaining.
	   */
	  Vector.prototype['reflectN'] = Vector.prototype.reflectN = function(axis) {
	    var x = this['x'];
	    var y = this['y'];
	    this.projectN(axis).scale(2);
	    this['x'] -= x;
	    this['y'] -= y;
	    return this;
	  };
	  
	  // Get the dot product of this vector and another.
	  /**
	   * @param {Vector}  other The vector to dot this one against.
	   * @return {number} The dot product.
	   */
	  Vector.prototype['dot'] = Vector.prototype.dot = function(other) {
	    return this['x'] * other['x'] + this['y'] * other['y'];
	  };
	  
	  // Get the squared length of this vector.
	  /**
	   * @return {number} The length^2 of this vector.
	   */
	  Vector.prototype['len2'] = Vector.prototype.len2 = function() {
	    return this.dot(this);
	  };
	  
	  // Get the length of this vector.
	  /**
	   * @return {number} The length of this vector.
	   */
	  Vector.prototype['len'] = Vector.prototype.len = function() {
	    return Math.sqrt(this.len2());
	  };
	  
	  // ## Circle
	  //
	  // Represents a circle with a position and a radius.
	
	  // Create a new circle, optionally passing in a position and/or radius. If no position
	  // is given, the circle will be at `(0,0)`. If no radius is provided, the circle will
	  // have a radius of `0`.
	  /**
	   * @param {Vector=} pos A vector representing the position of the center of the circle
	   * @param {?number=} r The radius of the circle
	   * @constructor
	   */
	  function Circle(pos, r) {
	    this['pos'] = pos || new Vector();
	    this['r'] = r || 0;
	  }
	  SAT['Circle'] = Circle;
	  
	  // Compute the axis-aligned bounding box (AABB) of this Circle.
	  //
	  // Note: Returns a _new_ `Polygon` each time you call this.
	  /**
	   * @return {Polygon} The AABB
	   */
	  Circle.prototype['getAABB'] = Circle.prototype.getAABB = function() {
	    var r = this['r'];
	    var corner = this["pos"].clone().sub(new Vector(r, r));
	    return new Box(corner, r*2, r*2).toPolygon();
	  };
	
	  // ## Polygon
	  //
	  // Represents a *convex* polygon with any number of points (specified in counter-clockwise order)
	  //
	  // Note: Do _not_ manually change the `points`, `angle`, or `offset` properties. Use the
	  // provided setters. Otherwise the calculated properties will not be updated correctly.
	  //
	  // `pos` can be changed directly.
	
	  // Create a new polygon, passing in a position vector, and an array of points (represented
	  // by vectors relative to the position vector). If no position is passed in, the position
	  // of the polygon will be `(0,0)`.
	  /**
	   * @param {Vector=} pos A vector representing the origin of the polygon. (all other
	   *   points are relative to this one)
	   * @param {Array.<Vector>=} points An array of vectors representing the points in the polygon,
	   *   in counter-clockwise order.
	   * @constructor
	   */
	  function Polygon(pos, points) {
	    this['pos'] = pos || new Vector();
	    this['angle'] = 0;
	    this['offset'] = new Vector();
	    this.setPoints(points || []);
	  }
	  SAT['Polygon'] = Polygon;
	  
	  // Set the points of the polygon.
	  /**
	   * @param {Array.<Vector>=} points An array of vectors representing the points in the polygon,
	   *   in counter-clockwise order.
	   * @return {Polygon} This for chaining.
	   */
	  Polygon.prototype['setPoints'] = Polygon.prototype.setPoints = function(points) {
	    // Only re-allocate if this is a new polygon or the number of points has changed.
	    var lengthChanged = !this['points'] || this['points'].length !== points.length;
	    if (lengthChanged) {
	      var i;
	      var calcPoints = this['calcPoints'] = [];
	      var edges = this['edges'] = [];
	      var normals = this['normals'] = [];
	      // Allocate the vector arrays for the calculated properties
	      for (i = 0; i < points.length; i++) {
	        calcPoints.push(new Vector());
	        edges.push(new Vector());
	        normals.push(new Vector());
	      }
	    }
	    this['points'] = points;
	    this._recalc();
	    return this;
	  };
	
	  // Set the current rotation angle of the polygon.
	  /**
	   * @param {number} angle The current rotation angle (in radians).
	   * @return {Polygon} This for chaining.
	   */
	  Polygon.prototype['setAngle'] = Polygon.prototype.setAngle = function(angle) {
	    this['angle'] = angle;
	    this._recalc();
	    return this;
	  };
	
	  // Set the current offset to apply to the `points` before applying the `angle` rotation.
	  /**
	   * @param {Vector} offset The new offset vector.
	   * @return {Polygon} This for chaining.
	   */
	  Polygon.prototype['setOffset'] = Polygon.prototype.setOffset = function(offset) {
	    this['offset'] = offset;
	    this._recalc();
	    return this;
	  };
	
	  // Rotates this polygon counter-clockwise around the origin of *its local coordinate system* (i.e. `pos`).
	  //
	  // Note: This changes the **original** points (so any `angle` will be applied on top of this rotation).
	  /**
	   * @param {number} angle The angle to rotate (in radians)
	   * @return {Polygon} This for chaining.
	   */
	  Polygon.prototype['rotate'] = Polygon.prototype.rotate = function(angle) {
	    var points = this['points'];
	    var len = points.length;
	    for (var i = 0; i < len; i++) {
	      points[i].rotate(angle);
	    }
	    this._recalc();
	    return this;
	  };
	
	  // Translates the points of this polygon by a specified amount relative to the origin of *its own coordinate
	  // system* (i.e. `pos`).
	  //
	  // This is most useful to change the "center point" of a polygon. If you just want to move the whole polygon, change
	  // the coordinates of `pos`.
	  //
	  // Note: This changes the **original** points (so any `offset` will be applied on top of this translation)
	  /**
	   * @param {number} x The horizontal amount to translate.
	   * @param {number} y The vertical amount to translate.
	   * @return {Polygon} This for chaining.
	   */
	  Polygon.prototype['translate'] = Polygon.prototype.translate = function (x, y) {
	    var points = this['points'];
	    var len = points.length;
	    for (var i = 0; i < len; i++) {
	      points[i].x += x;
	      points[i].y += y;
	    }
	    this._recalc();
	    return this;
	  };
	
	
	  // Computes the calculated collision polygon. Applies the `angle` and `offset` to the original points then recalculates the
	  // edges and normals of the collision polygon.
	  /**
	   * @return {Polygon} This for chaining.
	   */
	  Polygon.prototype._recalc = function() {
	    // Calculated points - this is what is used for underlying collisions and takes into account
	    // the angle/offset set on the polygon.
	    var calcPoints = this['calcPoints'];
	    // The edges here are the direction of the `n`th edge of the polygon, relative to
	    // the `n`th point. If you want to draw a given edge from the edge value, you must
	    // first translate to the position of the starting point.
	    var edges = this['edges'];
	    // The normals here are the direction of the normal for the `n`th edge of the polygon, relative
	    // to the position of the `n`th point. If you want to draw an edge normal, you must first
	    // translate to the position of the starting point.
	    var normals = this['normals'];
	    // Copy the original points array and apply the offset/angle
	    var points = this['points'];
	    var offset = this['offset'];
	    var angle = this['angle'];
	    var len = points.length;
	    var i;
	    for (i = 0; i < len; i++) {
	      var calcPoint = calcPoints[i].copy(points[i]);
	      calcPoint.x += offset.x;
	      calcPoint.y += offset.y;
	      if (angle !== 0) {
	        calcPoint.rotate(angle);
	      }
	    }
	    // Calculate the edges/normals
	    for (i = 0; i < len; i++) {
	      var p1 = calcPoints[i];
	      var p2 = i < len - 1 ? calcPoints[i + 1] : calcPoints[0];
	      var e = edges[i].copy(p2).sub(p1);
	      normals[i].copy(e).perp().normalize();
	    }
	    return this;
	  };
	  
	  
	  // Compute the axis-aligned bounding box. Any current state
	  // (translations/rotations) will be applied before constructing the AABB.
	  //
	  // Note: Returns a _new_ `Polygon` each time you call this.
	  /**
	   * @return {Polygon} The AABB
	   */
	  Polygon.prototype["getAABB"] = Polygon.prototype.getAABB = function() {
	    var points = this["calcPoints"];
	    var len = points.length;
	    var xMin = points[0]["x"];
	    var yMin = points[0]["y"];
	    var xMax = points[0]["x"];
	    var yMax = points[0]["y"];
	    for (var i = 1; i < len; i++) {
	      var point = points[i];
	      if (point["x"] < xMin) {
	        xMin = point["x"];
	      }
	      else if (point["x"] > xMax) {
	        xMax = point["x"];
	      }
	      if (point["y"] < yMin) {
	        yMin = point["y"];
	      }
	      else if (point["y"] > yMax) {
	        yMax = point["y"];
	      }
	    }
	    return new Box(this["pos"].clone().add(new Vector(xMin, yMin)), xMax - xMin, yMax - yMin).toPolygon();
	  };
	  
	
	  // ## Box
	  //
	  // Represents an axis-aligned box, with a width and height.
	
	
	  // Create a new box, with the specified position, width, and height. If no position
	  // is given, the position will be `(0,0)`. If no width or height are given, they will
	  // be set to `0`.
	  /**
	   * @param {Vector=} pos A vector representing the top-left of the box.
	   * @param {?number=} w The width of the box.
	   * @param {?number=} h The height of the box.
	   * @constructor
	   */
	  function Box(pos, w, h) {
	    this['pos'] = pos || new Vector();
	    this['w'] = w || 0;
	    this['h'] = h || 0;
	  }
	  SAT['Box'] = Box;
	
	  // Returns a polygon whose edges are the same as this box.
	  /**
	   * @return {Polygon} A new Polygon that represents this box.
	   */
	  Box.prototype['toPolygon'] = Box.prototype.toPolygon = function() {
	    var pos = this['pos'];
	    var w = this['w'];
	    var h = this['h'];
	    return new Polygon(new Vector(pos['x'], pos['y']), [
	     new Vector(), new Vector(w, 0), 
	     new Vector(w,h), new Vector(0,h)
	    ]);
	  };
	  
	  // ## Response
	  //
	  // An object representing the result of an intersection. Contains:
	  //  - The two objects participating in the intersection
	  //  - The vector representing the minimum change necessary to extract the first object
	  //    from the second one (as well as a unit vector in that direction and the magnitude
	  //    of the overlap)
	  //  - Whether the first object is entirely inside the second, and vice versa.
	  /**
	   * @constructor
	   */  
	  function Response() {
	    this['a'] = null;
	    this['b'] = null;
	    this['overlapN'] = new Vector();
	    this['overlapV'] = new Vector();
	    this.clear();
	  }
	  SAT['Response'] = Response;
	
	  // Set some values of the response back to their defaults.  Call this between tests if
	  // you are going to reuse a single Response object for multiple intersection tests (recommented
	  // as it will avoid allcating extra memory)
	  /**
	   * @return {Response} This for chaining
	   */
	  Response.prototype['clear'] = Response.prototype.clear = function() {
	    this['aInB'] = true;
	    this['bInA'] = true;
	    this['overlap'] = Number.MAX_VALUE;
	    return this;
	  };
	
	  // ## Object Pools
	
	  // A pool of `Vector` objects that are used in calculations to avoid
	  // allocating memory.
	  /**
	   * @type {Array.<Vector>}
	   */
	  var T_VECTORS = [];
	  for (var i = 0; i < 10; i++) { T_VECTORS.push(new Vector()); }
	  
	  // A pool of arrays of numbers used in calculations to avoid allocating
	  // memory.
	  /**
	   * @type {Array.<Array.<number>>}
	   */
	  var T_ARRAYS = [];
	  for (var i = 0; i < 5; i++) { T_ARRAYS.push([]); }
	
	  // Temporary response used for polygon hit detection.
	  /**
	   * @type {Response}
	   */
	  var T_RESPONSE = new Response();
	
	  // Unit square polygon used for polygon hit detection.
	  /**
	   * @type {Polygon}
	   */
	  var UNIT_SQUARE = new Box(new Vector(), 1, 1).toPolygon();
	
	  // ## Helper Functions
	
	  // Flattens the specified array of points onto a unit vector axis,
	  // resulting in a one dimensional range of the minimum and
	  // maximum value on that axis.
	  /**
	   * @param {Array.<Vector>} points The points to flatten.
	   * @param {Vector} normal The unit vector axis to flatten on.
	   * @param {Array.<number>} result An array.  After calling this function,
	   *   result[0] will be the minimum value,
	   *   result[1] will be the maximum value.
	   */
	  function flattenPointsOn(points, normal, result) {
	    var min = Number.MAX_VALUE;
	    var max = -Number.MAX_VALUE;
	    var len = points.length;
	    for (var i = 0; i < len; i++ ) {
	      // The magnitude of the projection of the point onto the normal
	      var dot = points[i].dot(normal);
	      if (dot < min) { min = dot; }
	      if (dot > max) { max = dot; }
	    }
	    result[0] = min; result[1] = max;
	  }
	  
	  // Check whether two convex polygons are separated by the specified
	  // axis (must be a unit vector).
	  /**
	   * @param {Vector} aPos The position of the first polygon.
	   * @param {Vector} bPos The position of the second polygon.
	   * @param {Array.<Vector>} aPoints The points in the first polygon.
	   * @param {Array.<Vector>} bPoints The points in the second polygon.
	   * @param {Vector} axis The axis (unit sized) to test against.  The points of both polygons
	   *   will be projected onto this axis.
	   * @param {Response=} response A Response object (optional) which will be populated
	   *   if the axis is not a separating axis.
	   * @return {boolean} true if it is a separating axis, false otherwise.  If false,
	   *   and a response is passed in, information about how much overlap and
	   *   the direction of the overlap will be populated.
	   */
	  function isSeparatingAxis(aPos, bPos, aPoints, bPoints, axis, response) {
	    var rangeA = T_ARRAYS.pop();
	    var rangeB = T_ARRAYS.pop();
	    // The magnitude of the offset between the two polygons
	    var offsetV = T_VECTORS.pop().copy(bPos).sub(aPos);
	    var projectedOffset = offsetV.dot(axis);
	    // Project the polygons onto the axis.
	    flattenPointsOn(aPoints, axis, rangeA);
	    flattenPointsOn(bPoints, axis, rangeB);
	    // Move B's range to its position relative to A.
	    rangeB[0] += projectedOffset;
	    rangeB[1] += projectedOffset;
	    // Check if there is a gap. If there is, this is a separating axis and we can stop
	    if (rangeA[0] > rangeB[1] || rangeB[0] > rangeA[1]) {
	      T_VECTORS.push(offsetV); 
	      T_ARRAYS.push(rangeA); 
	      T_ARRAYS.push(rangeB);
	      return true;
	    }
	    // This is not a separating axis. If we're calculating a response, calculate the overlap.
	    if (response) {
	      var overlap = 0;
	      // A starts further left than B
	      if (rangeA[0] < rangeB[0]) {
	        response['aInB'] = false;
	        // A ends before B does. We have to pull A out of B
	        if (rangeA[1] < rangeB[1]) { 
	          overlap = rangeA[1] - rangeB[0];
	          response['bInA'] = false;
	        // B is fully inside A.  Pick the shortest way out.
	        } else {
	          var option1 = rangeA[1] - rangeB[0];
	          var option2 = rangeB[1] - rangeA[0];
	          overlap = option1 < option2 ? option1 : -option2;
	        }
	      // B starts further left than A
	      } else {
	        response['bInA'] = false;
	        // B ends before A ends. We have to push A out of B
	        if (rangeA[1] > rangeB[1]) { 
	          overlap = rangeA[0] - rangeB[1];
	          response['aInB'] = false;
	        // A is fully inside B.  Pick the shortest way out.
	        } else {
	          var option1 = rangeA[1] - rangeB[0];
	          var option2 = rangeB[1] - rangeA[0];
	          overlap = option1 < option2 ? option1 : -option2;
	        }
	      }
	      // If this is the smallest amount of overlap we've seen so far, set it as the minimum overlap.
	      var absOverlap = Math.abs(overlap);
	      if (absOverlap < response['overlap']) {
	        response['overlap'] = absOverlap;
	        response['overlapN'].copy(axis);
	        if (overlap < 0) {
	          response['overlapN'].reverse();
	        }
	      }      
	    }
	    T_VECTORS.push(offsetV); 
	    T_ARRAYS.push(rangeA); 
	    T_ARRAYS.push(rangeB);
	    return false;
	  }
	  
	  // Calculates which Vornoi region a point is on a line segment.
	  // It is assumed that both the line and the point are relative to `(0,0)`
	  //
	  //            |       (0)      |
	  //     (-1)  [S]--------------[E]  (1)
	  //            |       (0)      |
	  /**
	   * @param {Vector} line The line segment.
	   * @param {Vector} point The point.
	   * @return  {number} LEFT_VORNOI_REGION (-1) if it is the left region, 
	   *          MIDDLE_VORNOI_REGION (0) if it is the middle region, 
	   *          RIGHT_VORNOI_REGION (1) if it is the right region.
	   */
	  function vornoiRegion(line, point) {
	    var len2 = line.len2();
	    var dp = point.dot(line);
	    // If the point is beyond the start of the line, it is in the
	    // left vornoi region.
	    if (dp < 0) { return LEFT_VORNOI_REGION; }
	    // If the point is beyond the end of the line, it is in the
	    // right vornoi region.
	    else if (dp > len2) { return RIGHT_VORNOI_REGION; }
	    // Otherwise, it's in the middle one.
	    else { return MIDDLE_VORNOI_REGION; }
	  }
	  // Constants for Vornoi regions
	  /**
	   * @const
	   */
	  var LEFT_VORNOI_REGION = -1;
	  /**
	   * @const
	   */
	  var MIDDLE_VORNOI_REGION = 0;
	  /**
	   * @const
	   */
	  var RIGHT_VORNOI_REGION = 1;
	  
	  // ## Collision Tests
	
	  // Check if a point is inside a circle.
	  /**
	   * @param {Vector} p The point to test.
	   * @param {Circle} c The circle to test.
	   * @return {boolean} true if the point is inside the circle, false if it is not.
	   */
	  function pointInCircle(p, c) {
	    var differenceV = T_VECTORS.pop().copy(p).sub(c['pos']);
	    var radiusSq = c['r'] * c['r'];
	    var distanceSq = differenceV.len2();
	    T_VECTORS.push(differenceV);
	    // If the distance between is smaller than the radius then the point is inside the circle.
	    return distanceSq <= radiusSq;
	  }
	  SAT['pointInCircle'] = pointInCircle;
	
	  // Check if a point is inside a convex polygon.
	  /**
	   * @param {Vector} p The point to test.
	   * @param {Polygon} poly The polygon to test.
	   * @return {boolean} true if the point is inside the polygon, false if it is not.
	   */
	  function pointInPolygon(p, poly) {
	    UNIT_SQUARE['pos'].copy(p);
	    T_RESPONSE.clear();
	    var result = testPolygonPolygon(UNIT_SQUARE, poly, T_RESPONSE);
	    if (result) {
	      result = T_RESPONSE['aInB'];
	    }
	    return result;
	  }
	  SAT['pointInPolygon'] = pointInPolygon;
	
	  // Check if two circles collide.
	  /**
	   * @param {Circle} a The first circle.
	   * @param {Circle} b The second circle.
	   * @param {Response=} response Response object (optional) that will be populated if
	   *   the circles intersect.
	   * @return {boolean} true if the circles intersect, false if they don't. 
	   */
	  function testCircleCircle(a, b, response) {
	    // Check if the distance between the centers of the two
	    // circles is greater than their combined radius.
	    var differenceV = T_VECTORS.pop().copy(b['pos']).sub(a['pos']);
	    var totalRadius = a['r'] + b['r'];
	    var totalRadiusSq = totalRadius * totalRadius;
	    var distanceSq = differenceV.len2();
	    // If the distance is bigger than the combined radius, they don't intersect.
	    if (distanceSq > totalRadiusSq) {
	      T_VECTORS.push(differenceV);
	      return false;
	    }
	    // They intersect.  If we're calculating a response, calculate the overlap.
	    if (response) { 
	      var dist = Math.sqrt(distanceSq);
	      response['a'] = a;
	      response['b'] = b;
	      response['overlap'] = totalRadius - dist;
	      response['overlapN'].copy(differenceV.normalize());
	      response['overlapV'].copy(differenceV).scale(response['overlap']);
	      response['aInB']= a['r'] <= b['r'] && dist <= b['r'] - a['r'];
	      response['bInA'] = b['r'] <= a['r'] && dist <= a['r'] - b['r'];
	    }
	    T_VECTORS.push(differenceV);
	    return true;
	  }
	  SAT['testCircleCircle'] = testCircleCircle;
	  
	  // Check if a polygon and a circle collide.
	  /**
	   * @param {Polygon} polygon The polygon.
	   * @param {Circle} circle The circle.
	   * @param {Response=} response Response object (optional) that will be populated if
	   *   they interset.
	   * @return {boolean} true if they intersect, false if they don't.
	   */
	  function testPolygonCircle(polygon, circle, response) {
	    // Get the position of the circle relative to the polygon.
	    var circlePos = T_VECTORS.pop().copy(circle['pos']).sub(polygon['pos']);
	    var radius = circle['r'];
	    var radius2 = radius * radius;
	    var points = polygon['calcPoints'];
	    var len = points.length;
	    var edge = T_VECTORS.pop();
	    var point = T_VECTORS.pop();
	    
	    // For each edge in the polygon:
	    for (var i = 0; i < len; i++) {
	      var next = i === len - 1 ? 0 : i + 1;
	      var prev = i === 0 ? len - 1 : i - 1;
	      var overlap = 0;
	      var overlapN = null;
	      
	      // Get the edge.
	      edge.copy(polygon['edges'][i]);
	      // Calculate the center of the circle relative to the starting point of the edge.
	      point.copy(circlePos).sub(points[i]);
	      
	      // If the distance between the center of the circle and the point
	      // is bigger than the radius, the polygon is definitely not fully in
	      // the circle.
	      if (response && point.len2() > radius2) {
	        response['aInB'] = false;
	      }
	      
	      // Calculate which Vornoi region the center of the circle is in.
	      var region = vornoiRegion(edge, point);
	      // If it's the left region:
	      if (region === LEFT_VORNOI_REGION) { 
	        // We need to make sure we're in the RIGHT_VORNOI_REGION of the previous edge.
	        edge.copy(polygon['edges'][prev]);
	        // Calculate the center of the circle relative the starting point of the previous edge
	        var point2 = T_VECTORS.pop().copy(circlePos).sub(points[prev]);
	        region = vornoiRegion(edge, point2);
	        if (region === RIGHT_VORNOI_REGION) {
	          // It's in the region we want.  Check if the circle intersects the point.
	          var dist = point.len();
	          if (dist > radius) {
	            // No intersection
	            T_VECTORS.push(circlePos); 
	            T_VECTORS.push(edge);
	            T_VECTORS.push(point); 
	            T_VECTORS.push(point2);
	            return false;
	          } else if (response) {
	            // It intersects, calculate the overlap.
	            response['bInA'] = false;
	            overlapN = point.normalize();
	            overlap = radius - dist;
	          }
	        }
	        T_VECTORS.push(point2);
	      // If it's the right region:
	      } else if (region === RIGHT_VORNOI_REGION) {
	        // We need to make sure we're in the left region on the next edge
	        edge.copy(polygon['edges'][next]);
	        // Calculate the center of the circle relative to the starting point of the next edge.
	        point.copy(circlePos).sub(points[next]);
	        region = vornoiRegion(edge, point);
	        if (region === LEFT_VORNOI_REGION) {
	          // It's in the region we want.  Check if the circle intersects the point.
	          var dist = point.len();
	          if (dist > radius) {
	            // No intersection
	            T_VECTORS.push(circlePos); 
	            T_VECTORS.push(edge); 
	            T_VECTORS.push(point);
	            return false;              
	          } else if (response) {
	            // It intersects, calculate the overlap.
	            response['bInA'] = false;
	            overlapN = point.normalize();
	            overlap = radius - dist;
	          }
	        }
	      // Otherwise, it's the middle region:
	      } else {
	        // Need to check if the circle is intersecting the edge,
	        // Change the edge into its "edge normal".
	        var normal = edge.perp().normalize();
	        // Find the perpendicular distance between the center of the 
	        // circle and the edge.
	        var dist = point.dot(normal);
	        var distAbs = Math.abs(dist);
	        // If the circle is on the outside of the edge, there is no intersection.
	        if (dist > 0 && distAbs > radius) {
	          // No intersection
	          T_VECTORS.push(circlePos); 
	          T_VECTORS.push(normal); 
	          T_VECTORS.push(point);
	          return false;
	        } else if (response) {
	          // It intersects, calculate the overlap.
	          overlapN = normal;
	          overlap = radius - dist;
	          // If the center of the circle is on the outside of the edge, or part of the
	          // circle is on the outside, the circle is not fully inside the polygon.
	          if (dist >= 0 || overlap < 2 * radius) {
	            response['bInA'] = false;
	          }
	        }
	      }
	      
	      // If this is the smallest overlap we've seen, keep it. 
	      // (overlapN may be null if the circle was in the wrong Vornoi region).
	      if (overlapN && response && Math.abs(overlap) < Math.abs(response['overlap'])) {
	        response['overlap'] = overlap;
	        response['overlapN'].copy(overlapN);
	      }
	    }
	    
	    // Calculate the final overlap vector - based on the smallest overlap.
	    if (response) {
	      response['a'] = polygon;
	      response['b'] = circle;
	      response['overlapV'].copy(response['overlapN']).scale(response['overlap']);
	    }
	    T_VECTORS.push(circlePos); 
	    T_VECTORS.push(edge); 
	    T_VECTORS.push(point);
	    return true;
	  }
	  SAT['testPolygonCircle'] = testPolygonCircle;
	  
	  // Check if a circle and a polygon collide.
	  //
	  // **NOTE:** This is slightly less efficient than polygonCircle as it just
	  // runs polygonCircle and reverses everything at the end.
	  /**
	   * @param {Circle} circle The circle.
	   * @param {Polygon} polygon The polygon.
	   * @param {Response=} response Response object (optional) that will be populated if
	   *   they interset.
	   * @return {boolean} true if they intersect, false if they don't.
	   */
	  function testCirclePolygon(circle, polygon, response) {
	    // Test the polygon against the circle.
	    var result = testPolygonCircle(polygon, circle, response);
	    if (result && response) {
	      // Swap A and B in the response.
	      var a = response['a'];
	      var aInB = response['aInB'];
	      response['overlapN'].reverse();
	      response['overlapV'].reverse();
	      response['a'] = response['b'];
	      response['b'] = a;
	      response['aInB'] = response['bInA'];
	      response['bInA'] = aInB;
	    }
	    return result;
	  }
	  SAT['testCirclePolygon'] = testCirclePolygon;
	  
	  // Checks whether polygons collide.
	  /**
	   * @param {Polygon} a The first polygon.
	   * @param {Polygon} b The second polygon.
	   * @param {Response=} response Response object (optional) that will be populated if
	   *   they interset.
	   * @return {boolean} true if they intersect, false if they don't.
	   */
	  function testPolygonPolygon(a, b, response) {
	    var aPoints = a['calcPoints'];
	    var aLen = aPoints.length;
	    var bPoints = b['calcPoints'];
	    var bLen = bPoints.length;
	    // If any of the edge normals of A is a separating axis, no intersection.
	    for (var i = 0; i < aLen; i++) {
	      if (isSeparatingAxis(a['pos'], b['pos'], aPoints, bPoints, a['normals'][i], response)) {
	        return false;
	      }
	    }
	    // If any of the edge normals of B is a separating axis, no intersection.
	    for (var i = 0;i < bLen; i++) {
	      if (isSeparatingAxis(a['pos'], b['pos'], aPoints, bPoints, b['normals'][i], response)) {
	        return false;
	      }
	    }
	    // Since none of the edge normals of A or B are a separating axis, there is an intersection
	    // and we've already calculated the smallest overlap (in isSeparatingAxis).  Calculate the
	    // final overlap vector.
	    if (response) {
	      response['a'] = a;
	      response['b'] = b;
	      response['overlapV'].copy(response['overlapN']).scale(response['overlap']);
	    }
	    return true;
	  }
	  SAT['testPolygonPolygon'] = testPolygonPolygon;
	
	  return SAT;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(429)(module)))

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _customLodash = __webpack_require__(352);
	
	var _customLodash2 = _interopRequireDefault(_customLodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventEmitter = function () {
	    function EventEmitter() {
	        _classCallCheck(this, EventEmitter);
	
	        this.listeners = {};
	    }
	
	    EventEmitter.prototype.on = function on(name, listener) {
	        if (!this.listeners[name]) {
	            this.listeners[name] = [];
	        }
	
	        this.listeners[name].push(listener);
	    };
	
	    EventEmitter.prototype.off = function off(name, listener) {
	        if (!this.listeners[name]) {
	            return;
	        }
	
	        _customLodash2.default.remove(this.listeners[name], listener);
	    };
	
	    EventEmitter.prototype.emit = function emit(name) {
	        var _this = this;
	
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            args[_key - 1] = arguments[_key];
	        }
	
	        if (!this.listeners[name]) {
	            return;
	        }
	
	        this.listeners[name].forEach(function (l) {
	            return l.apply(_this, args);
	        });
	    };
	
	    return EventEmitter;
	}();
	
	exports.default = EventEmitter;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Core = __webpack_require__(334);
	
	var _Core2 = _interopRequireDefault(_Core);
	
	__webpack_require__(522);
	
	var _fontIcons = __webpack_require__(523);
	
	var _fontIcons2 = _interopRequireDefault(_fontIcons);
	
	var _customLodash = __webpack_require__(352);
	
	var _customLodash2 = _interopRequireDefault(_customLodash);
	
	var _helper = __webpack_require__(517);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _designControl = __webpack_require__(524);
	
	var _designControl2 = _interopRequireDefault(_designControl);
	
	var _designDescription = __webpack_require__(527);
	
	var _designDescription2 = _interopRequireDefault(_designDescription);
	
	var _placingComponent = __webpack_require__(526);
	
	var _placingComponent2 = _interopRequireDefault(_placingComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Design = function (_PlacingComponent) {
	    _inherits(Design, _PlacingComponent);
	
	    function Design(design, imageObj) {
	        var editable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	        _classCallCheck(this, Design);
	
	        var _this = _possibleConstructorReturn(this, _PlacingComponent.call(this));
	
	        _this.isSelected = false;
	        _this.data = design;
	        _this.imageObj = imageObj;
	        _this.componentSize = 20;
	        _this.controls = [];
	        _this.labels = [];
	        _this.resizable = !!design.resizable;
	        _this.content = new _placingComponent2.default();
	        _this.addKonvaComponent(_this.content);
	        _this.setImage(imageObj, design.width, design.height);
	
	        if (editable) {
	            _this.addControls();
	        } else if (design.id !== undefined) {
	            _this.addLabel(design.id.toString(), 4);
	        }
	        return _this;
	    }
	
	    Design.prototype.setImage = function setImage(imageObj, width, height) {
	        this.design = new _Core2.default.Image({
	            image: imageObj,
	            x: this.componentSize,
	            y: this.componentSize
	        });
	        this.content.addKonvaNode(this.design);
	
	        if (_customLodash2.default.isUndefined(width) && !_customLodash2.default.isUndefined(height)) {
	            width = height * (imageObj.naturalWidth / imageObj.naturalHeight);
	        } else if (!_customLodash2.default.isUndefined(width) && _customLodash2.default.isUndefined(height)) {
	            height = width * (imageObj.naturalHeight / imageObj.naturalWidth);
	        } else if (_customLodash2.default.isUndefined(width) && _customLodash2.default.isUndefined(height)) {
	            var currentWidth = this.getDesignSize().width;
	            var currentHeight = this.getDesignSize().height;
	            var factor = currentHeight / 50;
	            height = 50;
	            width = currentWidth / factor;
	        }
	
	        this.setDesignSize({ width: width, height: height });
	    };
	
	    Design.prototype.addControls = function addControls() {
	        var rotateCtrl = new _designControl2.default(this.componentSize, _fontIcons2.default.rotate, 1);
	        this._resizeCtrl = new _designControl2.default(this.componentSize, _fontIcons2.default.expand, 2);
	        var deleteCtrl = new _designControl2.default(this.componentSize, _fontIcons2.default.trash, 3);
	        var instructionCtrl = new _designControl2.default(this.componentSize, _fontIcons2.default.instruction, 4);
	        this.addControlEvent(rotateCtrl, 'rotate');
	        this.addControlEvent(deleteCtrl, 'delete');
	        this.addControlEvent(instructionCtrl, 'instruction');
	        this.addComponent(rotateCtrl, 'control');
	        this.addComponent(deleteCtrl, 'control');
	        this.addComponent(instructionCtrl, 'control');
	        this.addControlEvent(this._resizeCtrl, 'resize');
	        this.addComponent(this._resizeCtrl, 'control');
	    };
	
	    Design.prototype.addLabel = function addLabel(text, placement) {
	        var label = new _designDescription2.default(placement, '#dc574e', '#fff');
	        label.setText(text);
	        this.addComponent(label, 'label');
	    };
	
	    Design.prototype.addControlEvent = function addControlEvent(control, eventName) {
	        var _this2 = this;
	
	        control.events.on('mousedown', function (evt) {
	            evt.cancelBubble = true;
	            _this2.events.emit(eventName, { x: evt.evt.layerX, y: evt.evt.layerY });
	        });
	    };
	
	    Design.prototype.addComponent = function addComponent(component, type) {
	        this[type + 's'].push(component);
	        this.content.addKonvaComponent(component);
	        this.placeComponent(component);
	        var isVisible = type === 'label';
	        component.setVisible(isVisible);
	    };
	
	    Design.prototype.placeComponent = function placeComponent(component) {
	        var designSize = this.getDesignSize();
	        var position = { x: 0, y: 0 };
	        var right = designSize.width + this.componentSize;
	        var bottom = designSize.height + this.componentSize;
	        var centerX = designSize.width / 2;
	        var centerY = designSize.height / 2;
	
	        switch (component.placement) {
	            case 2:
	                position.x = right;
	                break;
	            case 3:
	                position.y = bottom;
	                break;
	            case 4:
	                position.x = right;
	                position.y = bottom;
	                break;
	            case 5:
	                position.x = centerX;
	                position.y = centerY;
	        }
	        component.setPos(position);
	    };
	
	    Design.prototype.setStroke = function setStroke() {
	        if (this.isSelected) {
	            this.design.stroke('#eaeaea');
	        } else {
	            this.design.stroke(null);
	        }
	    };
	
	    Design.prototype.getDesignOffset = function getDesignOffset() {
	        return this.design.getPosition();
	    };
	
	    Design.prototype.getDesignLayerPos = function getDesignLayerPos() {
	        var localDesignPos = this.design.getPosition();
	        var position = this.getPos();
	
	        return {
	            x: position.x + localDesignPos.x,
	            y: position.y + localDesignPos.y
	        };
	    };
	
	    Design.prototype.setDesignLayerPos = function setDesignLayerPos(_ref) {
	        var x = _ref.x,
	            y = _ref.y;
	
	        if (!_customLodash2.default.isUndefined(x)) {
	            this.setPos({ x: x - this.design.getPosition().x });
	        }
	        if (!_customLodash2.default.isUndefined(y)) {
	            this.setPos({ y: y - this.design.getPosition().y });
	        }
	    };
	
	    Design.prototype.getDesignCenterLayerPos = function getDesignCenterLayerPos() {
	        var pos = this.getDesignLayerPos();
	        var size = this.getDesignSize();
	        return {
	            x: pos.x + size.width / 2,
	            y: pos.y + size.height / 2
	        };
	    };
	
	    Design.prototype.getDesignSize = function getDesignSize() {
	        return {
	            width: this.design.getWidth(),
	            height: this.design.getHeight()
	        };
	    };
	
	    Design.prototype.setDesignSize = function setDesignSize(_ref2) {
	        var _this3 = this;
	
	        var width = _ref2.width,
	            height = _ref2.height;
	
	        if (!_customLodash2.default.isUndefined(width)) {
	            this.design.setWidth(width);
	        }
	        if (!_customLodash2.default.isUndefined(height)) {
	            this.design.setHeight(height);
	        }
	
	        // Use new size for content and components.
	        var contentOffset = {
	            x: this.design.x() + this.getDesignSize().width / 2,
	            y: this.design.y() + this.getDesignSize().height / 2
	        };
	        this.content.setOffset(contentOffset);
	        this.content.setPos({ x: contentOffset.x, y: contentOffset.y });
	        this.controls.forEach(function (c) {
	            return _this3.placeComponent(c);
	        });
	        this.labels.forEach(function (l) {
	            return _this3.placeComponent(l);
	        });
	    };
	
	    Design.prototype.setDesignRotation = function setDesignRotation(rotation) {
	        this.content.setRotation(rotation);
	    };
	
	    Design.prototype.getDesignRotation = function getDesignRotation() {
	        return this.content.getRotation();
	    };
	
	    Design.prototype.getDesignCorners = function getDesignCorners() {
	        return _helper2.default.getCorners(this.design);
	    };
	
	    Design.prototype.setInstruction = function setInstruction(instruction) {
	        this.data.instruction = instruction;
	    };
	
	    Design.prototype.getInstruction = function getInstruction() {
	        return this.data.instruction || '';
	    };
	
	    Design.prototype.setReference = function setReference(reference) {
	        this.data.reference = reference;
	    };
	
	    Design.prototype.getReference = function getReference() {
	        return this.data.reference || '';
	    };
	
	    Design.prototype.select = function select() {
	        this.isSelected = true;
	        this.controls.forEach(function (c) {
	            return c.setVisible(true);
	        });
	        if (!this.resizable) {
	            this._resizeCtrl.setVisible(false);
	        }
	        this.setStroke();
	    };
	
	    Design.prototype.deselect = function deselect() {
	        this.isSelected = false;
	        this.controls.forEach(function (c) {
	            return c.setVisible(false);
	        });
	        this.setStroke();
	        this.drawParentLayer();
	    };
	
	    Design.prototype.onMouseDown = function onMouseDown(evt) {
	        evt.cancelBubble = true;
	        this.select();
	        this.events.emit('select', { x: evt.evt.layerX, y: evt.evt.layerY });
	    };
	
	    return Design;
	}(_placingComponent2.default);
	
	exports.default = Design;

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';
	  // CONSTANTS
	  var IMAGE = 'Image';
	
	  /**
	     * Image constructor
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {Image} config.image
	     * @param {Object} [config.crop]
	     * @@shapeParams
	     * @@nodeParams
	     * @example
	     * var imageObj = new Image();
	     * imageObj.onload = function() {
	     *   var image = new Konva.Image({
	     *     x: 200,
	     *     y: 50,
	     *     image: imageObj,
	     *     width: 100,
	     *     height: 100
	     *   });
	     * };
	     * imageObj.src = '/path/to/image.jpg'
	     */
	  Konva.Image = function(config) {
	    this.___init(config);
	  };
	
	  Konva.Image.prototype = {
	    ___init: function(config) {
	      // call super constructor
	      Konva.Shape.call(this, config);
	      this.className = IMAGE;
	      this.sceneFunc(this._sceneFunc);
	      this.hitFunc(this._hitFunc);
	    },
	    _useBufferCanvas: function() {
	      return (
	        (this.hasShadow() || this.getAbsoluteOpacity() !== 1) &&
	        this.hasStroke() &&
	        this.getStage()
	      );
	    },
	    _sceneFunc: function(context) {
	      var width = this.getWidth(),
	        height = this.getHeight(),
	        image = this.getImage(),
	        cropWidth,
	        cropHeight,
	        params;
	
	      if (image) {
	        cropWidth = this.getCropWidth();
	        cropHeight = this.getCropHeight();
	        if (cropWidth && cropHeight) {
	          params = [
	            image,
	            this.getCropX(),
	            this.getCropY(),
	            cropWidth,
	            cropHeight,
	            0,
	            0,
	            width,
	            height
	          ];
	        } else {
	          params = [image, 0, 0, width, height];
	        }
	      }
	
	      if (this.hasFill() || this.hasStroke()) {
	        context.beginPath();
	        context.rect(0, 0, width, height);
	        context.closePath();
	        context.fillStrokeShape(this);
	      }
	
	      if (image) {
	        context.drawImage.apply(context, params);
	      }
	    },
	    _hitFunc: function(context) {
	      var width = this.getWidth(), height = this.getHeight();
	
	      context.beginPath();
	      context.rect(0, 0, width, height);
	      context.closePath();
	      context.fillStrokeShape(this);
	    },
	    getWidth: function() {
	      var image = this.getImage();
	      return this.attrs.width || (image ? image.width : 0);
	    },
	    getHeight: function() {
	      var image = this.getImage();
	      return this.attrs.height || (image ? image.height : 0);
	    }
	  };
	  Konva.Util.extend(Konva.Image, Konva.Shape);
	
	  // add getters setters
	  Konva.Factory.addGetterSetter(Konva.Image, 'image');
	
	  /**
	     * set image
	     * @name setImage
	     * @method
	     * @memberof Konva.Image.prototype
	     * @param {Image} image
	     */
	
	  /**
	     * get image
	     * @name getImage
	     * @method
	     * @memberof Konva.Image.prototype
	     * @returns {Image}
	     */
	
	  Konva.Factory.addComponentsGetterSetter(Konva.Image, 'crop', [
	    'x',
	    'y',
	    'width',
	    'height'
	  ]);
	  /**
	     * get/set crop
	     * @method
	     * @name crop
	     * @memberof Konva.Image.prototype
	     * @param {Object} crop
	     * @param {Number} crop.x
	     * @param {Number} crop.y
	     * @param {Number} crop.width
	     * @param {Number} crop.height
	     * @returns {Object}
	     * @example
	     * // get crop
	     * var crop = image.crop();
	     *
	     * // set crop
	     * image.crop({
	     *   x: 20,
	     *   y: 20,
	     *   width: 20,
	     *   height: 20
	     * });
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Image, 'cropX', 0);
	  /**
	     * get/set crop x
	     * @method
	     * @name cropX
	     * @memberof Konva.Image.prototype
	     * @param {Number} x
	     * @returns {Number}
	     * @example
	     * // get crop x
	     * var cropX = image.cropX();
	     *
	     * // set crop x
	     * image.cropX(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Image, 'cropY', 0);
	  /**
	     * get/set crop y
	     * @name cropY
	     * @method
	     * @memberof Konva.Image.prototype
	     * @param {Number} y
	     * @returns {Number}
	     * @example
	     * // get crop y
	     * var cropY = image.cropY();
	     *
	     * // set crop y
	     * image.cropY(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Image, 'cropWidth', 0);
	  /**
	     * get/set crop width
	     * @name cropWidth
	     * @method
	     * @memberof Konva.Image.prototype
	     * @param {Number} width
	     * @returns {Number}
	     * @example
	     * // get crop width
	     * var cropWidth = image.cropWidth();
	     *
	     * // set crop width
	     * image.cropWidth(20);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Image, 'cropHeight', 0);
	  /**
	     * get/set crop height
	     * @name cropHeight
	     * @method
	     * @memberof Konva.Image.prototype
	     * @param {Number} height
	     * @returns {Number}
	     * @example
	     * // get crop height
	     * var cropHeight = image.cropHeight();
	     *
	     * // set crop height
	     * image.cropHeight(20);
	     */
	
	  Konva.Collection.mapMethods(Konva.Image);
	
	  /**
	     * load image from given url and create `Konva.Image` instance
	     * @method
	     * @memberof Konva.Image
	     * @param {String} url image source
	     * @param {Function} callback with Konva.Image instance as first argument
	     * @example
	     *  Konva.Image.fromURL(imageURL, function(image){
	     *    // image is Konva.Image instance
	     *    layer.add(image);
	     *    layer.draw();
	     *  });
	     */
	  Konva.Image.fromURL = function(url, callback) {
	    var img = new Image();
	    img.onload = function() {
	      var image = new Konva.Image({
	        image: img
	      });
	      callback(image);
	    };
	    img.src = url;
	  };
	})();


/***/ }),
/* 523 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var fontIcons = {
	    'check': '\uF00C',
	    'arrows': '\uF047',
	    'trash': '\uF1F8',
	    'rotate': '\uF01E',
	    'expand': '\uF065',
	    'instruction': '\uF040'
	};
	
	exports.default = fontIcons;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Core = __webpack_require__(334);
	
	var _Core2 = _interopRequireDefault(_Core);
	
	__webpack_require__(349);
	
	__webpack_require__(525);
	
	var _placingComponent = __webpack_require__(526);
	
	var _placingComponent2 = _interopRequireDefault(_placingComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var DesignControl = function (_PlacingComponent) {
	    _inherits(DesignControl, _PlacingComponent);
	
	    function DesignControl(componentSize, text, placement) {
	        _classCallCheck(this, DesignControl);
	
	        var _this = _possibleConstructorReturn(this, _PlacingComponent.call(this));
	
	        var controlPadding = 3;
	        _this.placement = placement;
	        _this.controlBg = new _Core2.default.Rect({
	            width: componentSize,
	            height: componentSize,
	            fill: '#eaeaea'
	        });
	
	        _this.controlText = new _Core2.default.Text({
	            width: componentSize,
	            height: componentSize,
	            padding: controlPadding,
	            lineHeight: componentSize,
	            text: text,
	            fontSize: componentSize - controlPadding * 2,
	            fontFamily: 'FontAwesome',
	            fill: 'black'
	        });
	
	        _this.addKonvaNode(_this.controlBg);
	        _this.addKonvaNode(_this.controlText);
	        return _this;
	    }
	
	    return DesignControl;
	}(_placingComponent2.default);
	
	exports.default = DesignControl;

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	/*eslint-disable max-depth */
	(function() {
	  'use strict';
	  // var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
	  // constants
	  var AUTO = 'auto',
	    //CANVAS = 'canvas',
	    CENTER = 'center',
	    JUSTIFY = 'justify',
	    CHANGE_KONVA = 'Change.konva',
	    CONTEXT_2D = '2d',
	    DASH = '-',
	    EMPTY_STRING = '',
	    LEFT = 'left',
	    TEXT = 'text',
	    TEXT_UPPER = 'Text',
	    MIDDLE = 'middle',
	    NORMAL = 'normal',
	    PX_SPACE = 'px ',
	    SPACE = ' ',
	    RIGHT = 'right',
	    WORD = 'word',
	    CHAR = 'char',
	    NONE = 'none',
	    ATTR_CHANGE_LIST = [
	      'fontFamily',
	      'fontSize',
	      'fontStyle',
	      'fontVariant',
	      'padding',
	      'align',
	      'lineHeight',
	      'text',
	      'width',
	      'height',
	      'wrap',
	      'letterSpacing'
	    ],
	    // cached variables
	    attrChangeListLen = ATTR_CHANGE_LIST.length;
	  var dummyContext;
	  function getDummyContext() {
	    if (dummyContext) {
	      return dummyContext;
	    }
	    dummyContext = Konva.Util.createCanvasElement().getContext(CONTEXT_2D);
	    return dummyContext;
	  }
	
	  /**
	     * Text constructor
	     * @constructor
	     * @memberof Konva
	     * @augments Konva.Shape
	     * @param {Object} config
	     * @param {String} [config.fontFamily] default is Arial
	     * @param {Number} [config.fontSize] in pixels.  Default is 12
	     * @param {String} [config.fontStyle] can be normal, bold, or italic.  Default is normal
	     * @param {String} [config.fontVariant] can be normal or small-caps.  Default is normal
	     * @param {String} config.text
	     * @param {String} [config.align] can be left, center, or right
	     * @param {Number} [config.padding]
	     * @param {Number} [config.lineHeight] default is 1
	     * @param {String} [config.wrap] can be word, char, or none. Default is word
	     * @@shapeParams
	     * @@nodeParams
	     * @example
	     * var text = new Konva.Text({
	     *   x: 10,
	     *   y: 15,
	     *   text: 'Simple Text',
	     *   fontSize: 30,
	     *   fontFamily: 'Calibri',
	     *   fill: 'green'
	     * });
	     */
	  Konva.Text = function(config) {
	    this.___init(config);
	  };
	  function _fillFunc(context) {
	    context.fillText(this.partialText, 0, 0);
	  }
	  function _strokeFunc(context) {
	    context.strokeText(this.partialText, 0, 0);
	  }
	
	  Konva.Text.prototype = {
	    ___init: function(config) {
	      config = config || {};
	
	      // set default color to black
	      if (
	        !config.fillLinearGradientColorStops &&
	        !config.fillRadialGradientColorStops
	      ) {
	        config.fill = config.fill || 'black';
	      }
	      //
	      // if (config.width === undefined) {
	      //     config.width = AUTO;
	      // }
	      // if (config.height === undefined) {
	      //     config.height = AUTO;
	      // }
	
	      // call super constructor
	      Konva.Shape.call(this, config);
	
	      this._fillFunc = _fillFunc;
	      this._strokeFunc = _strokeFunc;
	      this.className = TEXT_UPPER;
	
	      // update text data for certain attr changes
	      for (var n = 0; n < attrChangeListLen; n++) {
	        this.on(ATTR_CHANGE_LIST[n] + CHANGE_KONVA, this._setTextData);
	      }
	
	      this._setTextData();
	      this.sceneFunc(this._sceneFunc);
	      this.hitFunc(this._hitFunc);
	    },
	    _sceneFunc: function(context) {
	      var p = this.getPadding(),
	        textHeight = this.getTextHeight(),
	        lineHeightPx = this.getLineHeight() * textHeight,
	        textArr = this.textArr,
	        textArrLen = textArr.length,
	        align = this.getAlign(),
	        totalWidth = this.getWidth(),
	        letterSpacing = this.getLetterSpacing(),
	        textDecoration = this.textDecoration(),
	        fill = this.fill(),
	        fontSize = this.fontSize(),
	        n;
	
	      context.setAttr('font', this._getContextFont());
	
	      context.setAttr('textBaseline', MIDDLE);
	      context.setAttr('textAlign', LEFT);
	      context.save();
	      if (p) {
	        context.translate(p, 0);
	        context.translate(0, p + textHeight / 2);
	      } else {
	        context.translate(0, textHeight / 2);
	      }
	
	      // draw text lines
	      for (n = 0; n < textArrLen; n++) {
	        var obj = textArr[n],
	          text = obj.text,
	          width = obj.width;
	
	        // horizontal alignment
	        context.save();
	        if (align === RIGHT) {
	          context.translate(totalWidth - width - p * 2, 0);
	        } else if (align === CENTER) {
	          context.translate((totalWidth - width - p * 2) / 2, 0);
	        }
	
	        if (textDecoration.indexOf('underline') !== -1) {
	          context.save();
	          context.beginPath();
	          context.moveTo(0, Math.round(lineHeightPx / 2));
	          context.lineTo(Math.round(width), Math.round(lineHeightPx / 2));
	          // TODO: I have no idea what is real ratio
	          // just /20 looks good enough
	          context.lineWidth = fontSize / 15;
	          context.strokeStyle = fill;
	          context.stroke();
	          context.restore();
	        }
	        if (textDecoration.indexOf('line-through') !== -1) {
	          context.save();
	          context.beginPath();
	          context.moveTo(0, 0);
	          context.lineTo(Math.round(width), 0);
	          context.lineWidth = fontSize / 15;
	          context.strokeStyle = fill;
	          context.stroke();
	          context.restore();
	        }
	        if (letterSpacing !== 0 || align === JUSTIFY) {
	          //   var words = text.split(' ');
	          var spacesNumber = text.split(' ').length - 1;
	          for (var li = 0; li < text.length; li++) {
	            var letter = text[li];
	            // skip justify for the last line
	            if (letter === ' ' && n !== textArrLen - 1 && align === JUSTIFY) {
	              context.translate(
	                Math.floor((totalWidth - width) / spacesNumber),
	                0
	              );
	            }
	            this.partialText = letter;
	            context.fillStrokeShape(this);
	            context.translate(
	              Math.round(this._getTextSize(letter).width) + letterSpacing,
	              0
	            );
	          }
	        } else {
	          this.partialText = text;
	
	          context.fillStrokeShape(this);
	        }
	        context.restore();
	        context.translate(0, lineHeightPx);
	      }
	      context.restore();
	    },
	    _hitFunc: function(context) {
	      var width = this.getWidth(),
	        height = this.getHeight();
	
	      context.beginPath();
	      context.rect(0, 0, width, height);
	      context.closePath();
	      context.fillStrokeShape(this);
	    },
	    // _useBufferCanvas: function(caching) {
	    //     var useIt = Konva.Shape.prototype._useBufferCanvas.call(this, caching);
	    //     if (useIt) {
	    //       return true;
	    //     }
	    //     return false;
	    //     // return isFirefox && this.hasFill() && this.hasShadow();
	    // },
	    setText: function(text) {
	      var str = Konva.Util._isString(text) ? text : (text || '').toString();
	      this._setAttr(TEXT, str);
	      return this;
	    },
	    /**
	         * get width of text area, which includes padding
	         * @method
	         * @memberof Konva.Text.prototype
	         * @returns {Number}
	         */
	    getWidth: function() {
	      var isAuto = this.attrs.width === AUTO || this.attrs.width === undefined;
	      return isAuto
	        ? this.getTextWidth() + this.getPadding() * 2
	        : this.attrs.width;
	    },
	    /**
	         * get the height of the text area, which takes into account multi-line text, line heights, and padding
	         * @method
	         * @memberof Konva.Text.prototype
	         * @returns {Number}
	         */
	    getHeight: function() {
	      var isAuto =
	        this.attrs.height === AUTO || this.attrs.height === undefined;
	      return isAuto
	        ? this.getTextHeight() * this.textArr.length * this.getLineHeight() +
	          this.getPadding() * 2
	        : this.attrs.height;
	    },
	    /**
	         * get text width
	         * @method
	         * @memberof Konva.Text.prototype
	         * @returns {Number}
	         */
	    getTextWidth: function() {
	      return this.textWidth;
	    },
	    /**
	         * get text height
	         * @method
	         * @memberof Konva.Text.prototype
	         * @returns {Number}
	         */
	    getTextHeight: function() {
	      return this.textHeight;
	    },
	    _getTextSize: function(text) {
	      var _context = getDummyContext(),
	        fontSize = this.getFontSize(),
	        metrics;
	
	      _context.save();
	      _context.font = this._getContextFont();
	
	      metrics = _context.measureText(text);
	      _context.restore();
	      return {
	        width: metrics.width,
	        height: parseInt(fontSize, 10)
	      };
	    },
	    _getContextFont: function() {
	      // IE don't want to work with usual font style
	      // bold was not working
	      // removing font variant will solve
	      // fix for: https://github.com/konvajs/konva/issues/94
	      if (Konva.UA.isIE) {
	        return (
	          this.getFontStyle() +
	          SPACE +
	          this.getFontSize() +
	          PX_SPACE +
	          this.getFontFamily()
	        );
	      }
	      return (
	        this.getFontStyle() +
	        SPACE +
	        this.getFontVariant() +
	        SPACE +
	        this.getFontSize() +
	        PX_SPACE +
	        this.getFontFamily()
	      );
	    },
	    _addTextLine: function(line) {
	      if (this.align() === JUSTIFY) {
	        line = line.trim();
	      }
	      var width = this._getTextWidth(line);
	      return this.textArr.push({ text: line, width: width });
	    },
	    _getTextWidth: function(text) {
	      var latterSpacing = this.getLetterSpacing();
	      var length = text.length;
	      return (
	        getDummyContext().measureText(text).width +
	        (length ? latterSpacing * (length - 1) : 0)
	      );
	    },
	    _setTextData: function() {
	      var lines = this.getText().split('\n'),
	        fontSize = +this.getFontSize(),
	        textWidth = 0,
	        lineHeightPx = this.getLineHeight() * fontSize,
	        width = this.attrs.width,
	        height = this.attrs.height,
	        fixedWidth = width !== AUTO,
	        fixedHeight = height !== AUTO,
	        padding = this.getPadding(),
	        maxWidth = width - padding * 2,
	        maxHeightPx = height - padding * 2,
	        currentHeightPx = 0,
	        wrap = this.getWrap(),
	        shouldWrap = wrap !== NONE,
	        wrapAtWord = wrap !== CHAR && shouldWrap;
	
	      this.textArr = [];
	      getDummyContext().save();
	      getDummyContext().font = this._getContextFont();
	      for (var i = 0, max = lines.length; i < max; ++i) {
	        var line = lines[i];
	
	        var lineWidth = this._getTextWidth(line);
	        if (fixedWidth && lineWidth > maxWidth) {
	          /*
	                     * if width is fixed and line does not fit entirely
	                     * break the line into multiple fitting lines
	                     */
	          while (line.length > 0) {
	            /*
	                         * use binary search to find the longest substring that
	                         * that would fit in the specified width
	                         */
	            var low = 0,
	              high = line.length,
	              match = '',
	              matchWidth = 0;
	            while (low < high) {
	              var mid = (low + high) >>> 1,
	                substr = line.slice(0, mid + 1),
	                substrWidth = this._getTextWidth(substr);
	              if (substrWidth <= maxWidth) {
	                low = mid + 1;
	                match = substr;
	                matchWidth = substrWidth;
	              } else {
	                high = mid;
	              }
	            }
	            /*
	                         * 'low' is now the index of the substring end
	                         * 'match' is the substring
	                         * 'matchWidth' is the substring width in px
	                         */
	            if (match) {
	              // a fitting substring was found
	              if (wrapAtWord) {
	                // try to find a space or dash where wrapping could be done
	                var wrapIndex =
	                  Math.max(match.lastIndexOf(SPACE), match.lastIndexOf(DASH)) +
	                  1;
	                if (wrapIndex > 0) {
	                  // re-cut the substring found at the space/dash position
	                  low = wrapIndex;
	                  match = match.slice(0, low);
	                  matchWidth = this._getTextWidth(match);
	                }
	              }
	              this._addTextLine(match);
	              textWidth = Math.max(textWidth, matchWidth);
	              currentHeightPx += lineHeightPx;
	              if (
	                !shouldWrap ||
	                (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx)
	              ) {
	                /*
	                                 * stop wrapping if wrapping is disabled or if adding
	                                 * one more line would overflow the fixed height
	                                 */
	                break;
	              }
	              line = line.slice(low);
	              if (line.length > 0) {
	                // Check if the remaining text would fit on one line
	                lineWidth = this._getTextWidth(line);
	                if (lineWidth <= maxWidth) {
	                  // if it does, add the line and break out of the loop
	                  this._addTextLine(line);
	                  currentHeightPx += lineHeightPx;
	                  textWidth = Math.max(textWidth, lineWidth);
	                  break;
	                }
	              }
	            } else {
	              // not even one character could fit in the element, abort
	              break;
	            }
	          }
	        } else {
	          // element width is automatically adjusted to max line width
	          this._addTextLine(line);
	          currentHeightPx += lineHeightPx;
	          textWidth = Math.max(textWidth, lineWidth);
	        }
	        // if element height is fixed, abort if adding one more line would overflow
	        if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) {
	          break;
	        }
	      }
	      getDummyContext().restore();
	      this.textHeight = fontSize;
	      // var maxTextWidth = 0;
	      // for(var j = 0; j < this.textArr.length; j++) {
	      //     maxTextWidth = Math.max(maxTextWidth, this.textArr[j].width);
	      // }
	      this.textWidth = textWidth;
	    }
	  };
	  Konva.Util.extend(Konva.Text, Konva.Shape);
	
	  // add getters setters
	  Konva.Factory.addGetterSetter(Konva.Text, 'fontFamily', 'Arial');
	
	  /**
	     * get/set font family
	     * @name fontFamily
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {String} fontFamily
	     * @returns {String}
	     * @example
	     * // get font family
	     * var fontFamily = text.fontFamily();
	     *
	     * // set font family
	     * text.fontFamily('Arial');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'fontSize', 12);
	
	  /**
	     * get/set font size in pixels
	     * @name fontSize
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {Number} fontSize
	     * @returns {Number}
	     * @example
	     * // get font size
	     * var fontSize = text.fontSize();
	     *
	     * // set font size to 22px
	     * text.fontSize(22);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'fontStyle', NORMAL);
	
	  /**
	     * set font style.  Can be 'normal', 'italic', or 'bold'.  'normal' is the default.
	     * @name fontStyle
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {String} fontStyle
	     * @returns {String}
	     * @example
	     * // get font style
	     * var fontStyle = text.fontStyle();
	     *
	     * // set font style
	     * text.fontStyle('bold');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'fontVariant', NORMAL);
	
	  /**
	     * set font variant.  Can be 'normal' or 'small-caps'.  'normal' is the default.
	     * @name fontVariant
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {String} fontVariant
	     * @returns {String}
	     * @example
	     * // get font variant
	     * var fontVariant = text.fontVariant();
	     *
	     * // set font variant
	     * text.fontVariant('small-caps');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'padding', 0);
	
	  /**
	     * set padding
	     * @name padding
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {Number} padding
	     * @returns {Number}
	     * @example
	     * // get padding
	     * var padding = text.padding();
	     *
	     * // set padding to 10 pixels
	     * text.padding(10);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'align', LEFT);
	
	  /**
	     * get/set horizontal align of text.  Can be 'left', 'center', 'right' or 'justify'
	     * @name align
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {String} align
	     * @returns {String}
	     * @example
	     * // get text align
	     * var align = text.align();
	     *
	     * // center text
	     * text.align('center');
	     *
	     * // align text to right
	     * text.align('right');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'lineHeight', 1);
	
	  /**
	     * get/set line height.  The default is 1.
	     * @name lineHeight
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {Number} lineHeight
	     * @returns {Number}
	     * @example
	     * // get line height
	     * var lineHeight = text.lineHeight();
	     *
	     * // set the line height
	     * text.lineHeight(2);
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'wrap', WORD);
	
	  /**
	     * get/set wrap.  Can be word, char, or none. Default is word.
	     * @name wrap
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {String} wrap
	     * @returns {String}
	     * @example
	     * // get wrap
	     * var wrap = text.wrap();
	     *
	     * // set wrap
	     * text.wrap('word');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'letterSpacing', 0);
	
	  /**
	       * set letter spacing property. Default value is 0.
	       * @name letterSpacing
	       * @method
	       * @memberof Konva.TextPath.prototype
	       * @param {Number} letterSpacing
	       */
	
	  Konva.Factory.addGetter(Konva.Text, 'text', EMPTY_STRING);
	  Konva.Factory.addOverloadedGetterSetter(Konva.Text, 'text');
	
	  /**
	     * get/set text
	     * @name getText
	     * @method
	     * @memberof Konva.Text.prototype
	     * @param {String} text
	     * @returns {String}
	     * @example
	     * // get text
	     * var text = text.text();
	     *
	     * // set text
	     * text.text('Hello world!');
	     */
	
	  Konva.Factory.addGetterSetter(Konva.Text, 'textDecoration', EMPTY_STRING);
	
	  /**
	      * get/set text decoration of a text.  Possible values are 'underline', 'line-through' or combination of these values separated by space
	      * @name textDecoration
	      * @method
	      * @memberof Konva.Text.prototype
	      * @param {String} textDecoration
	      * @returns {String}
	      * @example
	      * // get text decoration
	      * var textDecoration = text.textDecoration();
	      *
	      * // underline text
	      * text.textDecoration('underline');
	      *
	      * // strike text
	      * text.textDecoration('line-through');
	      *
	      * // underline and strike text
	      * text.textDecoration('underline line-through');
	      */
	
	  Konva.Collection.mapMethods(Konva.Text);
	})();


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Core = __webpack_require__(334);
	
	var _Core2 = _interopRequireDefault(_Core);
	
	var _customLodash = __webpack_require__(352);
	
	var _customLodash2 = _interopRequireDefault(_customLodash);
	
	var _eventEmitter = __webpack_require__(520);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PlacingComponent = function () {
	    function PlacingComponent() {
	        var _this = this;
	
	        _classCallCheck(this, PlacingComponent);
	
	        this.events = new _eventEmitter2.default();
	        this.konvaObject = new _Core2.default.Group();
	        var konaFns = ['setVisible', 'setDraggable', 'setOffset', 'setRotation', 'getRotation', 'destroy', 'moveToTop', 'getZIndex', 'setZIndex'];
	        this.addKonvaFunctions(konaFns);
	
	        this.konvaObject.on('mousedown', function (evt) {
	            return _this.onMouseDown(evt);
	        });
	        this.konvaObject.on('dragend', function (evt) {
	            return _this.onDragEnd(evt);
	        });
	    }
	
	    PlacingComponent.prototype.addKonvaFunctions = function addKonvaFunctions(functions) {
	        var _this2 = this;
	
	        functions.forEach(function (fn) {
	            _this2[fn] = _this2.konvaObject[fn].bind(_this2.konvaObject);
	        });
	    };
	
	    PlacingComponent.prototype.addKonvaNode = function addKonvaNode(node) {
	        this.konvaObject.add(node);
	    };
	
	    PlacingComponent.prototype.addKonvaComponent = function addKonvaComponent(component) {
	        this.konvaObject.add(component.konvaObject);
	    };
	
	    PlacingComponent.prototype.drawParentLayer = function drawParentLayer() {
	        this.konvaObject.getLayer().draw();
	    };
	
	    PlacingComponent.prototype.getPos = function getPos() {
	        return this.konvaObject.position();
	    };
	
	    PlacingComponent.prototype.setPos = function setPos(_ref) {
	        var x = _ref.x,
	            y = _ref.y;
	
	        if (!_customLodash2.default.isUndefined(x)) {
	            this.konvaObject.setX(x);
	        }
	        if (!_customLodash2.default.isUndefined(y)) {
	            this.konvaObject.setY(y);
	        }
	    };
	
	    PlacingComponent.prototype.onMouseDown = function onMouseDown(evt) {
	        this.events.emit('mousedown', evt);
	    };
	
	    PlacingComponent.prototype.onDragEnd = function onDragEnd() {
	        this.events.emit('dragend');
	    };
	
	    return PlacingComponent;
	}();
	
	exports.default = PlacingComponent;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Core = __webpack_require__(334);
	
	var _Core2 = _interopRequireDefault(_Core);
	
	__webpack_require__(349);
	
	__webpack_require__(525);
	
	var _placingComponent = __webpack_require__(526);
	
	var _placingComponent2 = _interopRequireDefault(_placingComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var DesignDescription = function (_PlacingComponent) {
	    _inherits(DesignDescription, _PlacingComponent);
	
	    function DesignDescription(placement) {
	        var backgroundColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#eaeaea';
	        var textColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#000';
	
	        _classCallCheck(this, DesignDescription);
	
	        var _this = _possibleConstructorReturn(this, _PlacingComponent.call(this));
	
	        _this.placement = placement;
	        _this.descriptionBg = new _Core2.default.Rect({
	            fill: backgroundColor
	        });
	
	        _this.controlText = new _Core2.default.Text({
	            fill: textColor,
	            padding: 2,
	            alignment: 'center'
	        });
	
	        _this.addKonvaNode(_this.descriptionBg);
	        _this.addKonvaNode(_this.controlText);
	        return _this;
	    }
	
	    DesignDescription.prototype.setText = function setText(text) {
	        this.controlText.setText(text);
	        this.descriptionBg.setWidth(this.controlText.getWidth());
	        this.descriptionBg.setHeight(this.controlText.getHeight());
	    };
	
	    DesignDescription.prototype.getTextWidth = function getTextWidth() {
	        return this.controlText.getWidth();
	    };
	
	    return DesignDescription;
	}(_placingComponent2.default);
	
	exports.default = DesignDescription;

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// Fast image resize/resample using Hermite filter.
	// https://github.com/viliusle/Hermite-resize
	function hermiteResize(canvas, size) {
	    var W = canvas.width;
	    var H = canvas.height;
	    var W2 = Math.round(size.width);
	    var H2 = Math.round(size.height);
	    var img = canvas.getContext('2d').getImageData(0, 0, W, H);
	    var img2 = canvas.getContext('2d').getImageData(0, 0, W2, H2);
	    var data = img.data;
	    var data2 = img2.data;
	    var ratio_w = W / W2;
	    var ratio_h = H / H2;
	    var ratio_w_half = Math.ceil(ratio_w / 2);
	    var ratio_h_half = Math.ceil(ratio_h / 2);
	
	    for (var j = 0; j < H2; j++) {
	        for (var i = 0; i < W2; i++) {
	            var x2 = (i + j * W2) * 4;
	            var weight = 0;
	            var weights = 0;
	            var weights_alpha = 0;
	            var gx_r = 0;
	            var gx_g = 0;
	            var gx_b = 0;
	            var gx_a = 0;
	            var center_y = (j + 0.5) * ratio_h;
	            for (var yy = Math.floor(j * ratio_h); yy < (j + 1) * ratio_h; yy++) {
	                var dy = Math.abs(center_y - (yy + 0.5)) / ratio_h_half;
	                var center_x = (i + 0.5) * ratio_w;
	                var w0 = dy * dy; //pre-calc part of w
	                for (var xx = Math.floor(i * ratio_w); xx < (i + 1) * ratio_w; xx++) {
	                    var dx = Math.abs(center_x - (xx + 0.5)) / ratio_w_half;
	                    var w = Math.sqrt(w0 + dx * dx);
	                    if (w >= -1 && w <= 1) {
	                        //hermite filter
	                        weight = 2 * w * w * w - 3 * w * w + 1;
	                        if (weight > 0) {
	                            dx = 4 * (xx + yy * W);
	                            //alpha
	                            gx_a += weight * data[dx + 3];
	                            weights_alpha += weight;
	                            //colors
	                            if (data[dx + 3] < 255) {
	                                weight = weight * data[dx + 3] / 250;
	                            }
	                            gx_r += weight * data[dx];
	                            gx_g += weight * data[dx + 1];
	                            gx_b += weight * data[dx + 2];
	                            weights += weight;
	                        }
	                    }
	                }
	            }
	            data2[x2] = gx_r / weights;
	            data2[x2 + 1] = gx_g / weights;
	            data2[x2 + 2] = gx_b / weights;
	            data2[x2 + 3] = gx_a / weights_alpha;
	        }
	    }
	
	    canvas.getContext('2d').clearRect(0, 0, Math.max(W, W2), Math.max(H, H2));
	    canvas.width = W2;
	    canvas.height = H2;
	    canvas.getContext('2d').putImageData(img2, 0, 0);
	}
	
	exports.default = hermiteResize;

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';
	  /**
	     * RGBA Filter
	     * @function
	     * @name RGBA
	     * @memberof Konva.Filters
	     * @param {Object} imageData
	     * @author codefo
	     * @example
	     * node.cache();
	     * node.filters([Konva.Filters.RGBA]);
	     * node.blue(120);
	     * node.green(200);
	     * node.alpha(0.3);
	     */
	  Konva.Filters.RGBA = function(imageData) {
	    var data = imageData.data,
	      nPixels = data.length,
	      red = this.red(),
	      green = this.green(),
	      blue = this.blue(),
	      alpha = this.alpha(),
	      i,
	      ia;
	
	    for (i = 0; i < nPixels; i += 4) {
	      ia = 1 - alpha;
	
	      data[i] = red * alpha + data[i] * ia; // r
	      data[i + 1] = green * alpha + data[i + 1] * ia; // g
	      data[i + 2] = blue * alpha + data[i + 2] * ia; // b
	    }
	  };
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'red', 0, function(val) {
	    this._filterUpToDate = false;
	    if (val > 255) {
	      return 255;
	    } else if (val < 0) {
	      return 0;
	    } else {
	      return Math.round(val);
	    }
	  });
	  /**
	    * get/set filter red value. Use with {@link Konva.Filters.RGBA} filter.
	    * @name red
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Integer} red value between 0 and 255
	    * @returns {Integer}
	    */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'green', 0, function(val) {
	    this._filterUpToDate = false;
	    if (val > 255) {
	      return 255;
	    } else if (val < 0) {
	      return 0;
	    } else {
	      return Math.round(val);
	    }
	  });
	  /**
	    * get/set filter green value. Use with {@link Konva.Filters.RGBA} filter.
	    * @name green
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Integer} green value between 0 and 255
	    * @returns {Integer}
	    */
	
	  Konva.Factory.addGetterSetter(
	    Konva.Node,
	    'blue',
	    0,
	    Konva.Validators.RGBComponent,
	    Konva.Factory.afterSetFilter
	  );
	  /**
	    * get/set filter blue value. Use with {@link Konva.Filters.RGBA} filter.
	    * @name blue
	    * @method
	    * @memberof Konva.Node.prototype
	    * @param {Integer} blue value between 0 and 255
	    * @returns {Integer}
	    */
	
	  Konva.Factory.addGetterSetter(Konva.Node, 'alpha', 1, function(val) {
	    this._filterUpToDate = false;
	    if (val > 1) {
	      return 1;
	    } else if (val < 0) {
	      return 0;
	    } else {
	      return val;
	    }
	  });
	  /**
	     * get/set filter alpha value. Use with {@link Konva.Filters.RGBA} filter.
	     * @name alpha
	     * @method
	     * @memberof Konva.Node.prototype
	     * @param {Float} alpha value between 0 and 1
	     * @returns {Float}
	     */
	})();


/***/ }),
/* 530 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// designPlacer.js